/*
 * @Author: WGL
 * @Date: 2023-04-03 15:28:54
 * @LastEditors: WGL 958897276@qq.com
 * @LastEditTime: 2025-12-01 14:08:31
 * @Description:
 */
export default {
  vabI18n: {
    首页: 'Главная',
    看板: 'Доска',
    工作台: 'Рабочий стол',
    个人中心: 'Личный кабинет',
    Excel: 'Excel',
    错误页: 'Страница ошибки',
    403: '403',
    404: '404',
    邮件: 'Почта',
    更多: 'Больше',
    退出登录: 'Выйти',
    登录: 'Войти',
    验证码: 'Код подтверждения',
    注册: 'Регистрация',
    国际化: 'Интернационализация',
    刷新: 'Обновить',
    通知: 'Уведомление',
    全屏: 'Полный экран',
    页面动画: 'Анимация страницы',
    搜索: 'Поиск',
    重置: 'Сброс',
    开启: 'Включить',
    关闭: 'Выключить',
    保存: 'Сохранить',
    欢迎来到: 'Добро пожаловать',
    请输入用户名: 'Введите имя пользователя',
    请输入密码: 'Введите пароль',
    用户名不能为空: 'Имя пользователя не может быть пустым',
    密码不能少于6位: 'Пароль не может быть меньше 6 символов',
    请输入正确的手机号: 'Введите правильный номер телефона',
    请输入手机号: 'Введите номер телефона',
    请输入手机验证码: 'Введите код подтверждения телефона',
    获取验证码: 'Получить код подтверждения',
    // ==================================== 常用基本 ==============================
    大: 'Большой',
    中: 'Средний',
    小: 'Маленький',
    基本信息: 'Основная информация',
    分类名称: 'Название категории',
    请输入分类名称: 'Введите название категории',
    排序: 'Сортировка',
    状态: 'Статус',
    备注: 'Примечание',
    请输入备注: 'Введите примечание',
    序号: 'Номер',
    规格: 'Спецификация',
    '重量/长-宽-高/体积': 'Вес/Длина-Ширина-Высота/Объем',
    价格: 'Цена',
    '价格(元)': 'Цена (юань)',
    销量: 'Объем продаж',
    封面图: 'Обложка',
    图片: 'Изображение',
    图标: 'Иконка',
    编码: 'Код',
    OEM编码: 'OEM код',
    '产品编码/OEM编码': 'Код продукта/OEM код',
    '编码超级搜索，多个编码换行隔开':
      'Супер поиск по кодам, несколько кодов разделяются переводом строки',
    库存: 'Запас',
    调出仓库: 'Склад отправки',
    调入仓库: 'Склад получения',
    '真实库存(锁定库存)': 'Фактический запас (заблокированный запас)',
    采购价: 'Цена закупки',
    毛利率: 'Валовая маржа',
    客户报价: 'Предложение клиента',
    报价状态: 'Статус предложения',
    来源: 'Источник',
    创建时间: 'Время создания',
    更新时间: 'Время обновления',
    使用状态: 'Статус использования',
    总价: 'Общая стоимость',
    操作: 'Операция',
    名称: 'Название',
    加载数据中: 'Загрузка данных...',
    系统: 'Система',
    确定: 'ОК',
    确认: 'Подтвердить',
    取消: 'Отмена',
    取消操作: 'Отменить операцию!',
    '此操作将会永久删除数据，是否继续?':
      'Эта операция навсегда удалит данные, продолжить?',
    '确定要复制当前数据?': 'Подтвердить копирование текущих данных?',
    请配置打印接口: 'Пожалуйста, настройте интерфейс печати!',
    暂无数据可导出: 'Нет данных для экспорта!',
    正在生成中: 'Генерация...',
    请配置导出接口: 'Пожалуйста, настройте интерфейс экспорта!',
    '当前页面可能存在未保存内容，直接离开内容将不被保存':
      'На текущей странице могут быть несохраненные данные, при прямом выходе данные не будут сохранены',
    请配置上传的路径地址: 'Пожалуйста, настройте путь загрузки!',
    编辑: 'Редактировать',
    删除: 'Удалить',
    新建: 'Создать',
    提示: 'Подсказка',
    '请配置导出接口！': 'Пожалуйста, настройте интерфейс экспорта!',
    '暂无数据可导出！': 'Нет данных для экспорта!',
    正在下载中: 'Загрузка...',
    文件: 'Файл',
    '请配置文件上传接口！': 'Пожалуйста, настройте интерфейс загрузки файлов!',
    '请配置编辑接口！': 'Пожалуйста, настройте интерфейс редактирования!',
    '导出数据过多，已添加至异步导出队列生成':
      'Слишком много данных для экспорта, добавлено в очередь асинхронного экспорта',
    请配置文件上传接口: 'Пожалуйста, настройте интерфейс загрузки файлов!',
    请配置编辑接口: 'Пожалуйста, настройте интерфейс редактирования!',
    请配置详情接口: 'Пожалуйста, настройте интерфейс деталей!',
    头像裁剪: 'Обрезка аватара',
    选择图片: 'Выбрать изображение',
    上传并保存: 'Загрузить и сохранить',
    返回: 'Назад',
    产品详情: 'Детали продукта',
    总计: 'Итого',
    查询: 'Поиск',
    单位: 'Единица',
    附件: 'Вложение',
    仓库: 'Склад',
    手机号: 'Номер телефона',
    角色: 'Роль',
    权限: 'Права',
    是否负责人: 'Ответственное лицо',
    固定号码: 'Фиксированный номер',
    上传文件: 'Загрузить файл',
    '附件名称(点击预览)': 'Название вложения (клик для предпросмотра)',
    附件类型: 'Тип вложения',
    附件大小: 'Размер вложения',
    上传人: 'Загрузчик',
    上传图片大小不能超过: 'Размер загружаемого изображения не может превышать',
    最多上传: 'Максимум загрузок',
    您选择了: 'Вы выбрали',
    '个文件,请重新选择': 'файлов, пожалуйста, выберите снова',
    你确定要删除: 'Вы уверены, что хотите удалить',
    上传时间: 'Время загрузки',
    明细: 'Детали',
    文件名称: 'Название файла',
    请输入分类排序: 'Введите сортировку категории',
    展开: 'Развернуть',
    合并: 'Объединить',
    紧急程度: 'Срочность',
    添加: 'Добавить',
    请选择: 'Пожалуйста, выберите',
    供应商: 'Поставщик',
    最近报价: 'Последнее предложение',
    品牌: 'Бренд',
    车型: 'Модель автомобиля',
    请选择车型: 'Пожалуйста, выберите модель автомобиля',
    部件: 'Компонент',
    请选择部件: 'Пожалуйста, выберите компонент',
    年份: 'Год',
    请选择年份: 'Пожалуйста, выберите год',
    发表评论: 'Оставить комментарий',
    修改: 'Изменить',
    '暂无评论~': 'Нет комментариев~',
    评论人员: 'Комментатор',
    '暂无信息~': 'Нет информации~',
    姓名: 'Имя',
    电话: 'Телефон',
    请输入电话: 'Введите телефон',
    邮箱: 'Электронная почта',
    部门: 'Отдел',
    职务: 'Должность',
    图表显示: 'Отображение графика',
    指标值: 'Значение показателя',
    日: 'День',
    月: 'Месяц',
    年: 'Год',
    已选择: 'Выбрано',
    请输入关键词: 'Введите ключевые слова',
    使用选择: 'Использовать выбор',
    暂无内容: 'Нет содержимого',
    选择成功: 'Выбор успешен',
    跟进: 'Следить',
    已添加: 'Добавлено',
    库存不足: 'Недостаточный запас',
    是: 'Да',
    否: 'Нет',
    请填写: 'Пожалуйста, заполните',
    币种: 'Валюта',
    创建人: 'Создатель',
    最近更新: 'Последнее обновление',
    从素材库选择: 'Выбрать из библиотеки материалов',
    // TODO: 2023-11-14 start
    从素材库选: 'Выбрать из библиотеки материалов',
    在此处粘贴图片即上传: 'Вставьте изображение здесь для загрузки',
    '上传图片只能是JPG,PNG,GIF,WEBP格式':
      'Загружаемые изображения могут быть только в форматах JPG,PNG,GIF,WEBP',
    只能上传一张图片: 'Можно загрузить только одно изображение',
    当前浏览器不支持本地图片粘贴:
      'Текущий браузер не поддерживает вставку локальных изображений',
    粘贴内容非图片: 'Вставленное содержимое не является изображением',
    上传文件大小不能超过: 'Размер загружаемого файла не может превышать',
    正在上传中: 'Загрузка...',
    上传: 'Загрузить',
    上传完成: 'Загрузка завершена',
    上传失败请重新上传: 'Загрузка не удалась, пожалуйста, загрузите снова',
    正在导入中: 'Импорт...',
    导入: 'Импорт',
    导出: 'Экспорт',
    全选: 'Выбрать все',
    使用选中: 'Использовать выбранное',
    一键抠图: 'Автоматическая вырезка',
    抠图: 'Вырезать',
    不抠图: 'Не вырезать',
    完成: 'Завершить',
    下载: 'Скачать',
    查看: 'Просмотр',
    暂无数据: 'Нет данных',
    上级分类: 'Родительская категория',
    添加分类: 'Добавить категорию',
    编辑分类: 'Редактировать категорию',
    删除分类: 'Удалить категорию',
    分类名称不能为空: 'Название категории не может быть пустым',
    音频: 'Аудио',
    只能选择一张图片: 'Можно выбрать только одно изображение',
    请配置分类接口: 'Пожалуйста, настройте интерфейс категорий!',
    全部: 'Все',
    请配置素材接口: 'Пожалуйста, настройте интерфейс материалов!',
    请添加分类: 'Пожалуйста, добавьте категорию',
    请配置分类添加接口: 'Пожалуйста, настройте интерфейс добавления категорий',
    请配置分类编辑接口:
      'Пожалуйста, настройте интерфейс редактирования категорий',
    请配置分类删除接口: 'Пожалуйста, настройте интерфейс удаления категорий',
    文件类型格式不正确: 'Неправильный формат типа файла!',
    大小不能超过: 'Размер не может превышать',
    个文件请重新选择: 'файлов, пожалуйста, выберите снова',
    请配置素材分类导出接口:
      'Пожалуйста, настройте интерфейс экспорта категорий материалов!',
    立即新增: 'Добавить немедленно',
    上传视频大小不能超过: 'Размер загружаемого видео не может превышать',
    图标选择器: 'Выбор иконок',
    最后编辑: 'Последнее редактирование',
    步骤: 'Шаг',
    标题: 'Заголовок',
    审核: 'Проверка',
    审核状态: 'Статус проверки',
    请选择类型: 'Пожалуйста, выберите тип',
    请选择审核状态: 'Пожалуйста, выберите статус проверки',
    通过: 'Пройдено',
    不通过: 'Не пройдено',
    付款状态: 'Статус оплаты',
    请选择付款状态: 'Пожалуйста, выберите статус оплаты',
    发货状态: 'Статус отправки',
    请选择发货状态: 'Пожалуйста, выберите статус отправки',
    提成金额: 'Сумма комиссии',
    请输入提成金额: 'Пожалуйста, введите сумму комиссии',
    回款方式: 'Способ возврата платежа',
    请选择回款方式: 'Пожалуйста, выберите способ возврата платежа',
    回款日期: 'Дата возврата платежа',
    请输入回款日期: 'Пожалуйста, введите дату возврата платежа',
    流水单号: 'Номер платежного документа',
    请输入支付流水单号: 'Пожалуйста, введите номер платежного документа',
    支付凭证: 'Платежный документ',
    付款方式: 'Способ оплаты',
    请选择付款方式: 'Пожалуйста, выберите способ оплаты',
    付款日期: 'Дата оплаты',
    请输入付款日期: 'Пожалуйста, введите дату оплаты',
    下单日期: 'Дата заказа',
    请选择下单日期: 'Пожалуйста, выберите дату заказа',
    请输入名称: 'Пожалуйста, введите название',
    保存并新增: 'Сохранить и добавить',
    您确定要对当前数据进行提审:
      'Вы уверены, что хотите отправить текущие данные на проверку?',
    您确定要对当前数据进行提审并通过:
      'Вы уверены, что хотите отправить текущие данные на проверку и пройти проверку?',
    '您确定要对当前状态进行撤销？撤销后可重新编辑提审':
      'Вы уверены, что хотите отменить текущий статус? После отмены можно будет повторно редактировать и отправить на проверку',
    您确定要对当前订单进行续单:
      'Вы уверены, что хотите продлить текущий заказ?',
    您确定要对当前订单生成出库单:
      'Вы уверены, что хотите сгенерировать накладную на отправку для текущего заказа?',
    // ==================================== 邮箱模块 ==============================
    下次联系时间: 'Время следующего контакта',
    跟进内容: 'Содержание отслеживания',
    上传附件: 'Загрузить вложение',
    '是否删除这条跟进记录?': 'Удалить эту запись отслеживания?',
    确定进入: 'Подтвердить вход',
    阶段: 'Этап',
    // ==================================== f成员管理模块 ==============================
    成员管理: 'Управление участниками',
    成员: 'Участник',
    请选择成员: 'Пожалуйста, выберите участника',
    只读: 'Только чтение',
    读写: 'Чтение и запись',
    负责人: 'Ответственное лицо',
    更换负责人: 'Сменить ответственного',
    设置为负责人: 'Назначить ответственным',
    请选择负责人: 'Пожалуйста, выберите ответственного',
    // ==================================== 产品模块 ==============================
    产品: 'Продукт',
    数量: 'Количество',
    产品名称: 'Название продукта',
    请输入产品名称: 'Пожалуйста, введите название продукта',
    产品分类: 'Категория продукта',
    请选择产品分类: 'Пожалуйста, выберите категорию продукта',
    产品类型: 'Тип продукта',
    请选择产品类型: 'Пожалуйста, выберите тип продукта',
    请输入排序: 'Пожалуйста, введите порядок сортировки',
    产品编码: 'Код продукта',
    请输入产品编码: 'Пожалуйста, введите код продукта',
    请输入OEM编码: 'Пожалуйста, введите OEM код',
    适用车型: 'Подходящая модель автомобиля',
    请选择适用车型: 'Пожалуйста, выберите подходящую модель автомобиля',
    车身部件: 'Кузовные детали',
    请选择车身部件: 'Пожалуйста, выберите кузовные детали',
    产品货币: 'Валюта продукта',
    请选择产品货币单位: 'Пожалуйста, выберите валюту продукта',
    预警库存: 'Предупреждающий запас',
    '建议售价/最低售价/成本':
      'Рекомендуемая цена/Минимальная цена/Себестоимость',
    外贸: 'Внешняя торговля',
    零售: 'Розничная торговля',
    成本: 'Себестоимость',
    '名称/编码/OEM编码': 'Название/Код/OEM код',
    '重量/体积/长-宽-高': 'Вес/Объем/Длина-Ширина-Высота',
    上下架: 'Выставление на продажу',
    上架: 'Выставить',
    下架: 'Снять с продажи',
    请选择单位: 'Пожалуйста, выберите единицу измерения',
    建议售价: 'Рекомендуемая цена',
    最低售价: 'Минимальная цена продажи',
    成本价: 'Себестоимость',
    装箱量: 'Количество в упаковке',
    箱规: 'Размер упаковки',
    '箱规-长(cm)': 'Размер упаковки - длина (см)',
    '箱规-宽(cm)': 'Размер упаковки - ширина (см)',
    '箱规-高(cm)': 'Размер упаковки - высота (см)',
    '箱规-装箱量': 'Размер упаковки - количество в упаковке',
    '箱规-净重(kg)': 'Размер упаковки - вес нетто (кг)',
    '箱规-毛重(kg)': 'Размер упаковки - вес брутто (кг)',
    '箱规-体积(m³)': 'Размер упаковки - объем (м³)',
    '重量(kg)': 'Вес (кг)',
    '单个-长(cm)': 'Один - длина (см)',
    '单个-宽(cm)': 'Один - ширина (см)',
    '单个-高(cm)': 'Один - высота (см)',
    '单个-体积(m³)': 'Один - объем (м³)',
    '单个-净重(kg)': 'Один - вес нетто (кг)',
    '单个-毛重(kg)': 'Один - вес брутто (кг)',
    证书: 'Сертификат',
    建议尺寸比例: 'Рекомендуемое соотношение размеров 1*1',
    重量: 'Вес',
    体积: 'Объем',
    分类: 'Категория',
    '体积(m³)': 'Объем (м³)',
    描述: 'Описание',
    请输入描述: 'Пожалуйста, введите описание',
    图集: 'Альбом изображений',
    实施服务: 'Услуги реализации',
    请选择实施服务: 'Пожалуйста, выберите услуги реализации',
    扩展信息: 'Дополнительная информация',
    请选择供应商: 'Пожалуйста, выберите поставщика',
    图片信息: 'Информация об изображении',
    请选择仓库: 'Пожалуйста, выберите склад',
    请选择产品: 'Пожалуйста, выберите продукт',
    入库: 'Поступление на склад',
    产品图片: 'Изображение продукта',
    我方编码: 'Наш код',
    对方编码: 'Код контрагента',
    历史最低: 'Исторический минимум',
    近期价格: 'Недавняя цена',
    历史最高: 'Исторический максимум',
    联系人: 'Контактное лицо',
    详细地址: 'Подробный адрес',
    请选择车型品牌: 'Пожалуйста, выберите марку автомобиля',
    请选择配置: 'Пожалуйста, выберите конфигурацию',
    货源: 'Источник поставки',
    产品概览: 'Обзор продукта',
    配套产品: 'Сопутствующие товары',
    配套产品详情: 'Детали сопутствующих товаров',
    平替产品: 'Аналогичные товары',
    价格策略: 'Ценовая стратегия',
    策略条件: 'Условия стратегии',
    数量大于等于: 'Количество больше или равно',
    单价为: 'Цена за единицу',
    类型: 'Тип',
    策略方式: 'Способ стратегии',
    策略类型: 'Тип стратегии',
    请选择策略类型: 'Пожалуйста, выберите тип стратегии',
    库存提示:
      'Текущий объем запасов (общий запас/заблокированный запас/предупреждающий запас)',
    包含产品: 'Содержит продукты',
    配置: 'Конфигурация',
    导出原图: 'Экспорт оригинального изображения',
    视频信息: 'Видеоинформация',
    视频: 'Видео',
    目标市场: 'Целевой рынок',
    请选择目标市场: 'Пожалуйста, выберите целевой рынок',
    产品货源: 'Источник поставки продукта',
    请选择产品货源: 'Пожалуйста, выберите источник поставки продукта',
    上下架状态: 'Статус выставления на продажу',
    请选择产品上下架状态:
      'Пожалуйста, выберите статус выставления продукта на продажу',
    index: {},
    // ==================================== 产品分类模块 ==============================
    需要以字母开头: 'Должно начинаться с буквы',
    显示名称: 'Отображаемое имя',
    请输入显示名称: 'Пожалуйста, введите отображаемое имя',
    用于生成电商网站时显示的分类标题:
      'Заголовок категории при генерации интернет-магазина',
    分类url: 'URL категории',
    请输入字母或数字: 'Пожалуйста, введите буквы или цифры',
    '请输入分类url,如lights':
      'Пожалуйста, введите URL категории, например lights',
    用于生成电商网站的链接: 'Ссылка для генерации интернет-магазина',
    分类描述: 'Описание категории',
    用于生成电商网站时SEO: 'SEO при генерации интернет-магазина',
    分类关键词: 'Ключевые слова категории',
    请输入分类: 'Пожалуйста, введите категорию',
    // ==================================== 销售模块 ==============================
    内容: 'Содержание',
    跟进人: 'Ответственный за follow-up',
    跟进时间: 'Время follow-up',
    添加成员: 'Добавить участника',
    删除成员: 'Удалить участника',
    '请选择成员(可多选)': 'Пожалуйста, выберите участников (можно несколько)',
    客户: 'Клиент',
    客户名称: 'Имя клиента',
    请输入客户名称: 'Пожалуйста, введите имя клиента',
    客户编码: 'Код клиента',
    成交单数: 'Количество заключенных сделок',
    成交金额: 'Сумма сделок',
    回款金额: 'Сумма поступлений',
    客户来源: 'Источник клиента',
    请选择客户来源: 'Пожалуйста, выберите источник клиента',
    客户行业: 'Отрасль клиента',
    请选择客户行业: 'Пожалуйста, выберите отрасль клиента',
    客户等级: 'Уровень клиента',
    请选择客户等级: 'Пожалуйста, выберите уровень клиента',
    下次跟进时间: 'Время следующего follow-up',
    地区: 'Регион',
    请选择地区: 'Пожалуйста, выберите регион',
    请输入客户手机号: 'Пожалуйста, введите номер телефона клиента',
    请输入邮箱地址: 'Пожалуйста, введите адрес электронной почты',
    地址: 'Адрес',
    请输入客户地址: 'Пожалуйста, введите адрес клиента',
    是否成交: 'Сделка состоялась',
    请选择是否成交: 'Пожалуйста, выберите, состоялась ли сделка',
    客户详情: 'Детали клиента',
    最后跟进时间: 'Последнее время follow-up',
    微信: 'WeChat',
    请输入微信: 'Пожалуйста, введите WeChat',
    商机: 'Возможность',
    范围: 'Диапазон',
    请选择数据范围: 'Пожалуйста, выберите диапазон данных',
    客户地区: 'Регион клиента',
    团队成员: 'Члены команды',
    发票信息: 'Информация о счете',
    客户分析: 'Анализ клиентов',
    客户订单分析: 'Анализ заказов клиентов',
    请选择开始日期: 'Пожалуйста, выберите дату начала',
    开始日期: 'Дата начала',
    结束日期: 'Дата окончания',
    退货产品: 'Возврат товара',
    结束时间: 'Время окончания',
    开始时间: 'Время начала',
    核心数据: 'Основные данные',
    成交趋势: 'Тенденция сделок',
    产品分布: 'Распределение продуктов',
    产品排行: 'Рейтинг продуктов',
    销售前20产品: 'Топ-20 продаваемых продуктов',
    历史订单: 'История заказов',
    订单金额: 'Сумма заказа',
    订单总金额: 'Общая сумма заказов',
    订单笔数: 'Количество заказов',
    下单数量: 'Количество заказанных единиц',
    实收金额: 'Фактически полученная сумма',
    '当前订单收款总和，扣除退款':
      'Общая сумма поступлений по текущему заказу, за вычетом возвратов',
    退款金额: 'Сумма возврата',
    当前订单退款金额: 'Сумма возврата по текущему заказу',
    未收回款: 'Неполученные платежи',
    '订单金额-已收金额': 'Сумма заказа - Полученная сумма',
    已开票金额: 'Сумма выставленных счетов',
    订单已开票的金额: 'Сумма счетов по заказу',
    平均单价: 'Средняя цена за единицу',
    每笔订单平均单价: 'Средняя цена за единицу по каждому заказу',
    排名: 'Рейтинг',
    渠道来源: 'Источник канала',
    金额占比: 'Доля суммы',
    订单占比: 'Доля заказов',
    公司名称: 'Название компании',
    请输入公司名称: 'Пожалуйста, введите название компании',
    税号: 'Налоговый номер',
    请输入公司税号: 'Пожалуйста, введите налоговый номер компании',
    开户行: 'Банк',
    银行账号: 'Номер банковского счета',
    账户信息: 'Информация о счете',
    发票抬头: 'Получатель счета',
    关联客户: 'Связанный клиент',
    请选择客户: 'Пожалуйста, выберите клиента',
    货币币种: 'Валюта',
    开户银行: 'Банк',
    请输入开户银行全称: 'Пожалуйста, введите полное название банка',
    银行卡号: 'Номер банковской карты',
    请输入银行卡号: 'Пожалуйста, введите номер банковской карты',
    请输入地址: 'Пожалуйста, введите адрес',
    退货商品为空表示只退款:
      'Если товар для возврата пуст, это означает только возврат денег',
    请输入退货数量: 'Пожалуйста, введите количество возврата',
    产品明细: 'Детали продукта',
    请至少添加一个产品: 'Пожалуйста, добавьте хотя бы один продукт',
    // TODO: 2023-11-14 start
    商机名称: 'Название возможности',
    请输入商机名称: 'Пожалуйста, введите название возможности',
    商机阶段: 'Этап возможности',
    请选择商机阶段: 'Пожалуйста, выберите этап возможности',
    商机属性: 'Свойства возможности',
    请选择商机属性: 'Пожалуйста, выберите свойства возможности',
    商机状态: 'Статус возможности',
    请选择商机状态: 'Пожалуйста, выберите статус возможности',
    预计金额: 'Ожидаемая сумма',
    请输入预计成交金额: 'Пожалуйста, введите ожидаемую сумму сделки',
    请选择货币: 'Пожалуйста, выберите валюту',
    预计成交: 'Ожидаемая сделка',
    请输入预计成交日期: 'Пожалуйста, введите ожидаемую дату сделки',
    结束: 'Завершить',
    商机详情: 'Детали возможности',
    预计成交金额: 'Ожидаемая сумма сделки',
    预计成交时间: 'Ожидаемое время сделки',
    // ==================================== 报价单模块 ==============================
    报价单: 'Коммерческое предложение',
    请选择报价单: 'Пожалуйста, выберите коммерческое предложение',
    报价详情: 'Детали предложения',
    单号: 'Номер',
    复用价格: 'Повторное использование цены',
    时间: 'Время',
    我的报价: 'Мое предложение',
    '标题/编号': 'Заголовок/Номер',
    订单Id: 'ID заказа',
    客户名: 'Имя клиента',
    单价: 'Цена за единицу',
    请选择出入库类型: 'Пожалуйста, выберите тип прихода/расхода',
    所有客户: 'Все клиенты',
    当前客户: 'Текущий клиент',
    时间范围: 'Временной диапазон',
    价格范围: 'Ценовой диапазон',
    请选择状态: 'Пожалуйста, выберите статус',
    关联商机: 'Связанная возможность',
    请选择商机: 'Пожалуйста, выберите возможность',
    请选择币种: 'Пожалуйста, выберите валюту',
    生成订单: 'Создать заказ',
    交付日期: 'Дата доставки',
    '订单交付/发货日期': 'Дата доставки/отгрузки заказа',
    请选择交付日期: 'Пожалуйста, выберите дату доставки',
    报价单名称: 'Название коммерческого предложения',
    报价单编码: 'Код коммерческого предложения',
    产品数量: 'Количество продуктов',
    订单货币: 'Валюта заказа',
    编号: 'Номер',
    金额: 'Сумма',
    销售金额: 'Сумма продажи',
    销售订单: 'Заказ на продажу',
    订单数量: 'Количество заказов',
    产品列表: 'Список продуктов',
    订单详情: 'Детали заказа',
    发货计划: 'План отгрузки',
    回款计划: 'План поступлений',
    回款明细: 'Детали поступлений',
    出入库记录: 'Записи прихода/расхода',
    服务明细: 'Детали услуги',
    绩效明细: 'Детали производительности',
    开票计划: 'План выставления счетов',
    '退/换货': 'Возврат/обмен',
    合同: 'Контракт',
    应收款: 'Дебиторская задолженность',
    未收款: 'Неполученные платежи',
    已收金额: 'Полученная сумма',
    '当前订单收款总和，不扣除退款':
      'Общая сумма поступлений по текущему заказу, без вычета возвратов',
    已退金额: 'Возвращенная сумма',
    实收回款: 'Фактически полученные платежи',
    退款中金额: 'Сумма в процессе возврата',
    订单退款审批中金额: 'Сумма возврата по заказу на рассмотрении',
    '金额(应收/实收)': 'Сумма (должны получить/фактически получили)',
    下单时间: 'Время заказа',
    发货时间: 'Время отгрузки',
    请选择发货时间: 'Пожалуйста, выберите время отгрузки',
    订单: 'Заказ',
    签单类型: 'Тип подписания',
    生成任务时的开始日期: 'Дата начала при создании задачи',
    单据日期: 'Дата документа',
    订单成交时日期: 'Дата заключения заказа',
    '订单退/换货': 'Возврат/обмен по заказу',
    请输入退款金额: 'Пожалуйста, введите сумму возврата',
    退款金额为0表示只退货: 'Сумма возврата 0 означает только возврат товара',
    退款方式: 'Способ возврата',
    请选择退款方式: 'Пожалуйста, выберите способ возврата',
    退款日期: 'Дата возврата',
    请选择退款日期: 'Пожалуйста, выберите дату возврата',
    补差金额: 'Сумма компенсации',
    请输入补差金额: 'Пожалуйста, введите сумму компенсации',
    补差金额为0表示只换货: 'Сумма компенсации 0 означает только обмен товара',
    补差方式: 'Способ компенсации',
    请选择补差方式: 'Пожалуйста, выберите способ компенсации',
    补差日期: 'Дата компенсации',
    请选择补差计划日期: 'Пожалуйста, выберите плановую дату компенсации',
    换货商品为空表示只补差金额:
      'Если товар для обмена пуст, это означает только компенсацию денег',
    '退/换货备注': 'Примечание к возврату/обмену',
    请输入退货备注: 'Пожалуйста, введите примечание к возврату',
    订单名称: 'Название заказа',
    订单编码: 'Код заказа',
    发货日期: 'Дата отгрузки',
    包装要求: 'Требования к упаковке',
    规格说明: 'Описание спецификации',
    价格条款: 'Ценовые условия',
    订单进度: 'Прогресс заказа',
    // ==================================== 仓库模块 ==============================
    备货中: 'Подготовка к отгрузке',
    备货完成: 'Подготовка завершена',
    业务员: 'Менеджер',
    计划时间: 'Плановое время',
    备货状态: 'Статус подготовки',
    发货计划详情: 'Детали плана отгрузки',
    发货进度: 'Прогресс отгрузки',
    计划日期: 'Плановая дата',
    采购计划: 'План закупок',
    箱单: 'Упаковочный лист',
    发货单: 'Накладная',
    请选择销售订单: 'Пожалуйста, выберите заказ на продажу',
    交货日期: 'Дата поставки',
    采购状态: 'Статус закупки',
    请选择采购状态: 'Пожалуйста, выберите статус закупки',
    添加采购计划: 'Добавить план закупок',
    请输入采购数量: 'Пожалуйста, введите количество для закупки',
    添加到采购单: 'Добавить в заказ на закупку',
    换货产品: 'Продукт для обмена',
    换货商品为空表示只补差额:
      'Если товар для обмена пуст, это означает только компенсацию разницы',
    出入库: 'Приход/Расход',
    出库: 'Расход',
    日期: 'Дата',
    入库类型: 'Тип прихода',
    出库类型: 'Тип расхода',
    出入库类型: 'Тип прихода/расхода',
    供应商名称: 'Название поставщика',
    '供应商/客户': 'Поставщик/Клиент',
    盘点状态: 'Статус инвентаризации',
    '未作废数据删除，库存将不会恢复是否删除':
      'Если удалить неаннулированные данные, запасы не будут восстановлены. Удалить?',
    '此操作将会永久删除数据，是否继续':
      'Эта операция навсегда удалит данные, продолжить?',
    您确定要作废当前数据: 'Вы уверены, что хотите аннулировать текущие данные?',
    // TODO: 2023-11-15 start
    '金额(应付/实付)': 'Сумма (к оплате/фактически оплачено)',
    实付金额: 'Фактически оплаченная сумма',
    '当前订单付款总和，扣除退款':
      'Общая сумма платежей по текущему заказу, за вычетом возвратов',
    未付金额: 'Неоплаченная сумма',
    采购: 'Закупка',
    采购单详情: 'Детали заказа на закупку',
    采购进度: 'Прогресс закупки',
    付款计划: 'План платежей',
    付款明细: 'Детали платежа',
    采购数量: 'Количество закупки',
    // ==================================== 供应商模块 ==============================
    供应商详情: 'Детали поставщика',
    '确认删除？': 'Подтвердить удаление?',
    消息: 'Сообщение',
    暂无评论: 'Нет комментариев',
    暂无信息: 'Нет информации',
    素材选择: 'Выбор материалов',
    '文件已存在下载队列中！': 'Файл уже в очереди загрузки!',
    新增故事: 'Добавить историю',
    请输入内容: 'Пожалуйста, введите содержание',
    只能选择一张: 'Можно выбрать только одну',
    请选择邮件模板: 'Пожалуйста, выберите шаблон письма',
    '正在生成中...': 'Генерация...',
    '该附件格式不支持预览，请下载后查看':
      'Предварительный просмотр этого формата вложений не поддерживается, пожалуйста, скачайте для просмотра',
    设备: 'Оборудование',
    总数: 'Общее количество',
    在线: 'Онлайн',
    离线: 'Оффлайн',
    故障: 'Неисправность',
    在线率: 'Процент онлайн',
    故障率: 'Процент неисправностей',
    '确认要离开本页面吗？': 'Подтвердить выход со страницы?',
    历史报价: 'История предложений',
    '产品名称/编码': 'Название продукта/код',
    '智慧商贸-ERP': 'Интеллектуальная торговля-ERP',
    '正在加载中...': 'Загрузка...',
    简体中文: 'Упрощенный китайский',
    繁體中文: 'Традиционный китайский',
    已创建: 'Создано',
    进行中: 'В процессе',
    已完成: 'Завершено',
    折线图: 'Линейный график',
    柱状图: 'Гистограмма',
    周: 'Неделя',
    已作废: 'Аннулировано',
    已过期: 'Истек срок',
    编辑中: 'В редактировании',
    待支付: 'Ожидает оплаты',
    已付定金: 'Задаток оплачен',
    已支付: 'Оплачено',
    已发货: 'Отгружено',
    已签收: 'Получено',
    '报价单-出口': 'Коммерческое предложение-Экспорт',
    '报价单-内销': 'Коммерческое предложение-Внутренние продажи',
    '报价单-门市': 'Коммерческое предложение-Розничные продажи',
    '报价单-淘宝': 'Коммерческое предложение-Taobao',
    '报价单-云工厂': 'Коммерческое предложение-Облачная фабрика',
    '报价单-智能工厂': 'Коммерческое предложение-Умная фабрика',
    禁用: 'Отключить',
    启用: 'Включить',
    隐藏: 'Скрыть',
    显示: 'Показать',
    未知: 'Неизвестно',
    抖音: 'Доуинь',
    快手: 'Куайшоу',
    待确定: 'Ожидает подтверждения',
    有效: 'Действующий',
    无效: 'Недействующий',
    推广微信公众号: 'Продвижение WeChat Official Account',
    推广抖音账号: 'Продвижение аккаунта Доуинь',
    推广抖音视频: 'Продвижение видео Доуинь',
    推广快手账号: 'Продвижение аккаунта Куайшоу',
    推广快手视频: 'Продвижение видео Куайшоу',
    销售收入: 'Выручка от продаж',
    押金收入: 'Доход от депозитов',
    租赁收入: 'Доход от аренды',
    购买支出: 'Расходы на покупку',
    押金退还: 'Возврат депозита',
    男: 'Мужской',
    女: 'Женский',
    保密: 'Конфиденциально',
    待处理: 'Ожидает обработки',
    处理中: 'В обработке',
    已处理: 'Обработано',
    文本框: 'Текстовое поле',
    多行文本框: 'Многострочное текстовое поле',
    数字文本框: 'Числовое текстовое поле',
    日期选择框: 'Поле выбора даты',
    状态选择: 'Выбор статуса',
    单选框: 'Радиокнопка',
    多选框: 'Флажок',
    下拉单选择: 'Выпадающий список одиночного выбора',
    下拉多选择: 'Выпадающий список множественного выбора',
    单图片: 'Одно изображение',
    多图片: 'Несколько изображений',
    日期选择: 'Выбор даты',
    未读: 'Непрочитано',
    已读: 'Прочитано',
    待审核: 'Ожидает проверки',
    私有: 'Частный',
    公海: 'Общая база',
    无: 'Нет',
    低: 'Низкий',
    高: 'Высокий',
    离职: 'Уволен',
    在职: 'Работает',
    销售: 'Продажи',
    按数量区间设置: 'Установка по диапазону количества',
    '按客户/供应商设置': 'Установка по клиенту/поставщику',
    待接受: 'Ожидает принятия',
    已接受: 'Принято',
    不接受: 'Не принимается',
    公司: 'Компания',
    银行账户: 'Банковский счет',
    单位地址: 'Адрес организации',
    '千美元)': 'Тысяч долларов)',
    宽松默认: 'Свободный по умолчанию',
    严格模式: 'Строгий режим',
    '支持jpg、jpeg、png格式，单次可最多选择':
      'Поддерживает форматы jpg, jpeg, png, можно выбрать максимум за один раз',
    '张图片，每张不可大于': 'изображений, каждое не более',
    如果大于: 'Если больше',
    会自动为您过滤: 'будет автоматически отфильтровано',
    查看大图: 'Просмотреть большое изображение',
    '正在上传中...': 'Загрузка...',
    当前上传成功数: 'Текущее количество успешных загрузок',
    张: 'шт.',
    当前上传失败数: 'Текущее количество неудачных загрузок',
    开始上传: 'Начать загрузку',
    '上传完成!': 'Загрузка завершена!',
    共上传: 'Всего загружено',
    张图片: 'изображений',
    '上传失败,文件大小为': 'Загрузка не удалась, размер файла',
    当前限制选择: 'Текущее ограничение выбора',
    '个文件，本次选择了': 'файлов, в этот раз выбрано',
    个文件: 'файлов',
    密码不能少于: 'Пароль не может быть меньше',
    位: 'символов',
    销售前: 'Перед продажей',
    更新日志: 'Журнал обновлений',
    用户管理: 'Управление пользователями',
    角色管理: 'Управление ролями',
    部门管理: 'Управление отделами',
    菜单管理: 'Управление меню',
    系统日志: 'Системный журнал',
    组件: 'Компонент',
    其他: 'Другое',
    角色权限: 'Права роли',
    外链: 'Внешняя ссылка',
    常规图标: 'Обычные иконки',
    小清新图标: 'Свежие иконки',
    综合表格: 'Комплексная таблица',
    行内编辑表格: 'Таблица с редактированием в строке',
    自定义表格: 'Пользовательская таблица',
    表单: 'Форма',
    综合表单: 'Комплексная форма',
    分步表单: 'Пошаговая форма',
    按钮: 'Кнопка',
    文字链接: 'Текстовая ссылка',
    输入框: 'Поле ввода',
    计数器: 'Счетчик',
    选择器: 'Селектор',
    开关: 'Переключатель',
    滑块: 'Слайдер',
    时间选择器: 'Выбор времени',
    日期选择器: 'Выбор даты',
    日期时间选择器: 'Выбор даты и времени',
    评分: 'Оценка',
    工作流: 'Рабочий процесс',
    图表: 'Диаграмма',
    打印: 'Печать',
    手机预览: 'Предварительный просмотр на мобильном',
    时间线: 'Хронология',
    数字自增长: 'Автоматическое увеличение чисел',
    多标签: 'Множественные вкладки',
    动态Meta: 'Динамический Meta',
    动态路径参数: 'Динамические параметры пути',
    列表: 'Список',
    多级路由缓存: 'Кэширование многоуровневой маршрутизации',
    多级路由: 'Многоуровневая маршрутизация',
    拖拽: 'Перетаскивание',
    卡片拖拽: 'Перетаскивание карточек',
    加载: 'Загрузка',
    视频播放器: 'Видеоплеер',
    编辑器: 'Редактор',
    富文本编辑器: 'Редактор форматированного текста',
    错误日志模拟: 'Симуляция журнала ошибок',
    导出Excel: 'Экспорт в Excel',
    导出选中行Excel: 'Экспорт выбранных строк в Excel',
    导出合并Excel: 'Экспорт объединенного Excel',
    动画: 'Анимация',
    第三方登录: 'Вход через сторонние сервисы',
    物料源: 'Источник материалов',
    物料市场: 'Рынок материалов',
    清空消息: 'Очистить сообщения',
    关闭其他: 'Закрыть другие',
    关闭左侧: 'Закрыть левые',
    关闭右侧: 'Закрыть правые',
    关闭全部: 'Закрыть все',
    主题配置: 'Конфигурация темы',
    常用设置: 'Часто используемые настройки',
    其它设置: 'Другие настройки',
    分栏布局时生效: 'Вступает в силу при колоночной верстке',
    标签开启时生效: 'Вступает в силу при включении вкладок',
    '布局配置仅在电脑视窗下生效，手机视窗时将默认锁定为纵向布局':
      'Конфигурация макета действует только в компьютерном окне, в мобильном окне по умолчанию будет заблокирована вертикальная верстка',
    默认: 'По умолчанию',
    海洋之心: 'Сердце океана',
    海洋之心sss: 'Сердце океана sss',
    绿荫草场: 'Зеленый луг',
    碰触纯白: 'Чисто белый',
    月上重火: 'Пламя на луне',
    蓝黑: 'Сине-черный',
    蓝白: 'Сине-белый',
    绿黑: 'Зелено-черный',
    绿白: 'Зелено-белый',
    红黑: 'Красно-черный',
    红白: 'Красно-белый',
    渐变: 'Градиент',
    布局: 'Макет',
    分栏: 'Колонки',
    纵向: 'Вертикальный',
    横向: 'Горизонтальный',
    综合: 'Комплексный',
    常规: 'Обычный',
    浮动: 'Плавающий',
    菜单背景: 'Фон меню',
    分栏风格: 'Стиль колонок',
    箭头: 'Стрелка',
    头部固定: 'Фиксированный заголовок',
    固定: 'Фиксированный',
    不固定: 'Не фиксированный',
    标签: 'Вкладка',
    标签风格: 'Стиль вкладок',
    标签图标: 'Иконка вкладки',
    卡片: 'Карточка',
    灵动: 'Живой',
    圆滑: 'Гладкий',
    进度条: 'Индикатор прогресса',
    随机换肤: 'Случайная смена темы',
    购买源码: 'Купить исходный код',
    拷贝源码: 'Копировать исходный код',
    清理缓存: 'Очистить кэш',
    恢复默认: 'Восстановить по умолчанию',
    '检测到新版本，正在下载中，请稍后...':
      'Обнаружена новая версия, идет загрузка, пожалуйста, подождите...',
    温馨提示: 'Дружеский совет',
    更新版本完成: 'Обновление версии завершено',
    后刷新项目: 'затем обновить проект',
    我的待办: 'Мои задачи',
    已办事项: 'Выполненные задачи',
    经营分析: 'Анализ деятельности',
    决策辅助: 'Вспомогательное принятие решений',
    采购订单: 'Заказ на закупку',
    供应管理: 'Управление поставками',
    客户管理: 'Управление клиентами',
    商机管理: 'Управление возможностями',
    对外报价: 'Внешние предложения',
    财务: 'Финансы',
    仓库管理: 'Управление складом',
    收款计划: 'План поступлений',
    收款明细: 'Детали поступлений',
    开票详情: 'Детали выставления счета',
    库存盘点: 'Инвентаризация запасов',
    库存报表: 'Отчет по запасам',
    库存余额: 'Остаток запасов',
    收发明细: 'Детали прихода/расхода',
    收发汇总: 'Сводка прихода/расхода',
    单据列表: 'Список документов',
    产品入库: 'Приход продукции',
    产品出库: 'Расход продукции',
    产品调拨: 'Перемещение продукции',
    产品组装: 'Сборка продукции',
    产品拆卸: 'Разборка продукции',
    绩效: 'Производительность',
    我的绩效: 'Моя производительность',
    团队绩效: 'Производительность команды',
    绩效核定: 'Утверждение производительности',
    绩效规则: 'Правила производительности',
    任务: 'Задача',
    任务列表: 'Список задач',
    电商: 'Электронная коммерция',
    首页设置: 'Настройки главной страницы',
    商品: 'Товар',
    轮播图: 'Карусель изображений',
    文章管理: 'Управление статьями',
    设置: 'Настройки',
    公司信息: 'Информация о компании',
    销售配置: 'Конфигурация продаж',
    产品配置: 'Конфигурация продукции',
    产品素材: 'Материалы продукции',
    模版管理: 'Управление шаблонами',
    扩展字段: 'Расширенные поля',
    系统设置: 'Системные настройки',
    操作日志: 'Журнал операций',
    公司列表: 'Список компаний',
    用户列表: 'Список пользователей',
    权限管理: 'Управление правами',
    行业管理: 'Управление отраслями',
    资源: 'Ресурсы',
    店铺选址: 'Выбор местоположения магазина',
    教程管理: 'Управление учебниками',
    超级管理员: 'Супер администратор',
    '没有菜单权限！': 'Нет прав доступа к меню!',
    '路由格式返回有误！': 'Ошибка формата маршрута!',
    运行中: 'В работе',
    已下线: 'Снято с эксплуатации',
    游客: 'Гость',
    '未开启登录拦截)': 'Перехват входа не включен)',
    早上好: 'Доброе утро',
    上午好: 'Добрый день',
    中午好: 'Добрый полдень',
    下午好: 'Добрый день',
    晚上好: 'Добрый вечер',
    欢迎登录: 'Добро пожаловать',
    '登录接口异常，未正确返回':
      'Исключение интерфейса входа, некорректный возврат',
    '核心接口异常，请检查返回JSON格式是否正确，是否正确返回':
      'Исключение основного интерфейса, пожалуйста, проверьте правильность формата возвращаемого JSON и корректность возврата',
    '核心接口异常，请检查返回JSON格式是否正确':
      'Исключение основного интерфейса, пожалуйста, проверьте правильность формата возвращаемого JSON',
    复制: 'Копировать',
    成功: 'Успешно',
    失败: 'Неудача',
    '重量/毛重': 'Вес/Брутто',
    产品证书: 'Сертификат продукта',
    推荐价格: 'Рекомендуемая цена',
    邮编: 'Почтовый индекс',
    传真: 'Факс',
    官网: 'Официальный сайт',
    企业状态: 'Статус предприятия',
    营收: 'Выручка',
    员工人数: 'Количество сотрудников',
    公司类型: 'Тип компании',
    所属国家: 'Страна',
    所属城市: 'Город',
    简介: 'Краткое описание',
    产品服务: 'Продукты и услуги',
    请输入: 'Пожалуйста, введите',
    产品价格策略: 'Ценовая стратегия продукта',
    起始价格: 'Начальная цена',
    分类logo: 'Логотип категории',
    建议尺寸: 'Рекомендуемый размер',
    分类banner: 'Баннер категории',
    请输入分类描述: 'Пожалуйста, введите описание категории',
    退款金额为: 'Сумма возврата',
    表示只退货: 'означает только возврат товара',
    补差金额为: 'Сумма компенсации',
    表示只换货: 'означает только обмен товара',
    请输入客户编码: 'Пожалуйста, введите код клиента',
    请输入联系人: 'Пожалуйста, введите контактное лицо',
    请输入客户Whats: 'Пожалуйста, введите WhatsApp клиента',
    规则名称: 'Название правила',
    请输入规则名称: 'Пожалуйста, введите название правила',
    绩效类型: 'Тип производительности',
    请选择绩效类型: 'Пожалуйста, выберите тип производительности',
    优先级: 'Приоритет',
    请输入优先级: 'Пожалуйста, введите приоритет',
    请输入编码: 'Пожалуйста, введите код',
    请选择分类: 'Пожалуйста, выберите категорию',
    请输入详细地址: 'Пожалуйста, введите подробный адрес',
    固定电话: 'Городской телефон',
    请输入固定电话: 'Пожалуйста, введите городской телефон',
    请输入邮箱: 'Пожалуйста, введите email',
    请输入QQ: 'Пожалуйста, введите QQ',
    网址: 'Веб-сайт',
    请输入网址: 'Пожалуйста, введите веб-сайт',
    添加到采购计划: 'Добавить в план закупок',
    请输入数量: 'Пожалуйста, введите количество',
    选择负责人: 'Выбрать ответственного',
    服务年限: 'Срок службы',
    '请输入服务年限(报告年限)':
      'Пожалуйста, введите срок службы (отчетный год)',
    任务日期: 'Дата задачи',
    请选择任务日期: 'Пожалуйста, выберите дату задачи',
    请输入任务金额: 'Пожалуйста, введите сумму задачи',
    请选择关联销售订单: 'Пожалуйста, выберите связанный заказ на продажу',
    请输入回款金额: 'Пожалуйста, введите сумму поступления',
    请选择回款日期: 'Пожалуйста, выберите дату поступления',
    批量生成回款计划: 'Массовое создание плана поступлений',
    首次回款日期: 'Дата первого поступления',
    请选择首次回款日期: 'Пожалуйста, выберите дату первого поступления',
    回款间隔时间: 'Интервал поступлений',
    请输入回款间隔时间: 'Пожалуйста, введите интервал поступлений',
    总回款期数: 'Общее количество периодов поступлений',
    请输入总回款期数:
      'Пожалуйста, введите общее количество периодов поступлений',
    请选择关联回款计划: 'Пожалуйста, выберите связанный план поступлений',
    渠道: 'Канал',
    请选择渠道: 'Пожалуйста, выберите канал',
    凭证: 'Документ',
    请选择采购订单: 'Пожалуйста, выберите заказ на закупку',
    请选择关联采购订单: 'Пожалуйста, выберите связанный заказ на закупку',
    付款金额: 'Сумма платежа',
    请输入付款金额: 'Пожалуйста, введите сумму платежа',
    请选择付款日期: 'Пожалуйста, выберите дату платежа',
    批量生成付款计划: 'Массовое создание плана платежей',
    首次付款日期: 'Дата первого платежа',
    请选择首次付款日期: 'Пожалуйста, выберите дату первого платежа',
    付款间隔时间: 'Интервал платежей',
    请输入付款间隔时间: 'Пожалуйста, введите интервал платежей',
    总付款期数: 'Общее количество периодов платежей',
    请输入总付款期数: 'Пожалуйста, введите общее количество периодов платежей',
    请选择关联付款计划: 'Пожалуйста, выберите связанный план платежей',
    请选择发票抬头: 'Пожалуйста, выберите получателя счета',
    开票金额: 'Сумма счета',
    请输入开票金额: 'Пожалуйста, введите сумму счета',
    含税金额: 'Сумма с налогом',
    商品名称: 'Название товара',
    请输入商品名称: 'Пожалуйста, введите название товара',
    商品编号: 'Код товара',
    请输入商品编号: 'Пожалуйста, введите код товара',
    规格型号: 'Спецификация и модель',
    请输入商品规格型号: 'Пожалуйста, введите спецификацию и модель товара',
    商品单位: 'Единица измерения товара',
    请输入商品单位: 'Пожалуйста, введите единицу измерения товара',
    发票类型: 'Тип счета',
    请选择发票类型: 'Пожалуйста, выберите тип счета',
    税率: 'Налоговая ставка',
    请输入税率: 'Пожалуйста, введите налоговую ставку',
    商品数量: 'Количество товаров',
    请输入商品数量: 'Пожалуйста, введите количество товаров',
    开票日期: 'Дата выставления счета',
    请选择开票日期: 'Пожалуйста, выберите дату выставления счета',
    开票明细: 'Детали счета',
    员工离职交接: 'Передача при увольнении сотрудника',
    交接人: 'Передающий',
    请选择交接人: 'Пожалуйста, выберите передающего',
    单据时间: 'Время документа',
    请选择单据时间: 'Пожалуйста, выберите время документа',
    箱数: 'Количество коробок',
    请输入预估箱数: 'Пожалуйста, введите предполагаемое количество коробок',
    装箱预估数量: 'Предполагаемое количество упаковки',
    出库单: 'Накладная на отгрузку',
    请选择出库单: 'Пожалуйста, выберите накладную на отгрузку',
    正: 'Передняя сторона',
    侧: 'Боковая сторона',
    唛信息: 'Маркировочная информация',
    目的地: 'Пункт назначения',
    请输入收货目的地: 'Пожалуйста, введите пункт назначения получения',
    箱号标识: 'Идентификатор номера коробки',
    '如M、B': 'Например, M, B',
    产地: 'Страна происхождения',
    请输入产地: 'Пожалуйста, введите страну происхождения',
    订单号: 'Номер заказа',
    将自动填充: 'Будет заполнено автоматически',
    净重: 'Вес нетто',
    毛重: 'Вес брутто',
    产品盘点: 'Инвентаризация продукции',
    请选择单据日期: 'Пожалуйста, выберите дату документа',
    组装: 'Сборка',
    拆卸: 'Разборка',
    请输选择: 'Пожалуйста, выберите',
    入库仓库: 'Склад поступления',
    出库仓库: 'Склад отгрузки',
    费用: 'Расходы',
    存为模版: 'Сохранить как шаблон',
    拆卸产品: 'Разборка продукции',
    请选择拆卸产品: 'Пожалуйста, выберите продукт для разборки',
    图片名称: 'Название изображения',
    请输入图片: 'Пожалуйста, введите изображение',
    链接地址: 'Адрес ссылки',
    请输入图片链接地址: 'Пожалуйста, введите адрес ссылки изображения',
    文章: 'Статья',
    文章标题: 'Заголовок статьи',
    请输入文章标题: 'Пожалуйста, введите заголовок статьи',
    文章类型: 'Тип статьи',
    请选择文章类型: 'Пожалуйста, выберите тип статьи',
    文章内容: 'Содержание статьи',
    请输入文章内容: 'Пожалуйста, введите содержание статьи',
    提单详情: 'Детали коносамента',
    采购商: 'Покупатель',
    产品信息: 'Информация о продукте',
    总金额: 'Общая сумма',
    产品描述: 'Описание продукта',
    货运信息: 'Информация о грузоперевозке',
    原产国: 'Страна происхождения',
    目的国: 'Страна назначения',
    运输方式: 'Способ транспортировки',
    数据来源: 'Источник данных',
    请输入姓名: 'Пожалуйста, введите имя',
    请输入部门: 'Пожалуйста, введите отдел',
    请输入职务: 'Пожалуйста, введите должность',
    绩效月份: 'Месяц производительности',
    请选择绩效月份: 'Пожалуйста, выберите месяц производительности',
    计提人: 'Начисляющий',
    请选计提人: 'Пожалуйста, выберите начисляющего',
    请选择调出仓库: 'Пожалуйста, выберите склад отправки',
    请选择调入仓库: 'Пожалуйста, выберите склад получения',
    回款类型: 'Тип поступления',
    请选择回款类型: 'Пожалуйста, выберите тип поступления',
    退款: 'Возврат',
    回款: 'Поступление',
    付款类型: 'Тип платежа',
    请选择付款类型: 'Пожалуйста, выберите тип платежа',
    请选择优先级: 'Пожалуйста, выберите приоритет',
    关键词: 'Ключевые слова',
    请选择上下架状态: 'Пожалуйста, выберите статус выставления на продажу',
    只允许输入数字和字母: 'Разрешено вводить только цифры и буквы',
    请输入产品关键词: 'Пожалуйста, введите ключевые слова продукта',
    请输入HS编码: 'Пожалуйста, введите HS-код',
    请输入供应商名称: 'Пожалуйста, введите название поставщика',
    请输入采购商名称: 'Пожалуйста, введите название покупателя',
    请选择原产国: 'Пожалуйста, выберите страну происхождения',
    请选择目的国: 'Пожалуйста, выберите страну назначения',
    起始时间: 'Время начала',
    请输入关键词搜索: 'Пожалуйста, введите ключевые слова для поиска',
    请输入公司名称搜索: 'Пожалуйста, введите название компании для поиска',
    请输入产品名称搜索: 'Пожалуйста, введите название продукта для поиска',
    请选择国家ISO编码: 'Пожалуйста, выберите ISO-код страны',
    请选择公司经营状态: 'Пожалуйста, выберите статус деятельности компании',
    请选择公司营收范围: 'Пожалуйста, выберите диапазон выручки компании',
    请选择公司人数: 'Пожалуйста, выберите количество сотрудников компании',
    一: 'Один',
    二: 'Два',
    三: 'Три',
    四: 'Четыре',
    五: 'Пять',
    六: 'Шесть',
    刚刚: 'Только что',
    分钟前: 'минут назад',
    小时前: 'часов назад',
    天前: 'дней назад',
    时: 'час',
    分: 'минута',
    是一个函数: 'это функция',
    服务器成功返回请求数据: 'Сервер успешно вернул запрошенные данные',
    新建或修改数据成功: 'Создание или изменение данных успешно',
    '一个请求已经进入后台排队(异步任务)':
      'Запрос поставлен в очередь на обработку (асинхронная задача)',
    删除数据成功: 'Удаление данных успешно',
    发出信息有误: 'Отправленная информация содержит ошибки',
    '用户没有权限(令牌失效、用户名、密码错误、登录过期)':
      'У пользователя нет прав (токен недействителен, имя пользователя, пароль неверны или истек срок входа)',
    令牌过期: 'Токен истек',
    '用户得到授权，但是访问是被禁止的':
      'Пользователь авторизован, но доступ запрещен',
    访问资源不存在: 'Доступ к ресурсу не существует',
    请求格式不可得: 'Формат запроса недоступен',
    '请求资源被永久删除，且不会被看到':
      'Запрашиваемый ресурс удален навсегда и не будет отображаться',
    服务器发生错误: 'Ошибка сервера',
    网关错误: 'Ошибка шлюза',
    '服务不可用，服务器暂时过载或维护':
      'Сервис недоступен, сервер временно перегружен или находится на обслуживании',
    网关超时: 'Тайм-аут шлюза',
    '无网络！,请连接网络！！': 'Нет сети! Пожалуйста, подключитесь к сети!!',
    '网络不给力！,请检查网络！！':
      'Слабое соединение! Пожалуйста, проверьте сеть!!',
    '服务端正在升级中，请稍后再试':
      'Сервер обновляется, пожалуйста, попробуйте позже',
    提审并通过: 'Отправить на проверку и пройти',
    转: 'Перевести',
    切换公司主体: 'Переключить юридическое лицо компании',
    '确定解绑企业微信?': 'Подтвердить отвязку корпоративного WeChat?',
    主体未设置企业微信: 'Юридическое лицо не настроило корпоративный WeChat',
    扫描二维码联系工作人员: 'Отсканируйте QR-код для связи с сотрудниками',
    正在导出的文件: 'Файлы в процессе экспорта',
    '版本)': 'Версия)',
    '异常捕获(温馨提示：错误必须解决)':
      'Перехват исключений (дружеский совет: ошибки необходимо устранить)',
    报错路由: 'Маршрут ошибки',
    错误信息: 'Информация об ошибке',
    错误详情: 'Детали ошибки',
    暂不显示: 'Временно не отображать',
    百度搜索: 'Поиск в Baidu',
    谷歌搜索: 'Поиск в Google',
    最近访问: 'Последние посещения',
    总览: 'Обзор',
    开启全屏失败: 'Не удалось включить полноэкранный режим',
    服务将于: 'Сервис истекает через',
    天后到期: 'дней',
    服务永不到期: 'Сервис бессрочный',
    站内信: 'Внутренняя почта',
    全部已读: 'Все прочитано',
    消息状态: 'Статус сообщения',
    请选择消息类型: 'Пожалуйста, выберите тип сообщения',
    标记已读: 'Отметить как прочитанное',
    没有更多了: 'Больше нет',
    清空消息成功: 'Очистка сообщений успешна',
    自有产品: 'Собственная продукция',
    '已在当前产品！请换一个试试！':
      'Уже в текущем продукте! Попробуйте другой!',
    电商网站: 'Интернет-магазин',
    '支持纵向布局、分栏布局、综合布局、常规布局，不支持横向布局、浮动布局':
      'Поддерживает вертикальную, колоночную, комплексную и обычную верстку, не поддерживает горизонтальную и плавающую верстку',
    '请输入密码(密码在购买时获得，跳转后需登录购买时绑定的github账号)':
      'Пожалуйста, введите пароль (пароль получается при покупке, после перехода необходимо войти в аккаунт GitHub, привязанный при покупке)',
    '秘钥不正确！': 'Неверный ключ!',
    错误拦截: 'Перехват ошибок',
    '检测到您当前浏览器使用的是IE内核，自':
      'Обнаружено, что ваш текущий браузер использует ядро IE, с',
    '月起，微软已宣布弃用IE，且不再对IE提供任何更新维护，请':
      'месяца Microsoft объявила об отказе от IE и больше не будет предоставлять обновления и техническую поддержку IE, пожалуйста',
    '基于admin-plus构建': 'Построен на основе admin-plus',
    '抱歉!': 'Извините!',
    '您没有操作角色...': 'У вас нет роли оператора...',
    '当前帐号没有操作角色,请联系管理员。':
      'Текущий аккаунт не имеет роли оператора, пожалуйста, свяжитесь с администратором.',
    '当前页面不存在...': 'Текущая страница не существует...',
    '请检查您输入的网址是否正确，或点击下面的按钮返回首页。':
      'Пожалуйста, проверьте правильность введенного URL или нажмите кнопку ниже для возврата на главную страницу.',
    返回首页: 'Вернуться на главную',
    '重量(KG)': 'Вес (КГ)',
    交易次数: 'Количество транзакций',
    交易重量: 'Вес транзакций',
    交易金额: 'Сумма транзакций',
    出口: 'Экспорт',
    期间采购共计: 'Всего закупок за период',
    次: 'раз',
    采购次数最高: 'Максимальное количество закупок',
    采购次数最低: 'Минимальное количество закупок',
    采购商数量: 'Количество покупателей',
    供应商数量: 'Количество поставщиков',
    月度趋势: 'Ежемесячная тенденция',
    已添加为客户: 'Добавлен как клиент',
    添加客户: 'Добавить клиента',
    进口详单: 'Детали импорта',
    出口详单: 'Детали экспорта',
    贸易总览: 'Обзор торговли',
    更新数据: 'Обновить данные',
    区域分布: 'Региональное распределение',
    编码分布: 'Распределение кодов',
    货运历史: 'История грузоперевозок',
    进口: 'Импорт',
    贸易伙伴: 'Торговые партнеры',
    搜索时间: 'Время поиска',
    页码: 'Номер страницы',
    查看数据: 'Просмотр данных',
    无搜索结果: 'Нет результатов поиска',
    国家: 'Страна',
    经营状态: 'Статус деятельности',
    营收范围: 'Диапазон выручки',
    公司人数: 'Количество сотрудников',
    搜索历史: 'История поиска',
    历史搜索: 'Исторический поиск',
    公司本地名称: 'Локальное название компании',
    城市: 'Город',
    已解锁: 'Разблокировано',
    未解锁: 'Не разблокировано',
    详情: 'Детали',
    '您确定要解锁当前客户数据?':
      'Вы уверены, что хотите разблокировать данные текущего клиента?',
    产品搜索: 'Поиск продуктов',
    公司搜索: 'Поиск компаний',
    交易分析: 'Анализ транзакций',
    分析报告: 'Аналитический отчет',
    回款详情: 'Детали поступлений',
    '您确定要对当前数据进行提审？':
      'Вы уверены, что хотите отправить текущие данные на проверку?',
    '您确定要对当前数据进行提审并通过？':
      'Вы уверены, что хотите отправить текущие данные на проверку и пройти проверку?',
    回款时间: 'Время поступления',
    审核人: 'Проверяющий',
    审核时间: 'Время проверки',
    回款计划详情: 'Детали плана поступлений',
    '您确定要对当前数据生成发货单？':
      'Вы уверены, что хотите сгенерировать накладную на отправку для текущих данных?',
    计划回款金额: 'Плановая сумма поступлений',
    付款详情: 'Детали платежа',
    付款时间: 'Время платежа',
    开票计划详情: 'Детали плана выставления счетов',
    开票公司: 'Компания, выставляющая счет',
    计划开票金额: 'Плановая сумма счета',
    计划开票时间: 'Плановое время выставления счета',
    开票商品名称: 'Название товара в счете',
    开票商品编号: 'Код товара в счете',
    商品规格型号: 'Спецификация и модель товара',
    开票商品单位: 'Единица измерения товара в счете',
    开票税率: 'Налоговая ставка в счете',
    开票商品数量: 'Количество товаров в счете',
    付款计划详情: 'Детали плана платежей',
    计划付款金额: 'Плановая сумма платежа',
    需要数量: 'Требуемое количество',
    仓库名称: 'Название склада',
    剩余数量: 'Остаточное количество',
    分配库存: 'Распределить запасы',
    关联订单: 'Связанный заказ',
    开票公司名称: 'Название компании, выставляющей счет',
    一键复制: 'Копировать одним кликом',
    计划: 'План',
    计划开票占比: 'Доля планового выставления счетов',
    开票时间: 'Время выставления счета',
    付款编号: 'Номер платежа',
    关联采购单: 'Связанный заказ на закупку',
    计划编号: 'Номер плана',
    期数: 'Количество периодов',
    第: 'Период',
    期: '',
    计划付款占比: 'Доля плановых платежей',
    采购金额: 'Сумма закупки',
    已付款金额占比: 'Доля оплаченной суммы',
    '当前期数/总期数': 'Текущий период/Общее количество периодов',
    '您确定当前数据快速付款？':
      'Вы уверены, что хотите быстро оплатить текущие данные?',
    计划回款占比: 'Доля плановых поступлений',
    '已回款金额/占比': 'Сумма поступлений/Доля',
    '您确定当前数据快速回款？':
      'Вы уверены, что хотите быстро получить платеж по текущим данным?',
    回款编号: 'Номер поступления',
    客户排行: 'Рейтинг клиентов',
    毛利分析: 'Анализ валовой прибыли',
    销量最高: 'Максимальный объем продаж',
    毛利最高: 'Максимальная валовая прибыль',
    采购数量最大: 'Максимальное количество закупок',
    采购利润最高: 'Максимальная прибыль от закупок',
    采购额: 'Сумма закупок',
    销售分析: 'Анализ продаж',
    成交最多的销售: 'Продавец с наибольшим количеством сделок',
    销量最高的产品: 'Продукт с наибольшим объемом продаж',
    毛利最多的销售: 'Продавец с наибольшей валовой прибылью',
    毛利最高的产品: 'Продукт с наибольшей валовой прибылью',
    最近爆发的销售: 'Недавно успешный продавец',
    上月增长最高的产品: 'Продукт с наибольшим ростом в прошлом месяце',
    最近沉默的销售: 'Недавно неактивный продавец',
    上月下降最多的产品: 'Продукт с наибольшим падением в прошлом месяце',
    销售额: 'Объем продаж',
    产品分析: 'Анализ продуктов',
    最畅销的产品: 'Самый продаваемый продукт',
    最赚钱的产品: 'Самый прибыльный продукт',
    最近爆发产品: 'Недавно популярный продукт',
    最近沉默产品: 'Недавно неактивный продукт',
    产品销售量: 'Объем продаж продукта',
    商机漏斗: 'Воронка возможностей',
    漏斗图: 'Воронка',
    销售排行: 'Рейтинг продаж',
    数据简报: 'Краткий отчет по данным',
    环比: 'По сравнению с предыдущим периодом',
    新增客户: 'Новые клиенты',
    新增商机: 'Новые возможности',
    新增订单: 'Новые заказы',
    累计回款: 'Накопленные поступления',
    累计退款: 'Накопленные возвраты',
    前天: 'Позавчера',
    前周: 'Предыдущая неделя',
    前月: 'Предыдущий месяц',
    前年: 'Предыдущий год',
    用户趋势: 'Тенденция пользователей',
    用户数量: 'Количество пользователей',
    趋势: 'Тенденция',
    客户跟进: 'Сопровождение клиентов',
    需跟进的客户: 'Клиенты, требующие сопровождения',
    商机跟进: 'Сопровождение возможностей',
    订单跟进: 'Сопровождение заказов',
    待办任务: 'Задачи в работе',
    任务名称: 'Название задачи',
    计划完成时间: 'Плановое время завершения',
    占位符: 'Заполнитель',
    图形验证码: 'Графическая капча',
    账号登录: 'Вход по аккаунту',
    快捷登录: 'Быстрый вход',
    扫码登录: 'Вход по скану QR-кода',
    '企业微信扫码登录失败，请先确认您的企业微信账号确认属于该企业':
      'Не удалось войти через сканирование корпоративного WeChat, пожалуйста, сначала подтвердите, что ваш аккаунт корпоративного WeChat принадлежит этой компании',
    验证码不能空: 'Капча не может быть пустой',
    事项信息: 'Информация о событии',
    事项标题: 'Заголовок события',
    事项类型: 'Тип события',
    所属目标: 'Целевая цель',
    重要程度: 'Степень важности',
    事项参与人员: 'Участники события',
    请选择参与人员: 'Пожалуйста, выберите участников',
    创建者: 'Создатель',
    参与人员: 'Участники',
    事项: 'Событие',
    请输入事项标题: 'Пожалуйста, введите заголовок события',
    请输入重要程度: 'Пожалуйста, введите степень важности',
    请选择紧急程度: 'Пожалуйста, выберите степень срочности',
    目标开始时间: 'Время начала цели',
    目标结束时间: 'Время окончания цели',
    目标时间: 'Время цели',
    请输入所属目标: 'Пожалуйста, введите целевую цель',
    请选择所属目标: 'Пожалуйста, выберите целевую цель',
    数据已存在: 'Данные уже существуют',
    还有: 'Еще',
    '项...': 'элементов...',
    系统创建: 'Создано системой',
    事件已结束: 'Событие завершено',
    新建日程: 'Создать расписание',
    上一年: 'Предыдущий год',
    上一月: 'Предыдущий месяц',
    今天: 'Сегодня',
    下一月: 'Следующий месяц',
    下一年: 'Следующий год',
    日程主题: 'Тема расписания',
    请输入日程主题: 'Пожалуйста, введите тему расписания',
    日程周期: 'Период расписания',
    日程描述: 'Описание расписания',
    请输入日程描述: 'Пожалуйста, введите описание расписания',
    产品英文名: 'Английское название продукта',
    请输入产品英文名: 'Пожалуйста, введите английское название продукта',
    产品主图: 'Главное изображение продукта',
    产品轮播图: 'Карусель изображений продукта',
    请输入产品描述: 'Пожалуйста, введите описание продукта',
    计量单位: 'Единица измерения',
    请输入产品计量单位: 'Пожалуйста, введите единицу измерения продукта',
    产品库存: 'Запасы продукта',
    产品销量: 'Объем продаж продукта',
    产品成本价: 'Себестоимость продукта',
    产品排序值: 'Значение сортировки продукта',
    产品重量: 'Вес продукта',
    采购建议: 'Рекомендации по закупке',
    请输入采购建议: 'Пожалуйста, введите рекомендации по закупке',
    于: 'В',
    创建者创建时间: 'Время создания создателем',
    最近操作时间: 'Последнее время операции',
    故事: 'История',
    数据周期: 'Период данных',
    '请输入属性名：库存': 'Пожалуйста, введите имя атрибута: запасы',
    '属性名：库存': 'Имя атрибута: запасы',
    请选择数据周期: 'Пожалуйста, выберите период данных',
    数据类型: 'Тип данных',
    请选择数据类型: 'Пожалуйста, выберите тип данных',
    定时任务: 'Запланированная задача',
    请选择定时任务: 'Пожалуйста, выберите запланированную задачу',
    目标组名称: 'Название группы целей',
    '开始时间-结束时间': 'Время начала-Время окончания',
    目标标题: 'Заголовок цели',
    指标标题: 'Заголовок показателя',
    图表类型: 'Тип диаграммы',
    目标组: 'Группа целей',
    目标组标题: 'Заголовок группы целей',
    请输入目标组标题: 'Пожалуйста, введите заголовок группы целей',
    目标组开始时间: 'Время начала группы целей',
    目标组结束时间: 'Время окончания группы целей',
    目标组时间: 'Время группы целей',
    目标: 'Цель',
    请输入目标标题: 'Пожалуйста, введите заголовок цели',
    所属目标组: 'Принадлежащая группа целей',
    请选择所属目标组: 'Пожалуйста, выберите принадлежащую группу целей',
    指标: 'Показатель',
    请输入指标标题: 'Пожалуйста, введите заголовок показателя',
    数据源: 'Источник данных',
    请选择数据源: 'Пожалуйста, выберите источник данных',
    选择出数据源: 'Выбрать источник данных',
    手动: 'Вручную',
    自动: 'Автоматически',
    指标数据: 'Данные показателя',
    重要不紧急: 'Важно, но не срочно',
    重要紧急: 'Важно и срочно',
    不重要不紧急: 'Не важно и не срочно',
    不重要紧急: 'Не важно, но срочно',
    所属指标: 'Принадлежащий показатель',
    横坐标: 'Ось X',
    数值: 'Значение',
    显示近一周: 'Показать за последнюю неделю',
    显示近一月: 'Показать за последний месяц',
    显示近一年: 'Показать за последний год',
    显示全部: 'Показать все',
    个人: 'Персональный',
    团队: 'Команда',
    预计提成: 'Ожидаемая комиссия',
    元: 'юань',
    '预计提成：团队比例': 'Ожидаемая комиссия: процент команды',
    '计提人(团队)': 'Начисляющий (команда)',
    当期金额: 'Текущая сумма',
    实际提成: 'Фактическая комиссия',
    订单编号: 'Номер заказа',
    团队提成: 'Комиссия команды',
    服务金额: 'Сумма услуги',
    合计: 'Итого',
    条件: 'Условие',
    符合以下条件时按本规则计提:
      'При соблюдении следующих условий начислять по данному правилу',
    添加条件: 'Добавить условие',
    '元）': 'юань)',
    新建规则: 'Создать правило',
    '规则ID、规则名称': 'ID правила, название правила',
    编辑规则: 'Редактировать правило',
    '负责人/提计人': 'Ответственный/Начисляющий',
    产品分类下的扩展属性: 'Расширенные атрибуты в классификации продуктов',
    产品属性: 'Атрибуты продукта',
    设置方式: 'Способ настройки',
    销售价格: 'Цена продажи',
    采购价格: 'Цена закупки',
    按客户设置: 'Настроить по клиенту',
    价格为: 'Цена',
    价格币种: 'Валюта цены',
    标准单价: 'Стандартная цена за единицу',
    按客户类别设置: 'Настроить по категории клиента',
    默认调价比例: 'Стандартный коэффициент пересмотра цены',
    实际调价比例: 'Фактический коэффициент пересмотра цены',
    起始年份: 'Год начала',
    截止年份: 'Год окончания',
    补充年份: 'Дополнительный год',
    已上传: 'Загружено',
    上传图片: 'Загрузить изображение',
    共: 'Всего',
    综述信息: 'Обзорная информация',
    跟进信息: 'Информация о сопровождении',
    详细跟进: 'Подробное сопровождение',
    请填写跟进内容: 'Пожалуйста, заполните содержание сопровождения',
    发布: 'Опубликовать',
    下次跟进: 'Следующее сопровождение',
    绩效比例: 'Процент производительности',
    '个人绩效相对团队绩效占比，剩余部分归负责人':
      'Процент индивидуальной производительности относительно командной, оставшаяся часть принадлежит ответственному',
    最新价格: 'Последняя цена',
    历史近期: 'Недавняя история',
    供应: 'Поставка',
    已付金额: 'Оплаченная сумма',
    '当前订单付款总和，不扣除退款':
      'Общая сумма платежей по текущему заказу, без вычета возвратов',
    '您确定要对当前数据生成入库单？':
      'Вы уверены, что хотите сгенерировать приходную накладную для текущих данных?',
    批量添加: 'Массовое добавление',
    请输入企业名称: 'Пожалуйста, введите название предприятия',
    '您确定要对当前数据进行作废？':
      'Вы уверены, что хотите аннулировать текущие данные?',
    请选择组装拆卸产品明细:
      'Пожалуйста, выберите детали сборки/разборки продукта',
    请选择组装拆卸产品: 'Пожалуйста, выберите продукт для сборки/разборки',
    箱单详情: 'Детали упаковочного листа',
    '您确定要生成发货单？':
      'Вы уверены, что хотите сгенерировать накладную на отправку?',
    装箱数: 'Количество упаковок',
    '未作废数据删除，库存将不会恢复是否删除？':
      'Если удалить неаннулированные данные, запасы не будут восстановлены. Удалить?',
    '您确定要作废当前数据？':
      'Вы уверены, что хотите аннулировать текущие данные?',
    箱单数量: 'Количество упаковочных листов',
    请输入预估所需箱单数:
      'Пожалуйста, введите предполагаемое количество упаковочных листов',
    拆分数量: 'Количество разделения',
    装货箱编号: 'Номер грузовой коробки',
    码: 'Штрих-код',
    包装数量: 'Количество упаковки',
    包装的数量: 'Количество упаковки',
    '单个重量(w/pc)': 'Вес единицы (вес/шт)',
    包装的重量: 'Вес упаковки',
    '单个体积(v/pc)': 'Объем единицы (объем/шт)',
    包装的体积: 'Объем упаковки',
    总重量: 'Общий вес',
    总体积: 'Общий объем',
    所属箱号: 'Принадлежащий номер коробки',
    盘点详情: 'Детали инвентаризации',
    系统库存: 'Системные запасы',
    系统统计当前仓库的数量: 'Система подсчитывает количество на текущем складе',
    盘点数量: 'Количество при инвентаризации',
    盘亏盘盈: 'Недостача/Излишки',
    添加后请到出入库单列表审核:
      'После добавления перейдите в список приходно-расходных накладных для проверки',
    '剩余数量（冻结库存数量)': 'Остаточное количество (замороженные запасы)',
    操作员: 'Оператор',
    出入库单详情: 'Детали приходно-расходной накладной',
    '您确定要对当前数据生成出入库单？':
      'Вы уверены, что хотите сгенерировать приходно-расходную накладную для текущих данных?',
    出入库进度: 'Прогресс прихода/расхода',
    备注说明: 'Примечания',
    产品调拨详情: 'Детали перемещения продукта',
    组合件名称: 'Название сборной детали',
    单位成本: 'Себестоимость единицы',
    组合成本: 'Себестоимость сборки',
    操作时间: 'Время операции',
    操作人: 'Оператор',
    业务类型: 'Тип бизнеса',
    入库数量: 'Количество прихода',
    出库数量: 'Количество расхода',
    结存数量: 'Остаточное количество',
    库存低于预警库存: 'Запасы ниже предупреждающего уровня',
    各仓库数量: 'Количество по складам',
    总库存: 'Общие запасы',
    盘点时间: 'Время инвентаризации',
    盘点产品量: 'Количество инвентаризованных продуктов',
    盘点人: 'Инвентаризатор',
    中文: 'Китайский',
    父级: 'Родительский',
    请选择父级: 'Пожалуйста, выберите родительский',
    记录: 'Запись',
    租金: 'Аренда',
    人流量: 'Поток людей',
    是否转让: 'Передача',
    转让价格: 'Цена передачи',
    流水: 'Оборот',
    利润: 'Прибыль',
    推荐星级: 'Рекомендуемый рейтинг',
    星: 'звезда',
    联系方式: 'Контактная информация',
    商家: 'Продавец',
    是否显示: 'Отображать',
    请输入店铺名称: 'Пожалуйста, введите название магазина',
    选址类型: 'Тип выбора местоположения',
    请选择选址类型: 'Пожалуйста, выберите тип выбора местоположения',
    请输入店铺地址: 'Пожалуйста, введите адрес магазина',
    经度: 'Долгота',
    请输入经度: 'Пожалуйста, введите долготу',
    纬度: 'Широта',
    请输入纬度: 'Пожалуйста, введите широту',
    '租金(月)': 'Аренда (месяц)',
    请输入租金: 'Пожалуйста, введите аренду',
    请输入人流量: 'Пожалуйста, введите поток людей',
    请输入流水: 'Пожалуйста, введите оборот',
    请输入利润: 'Пожалуйста, введите прибыль',
    请输入推荐星级: 'Пожалуйста, введите рекомендуемый рейтинг',
    请输入转让价格: 'Пожалуйста, введите цену передачи',
    请输入联系方式: 'Пожалуйста, введите контактную информацию',
    竞品情况: 'Ситуация с конкурентами',
    请输入竞品情况: 'Пожалуйста, введите ситуацию с конкурентами',
    请输入教程名称: 'Пожалуйста, введите название учебника',
    教程类型: 'Тип учебника',
    请选择教程类型: 'Пожалуйста, выберите тип учебника',
    教程: 'Учебник',
    教程名称: 'Название учебника',
    前: 'За',
    小时内: 'часов',
    分钟内: 'минут',
    销售趋势: 'Тенденция продаж',
    销售数量: 'Количество продаж',
    客户最新报价: 'Последнее предложение клиента',
    头像: 'Аватар',
    昵称: 'Псевдоним',
    真实姓名: 'Настоящее имя',
    手机号码: 'Номер мобильного телефона',
    最后登录时间: 'Последнее время входа',
    电话号码: 'Номер телефона',
    请选择角色: 'Пожалуйста, выберите роль',
    请选择公司: 'Пожалуйста, выберите компанию',
    请选择昵称: 'Пожалуйста, выберите псевдоним',
    人员: 'Персонал',
    公司简称: 'Сокращенное название компании',
    请输入公司简称: 'Пожалуйста, введите сокращенное название компании',
    统一社会信用代码: 'Унифицированный социальный кредитный код',
    请输入统一社会信用代码:
      'Пожалуйста, введите унифицированный социальный кредитный код',
    企业法人: 'Юридическое лицо предприятия',
    请输入企业法人: 'Пожалуйста, введите юридическое лицо предприятия',
    注册地址: 'Адрес регистрации',
    请输入注册地址: 'Пожалуйста, введите адрес регистрации',
    注册日期: 'Дата регистрации',
    请输入注册日期: 'Пожалуйста, введите дату регистрации',
    请选择注册日期: 'Пожалуйста, выберите дату регистрации',
    联系电话: 'Контактный телефон',
    请输入联系电话: 'Пожалуйста, введите контактный телефон',
    联系邮箱: 'Контактный email',
    请输入联系邮箱: 'Пожалуйста, введите контактный email',
    站点域名: 'Домен сайта',
    请输入站点域名: 'Пожалуйста, введите домен сайта',
    请输入ICP: 'Пожалуйста, введите ICP',
    公司代号: 'Код компании',
    请输入公司代号: 'Пожалуйста, введите код компании',
    公司简介: 'Описание компании',
    请输入公司简介: 'Пожалуйста, введите описание компании',
    公司LOGO: 'Логотип компании',
    站点LOGO: 'Логотип сайта',
    站点ICO: 'ICO сайта',
    登录页背景图: 'Фоновое изображение страницы входа',
    部门名称: 'Название отдела',
    手机: 'Мобильный телефон',
    请输入部门名称: 'Пожалуйста, введите название отдела',
    部门人员: 'Персонал отдела',
    员工: 'Сотрудник',
    请选择员工: 'Пожалуйста, выберите сотрудника',
    职位: 'Должность',
    '您确定要对当前员工进行禁用？':
      'Вы уверены, что хотите отключить текущего сотрудника?',
    '您确定要对当前员工进行解除禁用？':
      'Вы уверены, что хотите включить текущего сотрудника?',
    '您确定要对当前员工进行离职处理？':
      'Вы уверены, что хотите уволить текущего сотрудника?',
    员工状态: 'Статус сотрудника',
    权限字段: 'Поля прав',
    编辑角色: 'Редактировать роль',
    添加角色: 'Добавить роль',
    角色名称: 'Название роли',
    请输入角色名称: 'Пожалуйста, введите название роли',
    角色描述: 'Описание роли',
    数据权限: 'Права на данные',
    模块权限: 'Права на модули',
    字段权限: 'Права на поля',
    请输入角色名: 'Пожалуйста, введите название роли',
    组织架构: 'Организационная структура',
    员工管理: 'Управление сотрудниками',
    标识: 'Идентификатор',
    成员限制: 'Ограничения участников',
    成员数量: 'Количество участников',
    到期时间: 'Время окончания',
    站点: 'Сайт',
    行业: 'Отрасль',
    请输入标识: 'Пожалуйста, введите идентификатор',
    管理员手机号: 'Номер мобильного телефона администратора',
    请输入管理员手机号:
      'Пожалуйста, введите номер мобильного телефона администратора',
    管理员姓名: 'Имя администратора',
    请输入管理员姓名: 'Пожалуйста, введите имя администратора',
    公司行业: 'Отрасль компании',
    请选择公司行业: 'Пожалуйста, выберите отрасль компании',
    请选择到期时间: 'Пожалуйста, выберите время окончания',
    键: 'Ключ',
    必填: 'Обязательно',
    默认值: 'Значение по умолчанию',
    占比: 'Процент',
    请输入正确key: 'Пожалуйста, введите правильный ключ',
    字段: 'Поле',
    只能是英文数字下划线的组合且以英文或者下划线开头:
      'Может содержать только комбинацию английских букв, цифр и подчеркиваний, начинающуюся с английской буквы или подчеркивания',
    请输入键: 'Пожалуйста, введите ключ',
    请输入默认值: 'Пожалуйста, введите значение по умолчанию',
    输入提示: 'Подсказка ввода',
    请输入输入提示: 'Пожалуйста, введите подсказку ввода',
    客户类型: 'Тип клиента',
    请输入客户类型名: 'Пожалуйста, введите название типа клиента',
    请输入客户类型: 'Пожалуйста, введите тип клиента',
    客户配置: 'Конфигурация клиента',
    行业字段: 'Отраслевые поля',
    行业名称: 'Название отрасли',
    行业权限: 'Отраслевые права',
    所属菜单: 'Принадлежащее меню',
    字段名称: 'Название поля',
    字段标识: 'Идентификатор поля',
    列表宽度: 'Ширина списка',
    父级菜单: 'Родительское меню',
    请选择父级菜单: 'Пожалуйста, выберите родительское меню',
    请输入字段名称: 'Пожалуйста, введите название поля',
    请输入字段标识: 'Пожалуйста, введите идентификатор поля',
    请输入列表宽度: 'Пожалуйста, введите ширину списка',
    字段排序: 'Сортировка полей',
    请输入字段排序: 'Пожалуйста, введите сортировку полей',
    菜单名称: 'Название меню',
    菜单: 'Меню',
    请输入菜单名称: 'Пожалуйста, введите название меню',
    菜单地址: 'Адрес меню',
    请输入菜单地址: 'Пожалуйста, введите адрес меню',
    关联菜单: 'Связанное меню',
    请选择关联菜单: 'Пожалуйста, выберите связанное меню',
    菜单图标: 'Иконка меню',
    请输入菜单图标: 'Пожалуйста, введите иконку меню',
    菜单排序: 'Сортировка меню',
    请输入菜单排序: 'Пожалуйста, введите сортировку меню',
    操作名称: 'Название операции',
    操作代码: 'Код операции',
    操作地址: 'Адрес операции',
    表头操作: 'Операции в заголовке таблицы',
    列表操作: 'Операции в списке',
    选项卡操作: 'Операции вкладки',
    请输入操作名称: 'Пожалуйста, введите название операции',
    不输入则与操作名称相同:
      'Если не введено, то совпадает с названием операции',
    请输入操作代码: 'Пожалуйста, введите код операции',
    操作图标: 'Иконка операции',
    请输入操作图标: 'Пожалуйста, введите иконку операции',
    请输入操作地址: 'Пожалуйста, введите адрес операции',
    操作排序: 'Сортировка операций',
    请输入操作排序: 'Пожалуйста, введите сортировку операций',
    显示在表头: 'Отображать в заголовке таблицы',
    显示在列表: 'Отображать в списке',
    显示在选项卡: 'Отображать во вкладке',
    所属企业: 'Принадлежащее предприятие',
    企业: 'Предприятие',
    选择企业: 'Выбрать предприятие',
    操作管理: 'Управление операциями',
    字段管理: 'Управление полями',
    设备调试: 'Настройка оборудования',
    门锁状态: 'Статус замка',
    物品状态: 'Статус предмета',
    门锁编号: 'Номер замка',
    开锁: 'Открыть замок',
    检测: 'Проверка',
    通电: 'Подача питания',
    断电: 'Отключение питания',
    门锁操作: 'Операции замка',
    门锁打开: 'Замок открыт',
    门锁已开启: 'Замок уже открыт',
    门锁关闭: 'Замок закрыт',
    门锁已关闭: 'Замок уже закрыт',
    发信昵称: 'Псевдоним отправителя',
    邮箱服务商: 'Провайдер email',
    默认发信邮箱: 'Email отправителя по умолчанию',
    请输入发信昵称: 'Пожалуйста, введите псевдоним отправителя',
    请选择邮箱服务商: 'Пожалуйста, выберите провайдера email',
    密码: 'Пароль',
    语种: 'Язык',
    请选择语种: 'Пожалуйста, выберите язык',
    '内容-头部': 'Содержание-Заголовок',
    '内容-尾部': 'Содержание-Подвал',
    用户名: 'Имя пользователя',
    性别: 'Пол',
    个人简介: 'Личное описание',
    我的邮箱: 'Мой email',
    重置密码: 'Сброс пароля',
    短信验证码: 'SMS-код подтверждения',
    新密码: 'Новый пароль',
    供应商分类: 'Классификация поставщиков',
    车型配置: 'Конфигурация моделей автомобилей',
    部件配置: 'Конфигурация компонентов',
    行业模板: 'Отраслевой шаблон',
    '请选择行业模板(非必填)':
      'Пожалуйста, выберите отраслевой шаблон (не обязательно)',
    分类图片: 'Изображение категории',
    英文名称: 'Английское название',
    顶级分类: 'Корневая категория',
    请输入搜索内容: 'Пожалуйста, введите содержание поиска',
    父级分类: 'Родительская категория',
    请选择父级分类: 'Пожалуйста, выберите родительскую категорию',
    '分类名称（英文）': 'Название категории (английское)',
    '请输入分类名称（英文）':
      'Пожалуйста, введите название категории (английское)',
    分类排序: 'Сортировка категории',
    类型标题: 'Заголовок типа',
    类型名称: 'Название типа',
    请输入类型名称: 'Пожалуйста, введите название типа',
    仓库设置: 'Настройки склада',
    图片数量: 'Количество изображений',
    宽度: 'Ширина',
    高度: 'Высота',
    素材名称: 'Название материала',
    分类标题: 'Заголовок категории',
    事项分类: 'Классификация событий',
    故事分类: 'Классификация историй',
    汇率设置: 'Настройки курса валют',
    人民币: 'Китайский юань',
    前缀: 'Префикс',
    请选择中间规则: 'Пожалуйста, выберите промежуточное правило',
    请选择后缀规则: 'Пожалуйста, выберите правило суффикса',
    产品编号规则: 'Правило номера продукта',
    '前缀如CP，类型代码需要在类型信息里面增加':
      'Префикс, например CP, код типа необходимо добавить в информацию о типе',
    空: 'Пусто',
    类型id: 'ID типа',
    类型代码: 'Код типа',
    自增ID: 'Автоинкрементный ID',
    客户编号规则: 'Правило номера клиента',
    前缀如KH: 'Префикс, например KH',
    国家ID: 'ID страны',
    国家代码: 'Код страны',
    销售单名称规则: 'Правило названия заказа на продажу',
    前缀如XSDD: 'Префикс, например XSDD',
    客户ID: 'ID клиента',
    年月日: 'Год-месяц-день',
    采购单名称规则: 'Правило названия заказа на закупку',
    前缀如CGD: 'Префикс, например CGD',
    供应商ID: 'ID поставщика',
    销售报价权限: 'Права на коммерческие предложения продаж',
    '严格模式下，报价低于产品最低售价不可提交，宽松模式下可以提交，会给出明显警告':
      'В строгом режиме предложения ниже минимальной цены продукта нельзя отправить, в свободном режиме можно отправить, но будет выдано явное предупреждение',
    宽松模式: 'Свободный режим',
    采购报价权限: 'Права на коммерческие предложения закупок',
    '严格模式下，采购高于供应商报价不可提交，宽松模式下可以提交，会给出明显警告':
      'В строгом режиме закупки выше предложения поставщика нельзя отправить, в свободном режиме можно отправить, но будет выдано явное предупреждение',
    基本配置: 'Базовая конфигурация',
    '用户ID/用户名': 'ID пользователя/Имя пользователя',
    路径: 'Путь',
    请求ID: 'ID запроса',
    规则: 'Правило',
    执行类: 'Класс выполнения',
    执行方法: 'Метод выполнения',
    是否启用: 'Включено',
    任务标题: 'Заголовок задачи',
    请输入任务标题: 'Пожалуйста, введите заголовок задачи',
    任务规则: 'Правило задачи',
    请输入任务规则: 'Пожалуйста, введите правило задачи',
    如: 'Например',
    则代表每: 'представляет каждые',
    分钟执行一次: 'минут выполнения',
    请输入执行类: 'Пожалуйста, введите класс выполнения',
    请输入执行方法: 'Пожалуйста, введите метод выполнения',
    任务类型: 'Тип задачи',
    请选择任务类型: 'Пожалуйста, выберите тип задачи',
    参数格式: 'Формат параметров',
    '请输入参数格式(必须为json格式),可不填写':
      'Пожалуйста, введите формат параметров (должен быть в формате json), можно не заполнять',
    数据组类型: 'Тип группы данных',
    请选择数据组类型: 'Пожалуйста, выберите тип группы данных',
    属性: 'Атрибут',
    '请输入属性key(唯一)：name':
      'Пожалуйста, введите ключ атрибута (уникальный): name',
    '属性key(唯一)：name': 'Ключ атрибута (уникальный): name',
    属性类型: 'Тип атрибута',
    排序值: 'Значение сортировки',
    请填写选项配置值: 'Пожалуйста, заполните значение конфигурации опций',
    参数方式例如: 'Способ параметров, например',
    白色: 'Белый',
    红色: 'Красный',
    黑色: 'Черный',
    添加属性: 'Добавить атрибут',
    数据组名称: 'Название группы данных',
    数据组描述: 'Описание группы данных',
    请输入关键字: 'Пожалуйста, введите ключевые слова',
    扩展属性: 'Расширенные атрибуты',
    请输入数据组名称: 'Пожалуйста, введите название группы данных',
    请输入数据组描述: 'Пожалуйста, введите описание группы данных',
    请上传: 'Пожалуйста, загрузите',
    主体名称: 'Название юридического лица',
    域名: 'Домен',
    站点标题: 'Заголовок сайта',
    团队名称: 'Название команды',
    主体: 'Юридическое лицо',
    所属: 'Принадлежит',
    请输入所属: 'Пожалуйста, введите принадлежность',
    请输入主体名称: 'Пожалуйста, введите название юридического лица',
    请输入税号: 'Пожалуйста, введите налоговый номер',
    法人: 'Юридическое лицо',
    请输入法人: 'Пожалуйста, введите юридическое лицо',
    请输入站点标题: 'Пожалуйста, введите заголовок сайта',
    主体简介: 'Описание юридического лица',
    请输入主体简介: 'Пожалуйста, введите описание юридического лица',
    主体LOGO: 'Логотип юридического лица',
    站点背景: 'Фон сайта',
    数据配置: 'Конфигурация данных',
    主体管理: 'Управление юридическими лицами',
    账号: 'Аккаунт',
    请输入账号: 'Пожалуйста, введите аккаунт',
    周期: 'Период',
    日志类型: 'Тип журнала',
    执行结果: 'Результат выполнения',
    登录成功: 'Вход успешен',
    访问时间: 'Время доступа',
    登录IP: 'IP входа',
    下载模版: 'Скачать шаблон',
    枚举变量: 'Перечисляемая переменная',
    模版文件: 'Файл шаблона',
    仅支持Xlsx: 'Поддерживает только Xlsx',
    若为Xls文件请先在Excel中另存为Xlsx:
      'Если файл Xls, пожалуйста, сначала сохраните как Xlsx в Excel',
    '添加完成后，请点击字段集编辑完善模版填充配置信息':
      'После добавления нажмите редактирование набора полей для завершения конфигурации заполнения шаблона',
    变量: 'Переменная',
    为单一数据占位: 'Занимает место для единичных данных',
    为列数据占位: 'Занимает место для данных столбца',
    字段集: 'Набор полей',
    '文件名称(点击预览)': 'Название файла (клик для предпросмотра)',
    文件大小: 'Размер файла',
    数据填充起始行: 'Начальная строка заполнения данных',
    模板选择: 'Выбор шаблона',
    无模板导出: 'Экспорт без шаблона',
    模板导出: 'Экспорт с шаблоном',
    无模板打印: 'Печать без шаблона',
    模板打印: 'Печать с шаблоном',
    请选择模板: 'Пожалуйста, выберите шаблон',
    '正在导出中...': 'Экспорт в процессе...',
    '正在打印中...': 'Печать в процессе...',
    单元格: 'Ячейка',
    多行项: 'Многострочный элемент',
    是否求和: 'Суммировать',
    是否图片: 'Изображение',
    是否合并: 'Объединить',
    图片宽度: 'Ширина изображения',
    图片高度: 'Высота изображения',
    关联合并: 'Связанное объединение',
    请选择字段: 'Пожалуйста, выберите поле',
    链接: 'Ссылка',
    轮播图设置: 'Настройки карусели изображений',
    首页分类商品设置: 'Настройки товаров категории на главной странице',
    '此内容依赖于：产品》产品分类，您可以勾选你需要展示的分类，勾选后分类将出现在首页f分类商品中。':
      'Этот контент зависит от: Продукт》Классификация продуктов, вы можете выбрать нужные категории для отображения, после выбора категории появятся в товарах категории на главной странице.',
    首页分类导航设置: 'Настройки навигации категорий на главной странице',
    '此内容依赖于：产品》产品分类，您可以勾选你需要展示的分类，勾选后分类将出现在首页导航栏中。':
      'Этот контент зависит от: Продукт》Классификация продуктов, вы можете выбрать нужные категории для отображения, после выбора категории появятся в навигационной панели на главной странице.',
    导航设置: 'Настройки навигации',
    站点名称: 'Название сайта',
    请输入站点名称: 'Пожалуйста, введите название сайта',
    '对SEO很重要,不要堆砌关键字':
      'Важно для SEO, не перегружайте ключевыми словами',
    站点描述: 'Описание сайта',
    请输入站点描述: 'Пожалуйста, введите описание сайта',
    '站点的描述，用于展示在搜素结果':
      'Описание сайта, используется для отображения в результатах поиска',
    站点关键词: 'Ключевые слова сайта',
    请输入站点关键词: 'Пожалуйста, введите ключевые слова сайта',
    '搜索时会匹配对应的关键词，不要重复':
      'При поиске будут сопоставляться соответствующие ключевые слова, не повторяйте',
    请输入公司地址: 'Пожалуйста, введите адрес компании',
    社媒设置: 'Настройки социальных сетей',
    联系我们: 'Свяжитесь с нами',
    请输入正确的网址信息:
      'Пожалуйста, введите правильную информацию о веб-сайте',
    请输入facebook主页地址:
      'Пожалуйста, введите адрес главной страницы facebook',
    请输入twitter主页地址: 'Пожалуйста, введите адрес главной страницы twitter',
    请输入youtube主页地址: 'Пожалуйста, введите адрес главной страницы youtube',
    请输入linkedin主页地址:
      'Пожалуйста, введите адрес главной страницы linkedin',
    请输入instagram主页地址:
      'Пожалуйста, введите адрес главной страницы instagram',
    页尾设置: 'Настройки подвала',
    '您确定要作废当前数据?':
      'Вы уверены, что хотите аннулировать текущие данные?',
    实施明细: 'Детали реализации',
    任务状态: 'Статус задачи',
    参与人: 'Участники',
    未开始: 'Не начато',
    任务详情: 'Детали задачи',
    任务概况: 'Обзор задачи',
    完成时间: 'Время завершения',
    '您确定要作废此任务？': 'Вы уверены, что хотите аннулировать эту задачу?',
    '您确定已完成此任务？': 'Вы уверены, что завершили эту задачу?',
    请选择团队成员: 'Пожалуйста, выберите членов команды',
    请填写比列: 'Пожалуйста, заполните соотношение',
    请填写分成比列: 'Пожалуйста, заполните процент разделения',
    进度: 'Прогресс',
    分成比例不能低于: 'Процент разделения не может быть ниже',
    或高于: 'или выше',
    钱包金额: 'Сумма в кошельке',
    用户角色: 'Роль пользователя',
    注册时间: 'Время регистрации',
    用户: 'Пользователь',
    请输入真实姓名: 'Пожалуйста, введите настоящее имя',
    用户邮箱: 'Email пользователя',
    请输入用户邮箱: 'Пожалуйста, введите email пользователя',
    请输入正确的用户邮箱地址:
      'Пожалуйста, введите правильный адрес email пользователя',
    性别选择: 'Выбор пола',
    所属团队: 'Принадлежащая команда',
    请选择团队: 'Пожалуйста, выберите команду',
    所属角色: 'Принадлежащая роль',
    用户密码: 'Пароль пользователя',
    请输入用户密码: 'Пожалуйста, введите пароль пользователя',
    用户头像: 'Аватар пользователя',
    用户昵称: 'Псевдоним пользователя',
    回复: 'Ответить',
    反馈: 'Обратная связь',
    请输入回复: 'Пожалуйста, введите ответ',
    启用状态: 'Статус включения',
    用户来源: 'Источник пользователя',
    积分: 'Баллы',
    请输入用户昵称: 'Пожалуйста, введите псевдоним пользователя',
    请选择用户角色: 'Пожалуйста, выберите роль пользователя',
    未知功能: 'Неизвестная функция',
    成员头像: 'Аватар участника',
    成员名称: 'Имя участника',
    成员角色: 'Роль участника',
    管理产品: 'Управление продуктами',
    请输入团队名称: 'Пожалуйста, введите название команды',
    设备区域: 'Область оборудования',
    请选择设备区域: 'Пожалуйста, выберите область оборудования',
    团队简介: 'Описание команды',
    请输入团队简介: 'Пожалуйста, введите описание команды',
    团队头像: 'Аватар команды',
    HS编码: 'HS-код',
    // TODO: 2023-11-21
    '产品组成：产品A由B/C/D组成,组合的产品A在销售和库存环节跟其他产品一样。在箱单处理环节可以自动拆分':
      'Состав продукта: продукт A состоит из B/C/D, комбинированный продукт A такой же, как и другие продукты, на этапах продаж и инвентаризации. На этапе обработки упаковочного листа может быть автоматически разделен',
    M会自动为您过滤: 'M автоматически фильтрует для вас',
    S后刷新项目: 'Обновить проект после S',
    客户投诉: 'Жалобы клиентов',
    配置项: 'Элементы конфигурации',
    login核心接口异常: 'Аномалия основного интерфейса login',
    '请检查返回JSON格式是否正确，是否正确返回':
      'Пожалуйста, проверьте правильность формата возвращаемого JSON и корректность возврата',
    getUserInfo核心接口异常: 'Аномалия основного интерфейса getUserInfo',
    请检查返回JSON格式是否正确:
      'Пожалуйста, проверьте правильность формата возвращаемого JSON',
    不含税: 'Без налога',
    产品质量: 'Качество продукции',
    发货速度: 'Скорость отгрузки',
    售后服务: 'Послепродажное обслуживание',
    客诉: 'Жалобы клиентов',
    客诉标题: 'Заголовок жалобы клиента',
    请输入客诉标题: 'Пожалуйста, введите заголовок жалобы клиента',
    客诉类型: 'Тип жалобы клиента',
    关联信息: 'Связанная информация',
    请选择关联信息: 'Пожалуйста, выберите связанную информацию',
    客诉原因: 'Причина жалобы клиента',
    请输入客诉原因: 'Пожалуйста, введите причину жалобы клиента',
    valFun是一个函数: 'valFun - это функция',
    产品组成: 'Состав продукта',
    最近销售时间: 'Последнее время продажи',
    EXW价格: 'Цена EXW',
    FOB价格: 'Цена FOB',
    厂商税率: 'Налоговая ставка производителя',
    最近采购时间: 'Последнее время закупки',
    采购次数: 'Количество закупок',
    产品供应商分布: 'Распределение поставщиков продукта',
    OEM码: 'Код OEM',
    附件信息: 'Информация о вложении',
    原因: 'Причина',
    URL地址: 'Адрес URL',
    // TODO: 2023-11-22
    含税: 'С налогом',
    请输入采购税率: 'Пожалуйста, введите налоговую ставку закупки',
    是否含税: 'С налогом',
    交货方式: 'Способ доставки',
    请选择客诉类型: 'Пожалуйста, выберите тип жалобы клиента',
    客诉信息: 'Информация о жалобе клиента',
    请输入客户WhatsApp: 'Пожалуйста, введите WhatsApp клиента',
    '仅支持Xlsx,若为Xls文件请先在Excel中另存为Xlsx':
      'Поддерживает только Xlsx, если файл Xls, пожалуйста, сначала сохраните как Xlsx в Excel',
    // TODO: 2023-11-24
    设为主图: 'Установить как главное изображение',
    包邮: 'Бесплатная доставка',
    不包邮: 'Без бесплатной доставки',
    邮费: 'Почтовые расходы',
    减少: 'Уменьшить',
    增加: 'Увеличить',
    产品图文: 'Текст и изображения продукта',
    图文列表: 'Список текста и изображений',
    图文生成: 'Генерация текста и изображений',
    金豆记录: 'Записи золотых бобов',
    是否包邮: 'Бесплатная доставка',
    抠图图集: 'Альбом изображений с вырезкой',
    金豆变更: 'Изменение золотых бобов',
    选择产品型号: 'Выбрать модель продукта',
    预览图文: 'Предварительный просмотр текста и изображений',
    生成PDF: 'Сгенерировать PDF',
    '当前只可选择生成三级分类产品，若需生成完整产品图文，请先完善三级分类':
      'В настоящее время можно выбрать только генерацию продуктов третьего уровня классификации. Если необходимо сгенерировать полный текст и изображения продукта, пожалуйста, сначала завершите классификацию третьего уровня',
    生成请求已提交: 'Запрос на генерацию отправлен',
    可前往产品图文列表页查看进度:
      'Можно перейти на страницу списка текста и изображений продукта для просмотра прогресса',
    返回上页: 'Вернуться на предыдущую страницу',
    开始生成: 'Начать генерацию',
    重新生成: 'Перегенерировать',
    前往列表页: 'Перейти на страницу списка',
    金豆剩余: 'Остаток золотых бобов',
    消费类型: 'Тип потребления',
    消费金豆: 'Потребление золотых бобов',
    消费前: 'До потребления',
    消费后: 'После потребления',
    消费时间: 'Время потребления',
    请选择消费类型: 'Пожалуйста, выберите тип потребления',
    '您确定要对当前员工进行恢复？':
      'Вы уверены, что хотите восстановить текущего сотрудника?',
    金豆使用规则: 'Правила использования золотых бобов',
    // TODO: 2024-05-27
    长: 'Длина',
    厘米: 'Сантиметр',
    宽: 'Ширина',
    不能为空: 'Не может быть пустым',
    购买数量: 'Количество покупки',
    '预览（可根据买家采购的不同数量设置不同价格）':
      'Предварительный просмотр (можно установить разные цены в зависимости от разных количеств закупки покупателя)',
    可售数量: 'Количество для продажи',
    单品货号: 'Артикул единицы товара',
    是否上架: 'Выставить на продажу',
    上架店铺: 'Магазин для выставления',
    请选择店铺: 'Пожалуйста, выберите магазин',
    商品类目: 'Категория товаров',
    上一步: 'Предыдущий шаг',
    提交: 'Отправить',
    下一步: 'Следующий шаг',
    选择类目: 'Выбрать категорию',
    新增产品: 'Добавить продукт',
    修改产品: 'Изменить продукт',
    使用运费模版: 'Использовать шаблон доставки',
    运费指导模版: 'Шаблон руководства по доставке',
    卖家承担运费: 'Продавец оплачивает доставку',
    库存详情: 'Детали инвентаря',
    国内仓: 'Внутренний склад',
    荔枝角: 'Личжицзяо',
    深水埗: 'Шамшуйпо',
    '产品报价低于最低售价不可提交,请调整!':
      'Цена продукта ниже минимальной цены продажи, нельзя отправить, пожалуйста, скорректируйте!',
    '产品报价低于最低售价!': 'Цена продукта ниже минимальной цены продажи!',
    '产品报价高于最低采购价不可提交,请调整!':
      'Цена продукта выше минимальной закупочной цены, нельзя отправить, пожалуйста, скорректируйте!',
    '产品报价高于最低采购价!':
      'Цена продукта выше минимальной закупочной цены!',
    工单: 'Рабочий заказ',
    工序名称: 'Название операции',
    加工时长: 'Время обработки',
    默认仓库: 'Склад по умолчанию',
    '尺寸/规格': 'Размер/Спецификация',
    所述仓库: 'Упомянутый склад',
    绑定: 'Привязать',
    选择: 'Выбрать',
    运费: 'Стоимость доставки',
    '已更换产品，需重新打印标签贴标':
      'Продукт заменен, необходимо повторно распечатать этикетки',
    规格材质: 'Материал спецификации',
    '蓝色字体表示建议售价，绿色字体表示历史成交报价':
      'Синий шрифт означает рекомендуемую цену продажи, зеленый шрифт означает историческую цену сделки',
    建议采购价: 'Рекомендуемая закупочная цена',
    智能选择供应商: 'Интеллектуальный выбор поставщика',
    品规: 'Спецификация',
    '体积/净重/长-宽-高': 'Объем/Вес нетто/Длина-Ширина-Высота',
    盒规: 'Спецификация коробки',
    '您确定要对当前数据进行一键采购？':
      'Вы уверены, что хотите выполнить закупку одним кликом для текущих данных?',
    '您确定要对当前数据进行一键备货？':
      'Вы уверены, что хотите выполнить подготовку к отгрузке одним кликом для текущих данных?',
    '当前产品明细数据有未关联的产品请关联产品?':
      'В текущих детальных данных продукта есть несвязанные продукты, пожалуйста, свяжите продукты?',
    '您当前报价低于最低售价的价格，请修改！':
      'Ваша текущая цена ниже минимальной цены продажи, пожалуйста, измените!',
    箱单信息: 'Информация упаковочного листа',
    混装: 'Смешанная упаковка',
    添加箱子: 'Добавить коробку',
    请选择箱规: 'Пожалуйста, выберите спецификацию коробки',
    请选择箱号: 'Пожалуйста, выберите номер коробки',
    '支持产品名称/OEM码/编码搜索':
      'Поддерживает поиск по названию продукта/коду OEM/коду',
    降序: 'По убыванию',
    升序: 'По возрастанию',
    月结: 'Ежемесячный расчет',
    寄付: 'Оплата отправителем',
    到付: 'Оплата получателем',
    明天: 'Завтра',
    后天: 'Послезавтра',
    深水涉: 'Шамшуйшэ',
    待入库: 'Ожидает поступления на склад',
    在仓: 'На складе',
    上车: 'Погрузка',
    取消派件: 'Отменить отправку',
    发往客户: 'Отправить клиенту',
    已送达: 'Доставлено',
    元天屯: 'Юаньтянь',
    九龍: 'Коулун',
    新界: 'Новые территории',
    港島: 'Гонконгский остров',
    '離島/偏遠': 'Отдаленные острова/регионы',
    九東: 'Восточный Коулун',
    港東: 'Восточный Гонконг',
    客户账单: 'Счет клиента',
    供应商账单: 'Счет поставщика',
    运营报表: 'Отчет по операциям',
    产品面板: 'Панель продукта',
    电商产品: 'Продукты электронной коммерции',
    报价单表: 'Таблица коммерческих предложений',
    产品图册: 'Каталог продуктов',
    产品箱规: 'Спецификация упаковки продукта',
    私有线索: 'Частные потенциальные клиенты',
    公海线索: 'Общие потенциальные клиенты',
    销售面板: 'Панель продаж',
    抖音订单: 'Заказы Douyin',
    营销: 'Маркетинг',
    我方渠道: 'Наши каналы',
    竞对渠道: 'Конкурентные каналы',
    我方店铺: 'Наши магазины',
    竞对店铺: 'Конкурентные магазины',
    渠道类型: 'Тип канала',
    对账列表: 'Список сверки',
    账单明细: 'Детали счета',
    '发货单(家具)': 'Накладная на отгрузку (мебель)',
    '派货行程(家具)': 'Маршрут доставки (мебель)',
    今日计划: 'План на сегодня',
    收货单: 'Приходная накладная',
    商品代发: 'Дропшиппинг товаров',
    商品退货: 'Возврат товаров',
    商品索赔: 'Претензии по товарам',
    '库存余额(家具)': 'Остаток запасов (мебель)',
    快递寄件: 'Экспресс-отправка',
    收费标准: 'Стандарты收費',
    工厂: 'Фабрика',
    生产计划: 'План производства',
    生产工单: 'Производственный заказ',
    委外管理: 'Управление аутсорсингом',
    委外订单: 'Заказ на аутсорсинг',
    整单委外: 'Полный заказ на аутсорсинг',
    工序委外: 'Аутсорсинг операций',
    生产执行: 'Исполнение производства',
    生产工序: 'Производственные операции',
    报工单: 'Отчет о выполнении работ',
    物料管理: 'Управление материалами',
    领料单: 'Накладная на получение материалов',
    退料单: 'Накладная на возврат материалов',
    质量管理: 'Управление качеством',
    工序质检: 'Контроль качества операций',
    委外质检: 'Контроль качества аутсорсинга',
    BOM管理: 'Управление BOM',
    产品BOM: 'BOM продукта',
    BOM清单: 'Спецификация BOM',
    工序工艺: 'Технология операций',
    工艺: 'Технология',
    工序: 'Операция',
    设备列表: 'Список оборудования',
    设备类型: 'Тип оборудования',
    三方应用: 'Сторонние приложения',
    硬件配置: 'Конфигурация оборудования',
    费用记录: 'Записи расходов',
    仓储体积: 'Объем хранения',
    导出记录: 'Экспорт записей',
    是否KP: 'Является ли KP',
    起订量: 'Минимальный заказ',
    部件备注: 'Примечание к компоненту',
    原产地: 'Страна происхождения',
    产品评分: 'Рейтинг продукта',
    供应链评分: 'Рейтинг цепочки поставок',
    账期客户: 'Клиенты с отсрочкой платежа',
    感兴趣产品: 'Интересующие продукты',
    客户折扣: 'Скидка клиента',
    采购类型: 'Тип закупки',
    线索名称: 'Название потенциального клиента',
    线索来源: 'Источник потенциального клиента',
    线索阶段: 'Этап потенциального клиента',
    线索编码: 'Код потенциального клиента',
    客户地址: 'Адрес клиента',
    客户区域: 'Регион клиента',
    产品类别: 'Категория продукта',
    订单备注: 'Примечание к заказу',
    后台备注: 'Примечание в бэкенде',
    送货日期: 'Дата доставки',
    选择日期: 'Выбрать дату',
    是否账期: 'Отсрочка платежа',
    关联订单号: 'Связанный номер заказа',
    订单支付状态: 'Статус оплаты заказа',
    配送方式: 'Способ доставки',
    收件电话: 'Телефон получателя',
    收件地址: 'Адрес получателя',
    快递单号: 'Номер экспресс-накладной',
    收货人信息: 'Информация о получателе',
    所在州: 'Штат',
    运输保险: 'Страховка перевозки',
    货品价值: 'Стоимость товара',
    签收选项: 'Опции получения',
    寄件人信息: 'Информация об отправителе',
    商品体积: 'Объем товара',
    商品重量: 'Вес товара',
    商品货值: 'Стоимость товара',
    快递费用: 'Стоимость экспресс-доставки',
    包裹信息: 'Информация о посылке',
    '长(in)': 'Длина (дюймы)',
    '宽(in)': 'Ширина (дюймы)',
    '高(in)': 'Высота (дюймы)',
    '重量(lb)': 'Вес (фунты)',
    计算费用: 'Рассчитать стоимость',
    快递公司: 'Экспресс-компания',
    快递面签: 'Экспресс-подпись',
    预约日期: 'Дата预约',
    预约时间: 'Время预约',
    退货照片: 'Фото возврата',
    外观照片: 'Фото внешнего вида',
    拆开照片: 'Фото после вскрытия',
    处理方式: 'Способ обработки',
    退货进度: 'Прогресс возврата',
    索赔结果: 'Результат претензии',
    订单截图: 'Скриншот заказа',
    证明图片: 'Подтверждающие изображения',
    适用产品: 'Применимые продукты',
    版本号: 'Номер версии',
    计划单号: 'Номер плана',
    生产类型: 'Тип производства',
    计划生产数量: 'Планируемое количество производства',
    计划开工日期: 'Планируемая дата начала работ',
    计划完工日期: 'Планируемая дата завершения',
    生产产品: 'Производимый продукт',
    生产批次号: 'Номер производственной партии',
    生产单号: 'Номер производственного заказа',
    生产状态: 'Статус производства',
    延期情况: 'Ситуация с задержкой',
    委外状态: 'Статус аутсорсинга',
    入库日期: 'Дата поступления на склад',
    排产人: 'Планировщик производства',
    生产完成率: 'Процент завершения производства',
    已完工数量: 'Количество завершенных',
    待入库数量: 'Количество ожидающих поступления на склад',
    已入库数量: 'Количество поступивших на склад',
    工序计划数量: 'Планируемое количество операций',
    工序完工数量: 'Количество завершенных операций',
    报废数: 'Количество брака',
    返工数: 'Количество переделок',
    总生产成本: 'Общая стоимость производства',
    加工成本: 'Стоимость обработки',
    物料成本: 'Стоимость материалов',
    委外编号: 'Номер аутсорсинга',
    委外供应商: 'Поставщик аутсорсинга',
    委外类型: 'Тип аутсорсинга',
    委外产品: 'Продукт аутсорсинга',
    委外数量: 'Количество аутсорсинга',
    委外单价: 'Цена единицы аутсорсинга',
    委外日期: 'Дата аутсорсинга',
    委外总额: 'Общая сумма аутсорсинга',
    委外应付总额: 'Общая сумма к оплате по аутсорсингу',
    委外已付总额: 'Общая сумма оплаченная по аутсорсингу',
    已退货数量: 'Количество возвращенных',
    质检不合格数量: 'Количество не прошедших контроль качества',
    质检合格率: 'Процент прошедших контроль качества',
    工序编号: 'Номер операции',
    工序状态: 'Статус операции',
    执行工序: 'Выполнение операции',
    工艺路线: 'Технологический маршрут',
    工序执行人: 'Исполнитель операции',
    工序计划生产数: 'Планируемое количество производства операции',
    实际完工日期: 'Фактическая дата завершения',
    待完工数量: 'Количество ожидающих завершения',
    完工良品数: 'Количество качественных завершенных',
    完工良品率: 'Процент качественных завершенных',
    工序完成率: 'Процент завершения операции',
    返工数量: 'Количество переделок',
    返工率: 'Процент переделок',
    报废数量: 'Количество брака',
    报废率: 'Процент брака',
    报工单编号: 'Номер отчета о выполнении работ',
    生产数量: 'Количество производства',
    生产人员: 'Производственный персонал',
    报工日期: 'Дата отчета о выполнении работ',
    质检状态: 'Статус контроля качества',
    良品数量: 'Количество качественных',
    生产工资: 'Заработная плата производства',
    工序单价: 'Цена единицы операции',
    问题描述: 'Описание проблемы',
    问题图片: 'Изображения проблемы',
    物料申请单号: 'Номер заявки на материалы',
    审批状态: 'Статус审批',
    申请人: 'Заявитель',
    申请时间: 'Время申请а',
    委外工单: 'Заказ на аутсорсинг работ',
    设备名称: 'Название оборудования',
    设备编码: 'Код оборудования',
    设备型号: 'Модель оборудования',
    外观尺寸: 'Габаритные размеры',
    设备用途: 'Назначение оборудования',
    管理负责人: 'Ответственный за управление',
    投产日期: 'Дата ввода в эксплуатацию',
    采购日期: 'Дата закупки',
    生产日期: 'Дата производства',
    生产厂家: 'Производитель',
    用途: 'Назначение',
    设备图集: 'Альбом изображений оборудования',
    请输入OEM码多个: 'Пожалуйста, введите несколько кодов OEM',
    分割: 'Разделение',
    请选择产品类别: 'Пожалуйста, выберите категорию продукта',
    是否关键产品: 'Ключевой продукт',
    请选择原产地: 'Пожалуйста, выберите страну происхождения',
    请输入部件备注: 'Пожалуйста, введите примечание к компоненту',
    箱规信息已移至详情页面添加编辑:
      'Информация о спецификации коробки перемещена на страницу деталей для добавления и редактирования',
    产品规格: 'Спецификация продукта',
    复制产品: 'Копировать продукт',
    图片设计: 'Дизайн изображений',
    箱规类型: 'Тип спецификации коробки',
    请选择箱规类型: 'Пожалуйста, выберите тип спецификации коробки',
    请输入产品数量: 'Пожалуйста, введите количество продукта',
    可以容纳的产品个数: 'Количество продуктов, которые можно разместить',
    默认箱规: 'Спецификация коробки по умолчанию',
    费用箱规: 'Спецификация коробки для расчета стоимости',
    计算货品体积费用时的箱规:
      'Спецификация коробки при расчете стоимости объема товара',
    '长(cm)': 'Длина (см)',
    请输入箱规长: 'Пожалуйста, введите длину спецификации коробки',
    '宽(cm)': 'Ширина (см)',
    请输入箱规宽: 'Пожалуйста, введите ширину спецификации коробки',
    '高(cm)': 'Высота (см)',
    请输入箱规高: 'Пожалуйста, введите высоту спецификации коробки',
    请输入箱规重量: 'Пожалуйста, введите вес спецификации коробки',
    请输入箱规体积: 'Пожалуйста, введите объем спецификации коробки',
    所属分类: 'Принадлежащая категория',
    请选择所属分类: 'Пожалуйста, выберите принадлежащую категорию',
    '用于生成电商网站的链接,可不填写':
      'Ссылка для генерации интернет-магазина, можно не заполнять',
    图册: 'Каталог',
    文件请到附件中上传: 'Файл, пожалуйста, загрузите во вложения',
    产品id: 'ID продукта',
    渠道名称: 'Название канала',
    请选择渠道名称: 'Пожалуйста, выберите название канала',
    请输入链接地址: 'Пожалуйста, введите адрес ссылки',
    请输入销售价格: 'Пожалуйста, введите цену продажи',
    售出产品数: 'Количество проданных продуктов',
    请输入售出产品数量: 'Пожалуйста, введите количество проданных продуктов',
    拉取三方店铺商品: 'Получить товары сторонних магазинов',
    拉取三方店铺订单: 'Получить заказы сторонних магазинов',
    三方店铺: 'Сторонние магазины',
    请选择三方店铺: 'Пожалуйста, выберите сторонний магазин',
    拉取: 'Получить',
    当前快递单号为: 'Текущий номер экспресс-накладной',
    下单成功: 'Заказ успешно оформлен',
    保存并打印: 'Сохранить и распечатать',
    请输入订单号: 'Пожалуйста, введите номер заказа',
    客户信息: 'Информация о клиенте',
    智能填写: 'Интеллектуальное заполнение',
    '粘贴收货信息到此处，将自动识别姓名/电话/地址':
      'Вставьте информацию о получении сюда, система автоматически распознает имя/телефон/адрес',
    客户电话: 'Телефон клиента',
    请输入客户电话: 'Пожалуйста, введите телефон клиента',
    已存在客户: 'Клиент уже существует',
    '是否使用当前客户信息？': 'Использовать текущую информацию о клиенте?',
    客户姓名: 'Имя клиента',
    请输入客户姓名: 'Пожалуйста, введите имя клиента',
    收货地址: 'Адрес получения',
    请输入收货地址: 'Пожалуйста, введите адрес получения',
    销售点: 'Точка продаж',
    请选择销售点: 'Пожалуйста, выберите точку продаж',
    付款信息: 'Информация об оплате',
    是否已付款: 'Оплачено',
    '您的报价产品中有低于最低售价的价格，请检查！':
      'В ваших коммерческих предложениях есть цены ниже минимальной цены продажи, пожалуйста, проверьте!',
    线索: 'Потенциальный клиент',
    国家地区: 'Страна/регион',
    请输入客户感兴趣产品: 'Пожалуйста, введите продукты, интересующие клиента',
    是否KA: 'Является ли KA',
    请输入客户网址: 'Пожалуйста, введите веб-сайт клиента',
    请输入客户地区: 'Пожалуйста, введите регион клиента',
    请输入客户折扣百分比: 'Пожалуйста, введите процент скидки клиента',
    请输入比分比: 'Пожалуйста, введите соотношение',
    请选择线索阶段: 'Пожалуйста, выберите этап потенциального клиента',
    请输入收件人: 'Пожалуйста, введите получателя',
    请输入收件电话: 'Пожалуйста, введите телефон получателя',
    请输入收件地址: 'Пожалуйста, введите адрес получателя',
    请选择渠道类型: 'Пожалуйста, выберите тип канала',
    渠道分类: 'Классификация каналов',
    请选择渠道分类: 'Пожалуйста, выберите классификацию каналов',
    快递账号: 'Аккаунт экспресс-доставки',
    请选择快递账号: 'Пожалуйста, выберите аккаунт экспресс-доставки',
    系统配置: 'Конфигурация системы',
    快递账号配置: 'Конфигурация аккаунта экспресс-доставки',
    中添加: 'Добавить в',
    请输入采购单单号: 'Пожалуйста, введите номер заказа на закупку',
    账期: 'Отсрочка платежа',
    添加付款明细: 'Добавить детали платежа',
    请输入昵称: 'Пожалуйста, введите псевдоним',
    密码为手机号后六位: 'Пароль - последние шесть цифр номера телефона',
    请选择部门: 'Пожалуйста, выберите отдел',
    供应商账号: 'Аккаунт поставщика',
    关联供应商: 'Связанный поставщик',
    入库预报: 'Прогноз поступления на склад',
    请选择配送方式: 'Пожалуйста, выберите способ доставки',
    交货时间: 'Время доставки',
    收货人姓名: 'Имя получателя',
    请输入收货人姓名: 'Пожалуйста, введите имя получателя',
    收货人电话: 'Телефон получателя',
    请输入收货人电话: 'Пожалуйста, введите телефон получателя',
    收货人邮箱: 'Email получателя',
    请输入收货人邮箱: 'Пожалуйста, введите email получателя',
    收货人地址: 'Адрес получателя',
    请输入收货人地址: 'Пожалуйста, введите адрес получателя',
    请输入城市: 'Пожалуйста, введите город',
    州: 'Штат',
    请输入州: 'Пожалуйста, введите штат',
    请选择国家: 'Пожалуйста, выберите страну',
    请输入邮编: 'Пожалуйста, введите почтовый индекс',
    请输入包装要求: 'Пожалуйста, введите требования к упаковке',
    寄件人: 'Отправитель',
    请选择寄件人信息: 'Пожалуйста, выберите информацию об отправителе',
    请选择签收选项: 'Пожалуйста, выберите опции получения',
    请选择运输保险: 'Пожалуйста, выберите страховку перевозки',
    商品代发单: 'Накладная на дропшиппинг товаров',
    快递索赔单: 'Накладная на претензии экспресс-доставки',
    商品退货单: 'Накладная на возврат товаров',
    请输入快递单号: 'Пожалуйста, введите номер экспресс-накладной',
    请选择处理方式: 'Пожалуйста, выберите способ обработки',
    将收取一定的费用: 'Будет взиматься определенная плата',
    请输入备注信息: 'Пожалуйста, введите примечание',
    '退货拍照(拆开)': 'Фото возврата (вскрытое)',
    '退货拍照(外观)': 'Фото возврата (внешний вид)',
    提交后将会通知供货商: 'После отправки будет уведомлен поставщик',
    选择处理方式: 'Выбрать способ обработки',
    处理费用: 'Стоимость обработки',
    请输入处理费用: 'Пожалуйста, введите стоимость обработки',
    商品快递索赔: 'Претензия по экспресс-доставке товаров',
    请输入货品价值: 'Пожалуйста, введите стоимость товара',
    请输入索赔原因: 'Пожалуйста, введите причину претензии',
    结果: 'Результат',
    请选择结果: 'Пожалуйста, выберите результат',
    请输入费用: 'Пожалуйста, введите стоимость',
    三方发货: 'Отправка через сторонние сервисы',
    多个用英文逗号隔开: 'Несколько, разделенные английской запятой',
    等: 'и т.д.',
    件产品: 'единиц продукта',
    请选择发货计划: 'Пожалуйста, выберите план отгрузки',
    收件人信息: 'Информация о получателе',
    收件人姓名: 'Имя получателя',
    请输入收件人姓名: 'Пожалуйста, введите имя получателя',
    收件人手机号: 'Номер телефона получателя',
    请输入收件人手机号: 'Пожалуйста, введите номер телефона получателя',
    收件人地址: 'Адрес получателя',
    请输入收件人地址: 'Пожалуйста, введите адрес получателя',
    省市区县街道: 'Провинция/город/район/улица',
    快捷选择寄件人信息: 'Быстрый выбор информации об отправителе',
    更多快捷寄件人信息请到:
      'Для получения дополнительной информации об отправителе перейдите в',
    发货地址: 'Адрес отправки',
    寄件人姓名: 'Имя отправителя',
    请输入寄件人姓名: 'Пожалуйста, введите имя отправителя',
    寄件人手机号: 'Номер телефона отправителя',
    请输入寄件人手机号: 'Пожалуйста, введите номер телефона отправителя',
    寄件人地址: 'Адрес отправителя',
    请输入寄件人地址: 'Пожалуйста, введите адрес отправителя',
    快递信息: 'Информация об экспресс-доставке',
    请选择快递公司: 'Пожалуйста, выберите экспресс-компанию',
    物品名称: 'Название предмета',
    请输入物品名称: 'Пожалуйста, введите название предмета',
    支付方式: 'Способ оплаты',
    请选择支付方式: 'Пожалуйста, выберите способ оплаты',
    '物品总重量(Kg)': 'Общий вес предметов (кг)',
    请输入物品总重量: 'Пожалуйста, введите общий вес предметов',
    无需单位: 'Без единиц измерения',
    寄件: 'Отправить',
    '下单中...': 'Оформление заказа...',
    立即打印面单: 'Немедленно распечатать накладную',
    打印机: 'Принтер',
    请选择打印机: 'Пожалуйста, выберите принтер',
    快递配置: 'Конфигурация экспресс-доставки',
    请选择快递配置: 'Пожалуйста, выберите конфигурацию экспресс-доставки',
    请选择委外订单: 'Пожалуйста, выберите заказ на аутсорсинг',
    请输入产品名: 'Пожалуйста, введите название продукта',
    名片: 'Визитная карточка',
    是否固定: 'Фиксированный',
    默认排序: 'Сортировка по умолчанию',
    排序方式: 'Способ сортировки',
    设置默认排序字段: 'Установить поле сортировки по умолчанию',
    请输入HSCODE: 'Пожалуйста, введите HSCODE',
    别名: 'Псевдоним',
    '请输入别名,多个用英文逗号隔开':
      'Пожалуйста, введите псевдонимы, несколько через английскую запятую',
    销售渠道: 'Каналы продаж',
    推广渠道: 'Каналы продвижения',
    关联店铺: 'Связанный магазин',
    请选择关联店铺: 'Пожалуйста, выберите связанный магазин',
    请输入渠道名称: 'Пожалуйста, введите название канала',
    快速调价: 'Быстрая корректировка цен',
    当前修改影响: 'Текущие изменения влияют на',
    '条数据,总价': 'записей данных, общая стоимость',
    '是否继续修改?': 'Продолжить изменения?',
    新购产品按建议价格: 'Новые покупки по рекомендуемой цене',
    请输入倍率: 'Пожалуйста, введите коэффициент',
    倍调价: 'Корректировка цен по коэффициенту',
    复购产品按历史底价: 'Повторные покупки по историческим минимальным ценам',
    所有产品按当前价格: 'Все продукты по текущим ценам',
    打印模版: 'Шаблон печати',
    硬件设备: 'Оборудование',
    购买打印机: 'Купить принтер',
    飞鹅云标签打印机: 'Облачный принтер этикеток Feie',
    佳博云标签打印机: 'Облачный принтер этикеток Gabor',
    SN编码: 'Код SN',
    请输入SN编码: 'Пожалуйста, введите код SN',
    是否默认: 'По умолчанию',
    '标签纸长(mm)': 'Длина этикеточной бумаги (мм)',
    请输入标签纸长度: 'Пожалуйста, введите длину этикеточной бумаги',
    '标签纸宽(mm)': 'Ширина этикеточной бумаги (мм)',
    请输入标签纸宽度: 'Пожалуйста, введите ширину этикеточной бумаги',
    模本内容: 'Содержание шаблона',
    请输入模本内容: 'Пожалуйста, введите содержание шаблона',
    缩略图: 'Миниатюра',
    最大打印宽度: 'Максимальная ширина печати',
    购买: 'Купить',
    打印标签: 'Распечатать этикетки',
    请选择设备: 'Пожалуйста, выберите оборудование',
    请选择打印模版: 'Пожалуйста, выберите шаблон печати',
    请输入打印数量: 'Пожалуйста, введите количество печати',
    请输入寄件人: 'Пожалуйста, введите отправителя',
    寄件人电话: 'Телефон отправителя',
    请输入寄件人电话: 'Пожалуйста, введите телефон отправителя',
    寄件人邮箱: 'Email отправителя',
    请输入寄件人邮箱: 'Пожалуйста, введите email отправителя',
    寄件地址: 'Адрес отправки',
    请输入寄件地址: 'Пожалуйста, введите адрес отправки',
    默认地址: 'Адрес по умолчанию',
    费用变更: 'Изменение стоимости',
    费用方式: 'Способ расчета стоимости',
    费用类型: 'Тип стоимости',
    请选择费用类型: 'Пожалуйста, выберите тип стоимости',
    请输入金额: 'Пожалуйста, введите сумму',
    请输入文件名称: 'Пожалуйста, введите название файла',
    来源链接: 'Исходная ссылка',
    请输入网页来源链接: 'Пожалуйста, введите исходную ссылку веб-страницы',
    更换产品: 'Заменить продукт',
    更换的产品: 'Замененные продукты',
    名称备注: 'Примечание к названию',
    请输入菜单名称备注: 'Пожалуйста, введите примечание к названию меню',
    是否显示PC: 'Отображать на ПК',
    是否显示移动端: 'Отображать на мобильных устройствах',
    请输入token: 'Пожалуйста, введите token',
    征收比例: 'Процент сбора',
    快递费用征收比例: 'Процент сбора экспресс-доставки',
    请输入比例: 'Пожалуйста, введите соотношение',
    请选择版本号: 'Пожалуйста, выберите номер версии',
    用量: 'Расход',
    请输入用量: 'Пожалуйста, введите расход',
    损耗率: 'Процент потерь',
    请输入损耗率: 'Пожалуйста, введите процент потерь',
    物料BOM: 'BOM материалов',
    请选择物料BOM: 'Пожалуйста, выберите BOM материалов',
    请输入单位: 'Пожалуйста, введите единицу измерения',
    请输入单价: 'Пожалуйста, введите цену за единицу',
    时长: 'Продолжительность',
    请输入加工时长: 'Пожалуйста, введите время обработки',
    是否质检: 'Контроль качества',
    请输入工序描述: 'Пожалуйста, введите описание операции',
    请选择生产类型: 'Пожалуйста, выберите тип производства',
    请选择订单: 'Пожалуйста, выберите заказ',
    请选择产品BOM: 'Пожалуйста, выберите BOM продукта',
    请选择生产优先级: 'Пожалуйста, выберите приоритет производства',
    请输入交货日期: 'Пожалуйста, введите дату доставки',
    请输入计划开工日期: 'Пожалуйста, введите планируемую дату начала работ',
    请输入计划完工日期: 'Пожалуйста, введите плановую дату завершения',
    请输入生产批次号: 'Пожалуйста, введите номер производственной партии',
    委外工序: 'Внешние операции',
    请选择生产状态: 'Пожалуйста, выберите статус производства',
    请选择生产计划: 'Пожалуйста, выберите производственный план',
    生产订单: 'Производственный заказ',
    请选择生产订单: 'Пожалуйста, выберите производственный заказ',
    请选择执行工序: 'Пожалуйста, выберите выполняемую операцию',
    请选择委外工序: 'Пожалуйста, выберите внешние операции',
    生产需求: 'Производственная потребность',
    请选择生产需求: 'Пожалуйста, выберите производственную потребность',
    请选择产品工艺: 'Пожалуйста, выберите технологию продукта',
    请输入委外数量: 'Пожалуйста, введите количество на аутсорсинг',
    请输入计划生产数量: 'Пожалуйста, введите плановое количество производства',
    请输入委外单价: 'Пожалуйста, введите цену за единицу на аутсорсинг',
    请选择计划开工日期: 'Пожалуйста, выберите плановую дату начала работы',
    请选择委外日期: 'Пожалуйста, выберите дату аутсорсинга',
    请选择计划完工日期: 'Пожалуйста, выберите плановую дату завершения',
    '请搜索/选择负责人': 'Пожалуйста, найдите/выберите ответственного',
    请选择生产工单: 'Пожалуйста, выберите производственный наряд',
    产品工艺: 'Технология продукта',
    请选择工序执行人: 'Пожалуйста, выберите исполнителя операции',
    '请搜索/选择工序执行人':
      'Пожалуйста, найдите/выберите исполнителя операции',
    请输入生产数量: 'Пожалуйста, введите количество производства',
    请选择生产人员: 'Пожалуйста, выберите производственный персонал',
    '请搜索/选择生产人员':
      'Пожалуйста, найдите/выберите производственный персонал',
    请选择报工日期: 'Пожалуйста, выберите дату отчета о работе',
    质检数量: 'Количество контроля качества',
    请输入质检数量: 'Пожалуйста, введите количество контроля качества',
    请输入入库数量: 'Пожалуйста, введите количество на склад',
    质检: 'Контроль качества',
    请输入报废数量: 'Пожалуйста, введите количество брака',
    请输入返工数量: 'Пожалуйста, введите количество переделки',
    请输入良品数量: 'Пожалуйста, введите количество годной продукции',
    请输入问题描述: 'Пожалуйста, введите описание проблемы',
    类别: 'Категория',
    请选择申请人: 'Пожалуйста, выберите заявителя',
    请选择关联领料单: 'Пожалуйста, выберите связанную заявку на материалы',
    服务商: 'Сервис-провайдер',
    请选择快递服务商: 'Пожалуйста, выберите экспресс-сервис провайдера',
    月结号: 'Номер месячного расчета',
    请输入月结号: 'Пожалуйста, введите номер месячного расчета',
    添加快递信息: 'Добавить информацию о доставке',
    选择香港仓库: 'Выбрать склад в Гонконге',
    选择仓库: 'Выбрать склад',
    选择发货时间及司机: 'Выбрать время отправки и водителя',
    司机: 'Водитель',
    请选择司机: 'Пожалуйста, выберите водителя',
    '请搜索/选择司机': 'Пожалуйста, найдите/выберите водителя',
    请选择发货日期: 'Пожалуйста, выберите дату отправки',
    上门时间: 'Время выезда на место',
    截止时间: 'Крайний срок',
    更改区域: 'Изменить регион',
    区域: 'Регион',
    请选择区域: 'Пожалуйста, выберите регион',
    shopify店铺: 'Магазин Shopify',
    店铺名: 'Название магазина',
    请输入shopify店铺名: 'Пожалуйста, введите название магазина Shopify',
    请输入店铺名: 'Пожалуйста, введите название магазина',
    请输入access: 'Пожалуйста, введите доступ',
    请输入app: 'Пожалуйста, введите приложение',
    对账明细: 'Детали сверки',
    请输入日期: 'Пожалуйста, введите дату',
    生产设备: 'Производственное оборудование',
    请输入设备名称: 'Пожалуйста, введите название оборудования',
    请选择设备类型: 'Пожалуйста, выберите тип оборудования',
    请输入设备编码SN: 'Пожалуйста, введите серийный номер оборудования',
    请输入设备型号: 'Пожалуйста, введите модель оборудования',
    请输入长度: 'Пожалуйста, введите длину',
    请输入宽度: 'Пожалуйста, введите ширину',
    请输入高度: 'Пожалуйста, введите высоту',
    请选择采购日期: 'Пожалуйста, выберите дату закупки',
    请选择投产日期: 'Пожалуйста, выберите дату запуска в производство',
    请输入采购价格: 'Пожалуйста, введите цену закупки',
    采购币种: 'Валюта закупки',
    请输入生产厂家: 'Пожалуйста, введите производителя',
    请选择生产日期: 'Пожалуйста, выберите дату производства',
    请输入用途: 'Пожалуйста, введите назначение',
    发货: 'Отправка',
    同步发货状态: 'Синхронизировать статус отправки',
    行: 'Строка',
    请输入行: 'Пожалуйста, введите строку',
    请输入子仓库行数: 'Пожалуйста, введите количество строк подсклада',
    列: 'Столбец',
    请输入列: 'Пожалуйста, введите столбец',
    请输入子仓库列数: 'Пожалуйста, введите количество столбцов подсклада',
    子仓库数量不能超过: 'Количество подскладов не может превышать',
    个: 'шт.',
    新增仓库: 'Добавить склад',
    '请搜索/选择产品': 'Пожалуйста, найдите/выберите продукт',
    '请搜索/选择创建人': 'Пожалуйста, найдите/выберите создателя',
    编辑人: 'Редактор',
    '请搜索/选择最后编辑人':
      'Пожалуйста, найдите/выберите последнего редактора',
    '请搜索/选择供应商': 'Пожалуйста, найдите/выберите поставщика',
    请输入价格: 'Пожалуйста, введите цену',
    请选择委外状态: 'Пожалуйста, выберите статус аутсорсинга',
    请选择工序状态: 'Пожалуйста, выберите статус операции',
    店铺: 'Магазин',
    关联状态: 'Статус связи',
    请选择关联状态: 'Пожалуйста, выберите статус связи',
    未关联: 'Не связано',
    已关联: 'Связано',
    面单模板: 'Шаблон накладной',
    请选择电子面单模板: 'Пожалуйста, выберите шаблон электронной накладной',
    打印类型: 'Тип печати',
    请选择打印类型: 'Пожалуйста, выберите тип печати',
    只下单不打印: 'Только заказ, без печати',
    生成图片短链: 'Сгенерировать короткую ссылку на изображение',
    快递: 'Экспресс-доставка',
    云打印机: 'Облачный принтер',
    生成html短链: 'Сгенерировать короткую HTML-ссылку',
    '请搜索/选择客户来源': 'Пожалуйста, найдите/выберите источник клиента',
    '请搜索/选择销售点': 'Пожалуйста, найдите/выберите точку продаж',
    货物状态: 'Статус груза',
    请选择货物状态: 'Пожалуйста, выберите статус груза',
    '请搜索/选择客户': 'Пожалуйста, найдите/выберите клиента',
    请选择账期日期: 'Пожалуйста, выберите дату расчетного периода',
    账期类型: 'Тип расчетного периода',
    请选择账期类型: 'Пожалуйста, выберите тип расчетного периода',
    '产品编码/名称关键字': 'Ключевые слова кода/названия продукта',
    '輸入產品/單號/手機': 'Введите продукт/номер заказа/телефон',
    请选择数据权限: 'Пожалуйста, выберите права доступа к данным',
    '请搜索/选择渠道名称': 'Пожалуйста, найдите/выберите название канала',
    '请搜索/选择产品分类': 'Пожалуйста, найдите/выберите категорию продукта',
    '请搜索/选择部件': 'Пожалуйста, найдите/выберите компонент',
    '请搜索/选择产品货源':
      'Пожалуйста, найдите/выберите источник поставки продукта',
    '请搜索/选择产品上下架状态':
      'Пожалуйста, найдите/выберите статус выставления продукта на продажу',
    请选择客户类型: 'Пожалуйста, выберите тип клиента',
    '请搜索/选择客户等级': 'Пожалуйста, найдите/выберите уровень клиента',
    '请搜索/选择客户行业': 'Пожалуйста, найдите/выберите отрасль клиента',
    请输入感兴趣的产品: 'Пожалуйста, введите интересующие продукты',
    线索状态: 'Статус лида',
    请选择线索状态: 'Пожалуйста, выберите статус лида',
    '名称/单号/关键词': 'Название/номер заказа/ключевые слова',
    请选择计划日期: 'Пожалуйста, выберите плановую дату',
    '请搜索/选择业务员': 'Пожалуйста, найдите/выберите менеджера',
    退货状态: 'Статус возврата',
    请选择退货状态: 'Пожалуйста, выберите статус возврата',
    '请搜索/选择渠道': 'Пожалуйста, найдите/выберите канал',
    '请搜索/选择渠道类型': 'Пожалуйста, найдите/выберите тип канала',
    图册名称: 'Название альбома',
    请选择图册名称: 'Пожалуйста, выберите название альбома',
    '请输入编码/选择产品': 'Пожалуйста, введите код/выберите продукт',
    请选择在仓状态: 'Пожалуйста, выберите статус на складе',
    服务器正在升级中: 'Сервер обновляется',
    '响应超时，请稍后再试': 'Тайм-аут ответа, пожалуйста, попробуйте позже',
    线索详情: 'Детали лида',
    导出明细: 'Экспорт деталей',
    客户产品: 'Продукты клиента',
    线索等级: 'Уровень лида',
    '您确定要将当前线索转化为客户吗？':
      'Вы уверены, что хотите преобразовать текущий лид в клиента?',
    '您确定要将当前线索释放发到公海吗？':
      'Вы уверены, что хотите освободить текущий лид в общую базу?',
    '您确定要领取当前线索？': 'Вы уверены, что хотите получить текущий лид?',
    分配线索: 'Распределить лиды',
    是否为负责人: 'Является ли ответственным',
    天成交单数: 'Количество сделок в день',
    天成交金额: 'Сумма сделок в день',
    客户评分: 'Рейтинг клиента',
    感兴趣的产品: 'Интересующие продукты',
    折扣: 'Скидка',
    最后下单时间: 'Время последнего заказа',
    生成账单: 'Сгенерировать счет',
    设备详情: 'Детали оборудования',
    充值记录: 'Записи пополнения',
    充值成功: 'Пополнение успешно',
    充值失败: 'Пополнение не удалось',
    充值金额: 'Сумма пополнения',
    充值状态: 'Статус пополнения',
    充值账户: 'Счет пополнения',
    充值时间: 'Время пополнения',
    物料: 'Материалы',
    可用库存: 'Доступный запас',
    所属BOM: 'Принадлежащий BOM',
    BOM详情: 'Детали BOM',
    清单明细: 'Детали списка',
    委外详情: 'Детали аутсорсинга',
    生成领料单: 'Сгенерировать заявку на материалы',
    退料单详情: 'Детали возврата материалов',
    领料单详情: 'Детали заявки на материалы',
    物料明细: 'Детали материалов',
    实际库存: 'Фактический запас',
    申请数量: 'Количество заявки',
    入库单: 'Приходная накладная',
    物料类型: 'Тип материала',
    分析结果: 'Результаты анализа',
    已生成采购计划: 'План закупок сгенерирован',
    未生成采购计划: 'План закупок не сгенерирован',
    所需用量: 'Требуемое количество',
    净需求: 'Чистая потребность',
    待采购数量: 'Количество к закупке',
    已采购入库数量: 'Количество закупленных и поступивших материалов',
    待申请物料数量: 'Количество материалов к заявке',
    已领料出库数量: 'Количество выданных материалов',
    已退料数量: 'Количество возвращенных материалов',
    待安排生产: 'Ожидает安排 производства',
    已安排生产: 'Производство安排ено',
    待安排委外: 'Ожидает安排 аутсорсинга',
    已生产数量: 'Произведенное количество',
    '您确定要对当前数据生成采购计划？':
      'Вы уверены, что хотите сгенерировать план закупок для текущих данных?',
    生产工单详情: 'Детали производственного наряда',
    '您确定要对当前数据预生成工序？':
      'Вы уверены, что хотите предварительно сгенерировать операции для текущих данных?',
    '您确定要对当前数据预生成入库单？':
      'Вы уверены, что хотите предварительно сгенерировать приходную накладную для текущих данных?',
    需求物料: 'Необходимые материалы',
    生产计划详情: 'Детали производственного плана',
    '您确定要生成物料需求清单？':
      'Вы уверены, что хотите сгенерировать список потребности в материалах?',
    生产概览: 'Обзор производства',
    生产工序详情: 'Детали производственных операций',
    报工单详情: 'Детали отчета о работе',
    工序号: 'Номер операции',
    完工数量: 'Количество завершенных',
    请先选择工序执行人: 'Пожалуйста, сначала выберите исполнителя операции',
    '您确定要开始当前工序？': 'Вы уверены, что хотите начать текущую операцию?',
    分配执行人: 'Назначить исполнителя',
    委外生产: 'Производство на аутсорсинге',
    质检详情: 'Детали контроля качества',
    质检明细: 'Детали инспекции качества',
    质检单号: 'Номер инспекции качества',
    质检类型: 'Тип инспекции качества',
    质检申请人: 'Заявитель инспекции качества',
    质检人: 'Инспектор качества',
    质检时间: 'Время инспекции качества',
    到货数量: 'Количество прибытия',
    工序详情: 'Детали операции',
    工艺详情: 'Детали технологии',
    工艺明细: 'Детали工艺流程',
    工序单位: 'Единица операции',
    工序负责人: 'Ответственный за операцию',
    工序编码: 'Код операции',
    回款渠道: 'Канал поступлений',
    对账单详情: 'Детали сверки',
    账期日期: 'Дата расчетного периода',
    当前欠款: 'Текущая задолженность',
    账单产品明细: 'Детали продуктов в счете',
    总计回款: 'Общая сумма поступлений',
    当前订单金额: 'Сумма текущего заказа',
    当前已付金额: 'Уже оплаченная сумма',
    '您确定要对当前数据重新生成对账单吗？':
      'Вы уверены, что хотите повторно сгенерировать сверку для текущих данных?',
    客户生成账单: 'Сгенерировать счет для клиента',
    供应商生成账单: 'Сгенерировать счет для поставщика',
    已付款: 'Оплачено',
    未付款: 'Не оплачено',
    已开票: 'Счет выставлен',
    未开票: 'Счет не выставлен',
    客户数量: 'Количество клиентов',
    客户渠道: 'Каналы клиентов',
    订单渠道: 'Каналы заказов',
    产品及供应链统计: 'Статистика продуктов и цепочки поставок',
    编辑产品: 'Редактировать продукт',
    新增供应链: 'Добавить цепочку поставок',
    KP资料不详细: 'Информация о KP не подробна',
    周新增数据: 'Новые данные за неделю',
    客户数据统计: 'Статистика данных клиентов',
    产品数据统计: 'Статистика данных продуктов',
    更新产品: 'Обновить продукт',
    KP供应链不足: 'Недостаточно цепочки поставок KP',
    '请输入手机号/邮箱': 'Пожалуйста, введите номер телефона/электронную почту',
    关联单号: 'Связанный номер',
    变更类型: 'Тип изменения',
    变更金额: 'Сумма изменения',
    变更前: 'До изменения',
    变更后: 'После изменения',
    变更时间: 'Время изменения',
    导出模块: 'Модуль экспорта',
    导出名称: 'Название экспорта',
    请选择导出模块: 'Пожалуйста, выберите модуль экспорта',
    仓储体积详情: 'Детали объема хранения',
    客户数: 'Количество клиентов',
    订单数: 'Количество заказов',
    渠道详情: 'Детали канала',
    关联产品: 'Связанные продукты',
    生成链接: 'Сгенерировать ссылку',
    发布商品: 'Опубликовать товар',
    请输入关键词搜索分类:
      'Пожалуйста, введите ключевые слова для поиска категории',
    售价: 'Цена продажи',
    '您确定要对当前产品更新到阿里巴巴？':
      'Вы уверены, что хотите обновить текущий продукт на Alibaba?',
    '净品规格的默认箱规将作为品规在列表展示，外箱规格的默认箱规将作为箱规在列表展示':
      'Стандартный размер упаковки для спецификации净品 будет отображаться как спецификация в списке, а стандартный размер упаковки для外箱规格 будет отображаться как размер упаковки в списке.',
    请输入箱规名称: 'Пожалуйста, введите название размера упаковки',
    请输入体积: 'Пожалуйста, введите объем',
    非默认箱规: 'Нестандартный размер упаковки',
    非费用箱规: 'Размер упаковки без费用',
    '体积/净重-毛重/长-宽-高': 'Объем/Вес нетто-Вес брутто/Длина-Ширина-Высота',
    图文详情: 'Графические подробности',
    查看价格策略: 'Просмотр ценовой стратегии',
    查看历史成交: 'Просмотреть историю сделок',
    渠道管理: 'Управление каналами',
    箱规管理: 'Управление размерами упаковки',
    应用渠道: 'Каналы применения',
    图片使用: 'Использование изображений',
    覆盖: 'Покрытие',
    追加: 'Добавить',
    继续: 'Продолжить',
    选择应用渠道: 'Выбор каналов применения',
    图册搜索: 'Поиск альбомов',
    页: 'Страница',
    图册上传: 'Загрузка альбомов',
    建议价格: 'Рекомендуемая цена',
    天销量: 'Объем продаж в день',
    所属仓库: 'Принадлежащий склад',
    渠道数量: 'Количество каналов',
    选择客户: 'Выбрать клиента',
    选择模板: 'Выбрать шаблон',
    若选择客户则会导出该客户关联模版信息:
      'Если выбрать клиента, будет экспортирована информация о шаблоне, связанном с этим клиентом',
    '为保证预览体验，当前仅展示最多':
      'Для обеспечения качества предварительного просмотра, в настоящее время отображается максимум',
    '条数据，点击': 'записей данных, нажмите',
    即可下载完整Excel数据: 'чтобы скачать полные данные Excel',
    店铺类型: 'Тип магазина',
    店铺名称: 'Название магазина',
    '您确定要发布当前产品?':
      'Вы уверены, что хотите опубликовать текущий продукт?',
    绑定产品: 'Привязать продукт',
    照片: 'Фото',
    关键字: 'Ключевые слова',
    网页: 'Веб-страница',
    页数: 'Количество страниц',
    EXW币种: 'Валюта EXW',
    FOB币种: 'Валюта FOB',
    网站: 'Веб-сайт',
    双击可编辑: 'Двойной клик для редактирования',
    自动上传: 'Автоматическая загрузка',
    '部分产品报价高于采购单价，是否确定要审核通过？':
      'Некоторые продукты имеют цену выше закупочной, действительно ли вы хотите подтвердить проверку?',
    请选择供货商: 'Пожалуйста, выберите поставщика',
    请输入包件编码: 'Пожалуйста, введите код посылки',
    请输入包件数量: 'Пожалуйста, введите количество посылок',
    请输入物流单号: 'Введите номер отслеживания посылки',
    厂商: 'Производитель',
    产品名: 'Название продукта',
    '规格/材质': 'Спецификация/Материал',
    备货产品: 'Резервная продукция',
    付款情况: 'Статус付款а',
    库存情况: 'Статус库存а',
    '您确定要对当前数据付款？操作后状态将会流转':
      'Вы уверены, что хотите оплатить текущие данные? После операции статус изменится',
    '您确定要对当前数据所有包裹确认收货？':
      'Вы уверены, что хотите подтвердить получение всех посылок текущих данных?',
    '您确定要对当前数据发往香港仓？':
      'Вы уверены, что хотите отправить текущие данные на склад в Гонконге?',
    '确认所有包裹已上车？':
      'Подтвердить, что все посылки загружены в транспорт?',
    包件编码: 'Код посылки',
    包件数量: 'Количество посылок',
    物流单号: 'Логистический номер',
    包裹状态: 'Статус посылки',
    最近下单时间: 'Время последнего заказа',
    包含数量: 'Включающее количество',
    请选择地址: 'Пожалуйста, выберите адрес',
    适用范围: 'Область применения',
    派送费用: 'Расходы на доставку',
    基础运价: 'Базовый тариф',
    体积比: 'Объемное соотношение',
    家庭地址费: 'Расходы на домашний адрес',
    '目的地若为家庭地址，则收取该费用':
      'Если назначение — домашний адрес, взимается данная плата.',
    偏远地区费: 'Расходы на отдаленные районы',
    '目的地邮编若在Fedex偏远地区清单中，则收取该费用':
      'Если почтовый индекс пункта назначения входит в список удаленных районов FedEx, взимается данная плата.',
    特殊处理费: 'Специальная обработка',
    产品实重: 'Вес продукции',
    磅: 'Фунт',
    包装: 'Упаковка',
    '满足以下任一条件，则收取该费用':
      'При соблюдении любого из следующих условий взимается данная плата',
    产品没有完全由外包装箱包装起来:
      'Продукт не полностью упакован во внешнюю тару',
    外包装由缠绕膜外包: 'Внешняя упаковка обернута пленкой',
    未使用纸箱包装: 'Не использовалась упаковка из картонной коробки',
    包装箱外形不是方形的: 'Форма упаковочного ящика не квадратная',
    尺寸: 'Размеры',
    最长边: 'Самая длинная сторона',
    英寸: 'Дюйм',
    次长边: 'Вторая по длине сторона',
    '最短边）': 'Самая короткая сторона)',
    英寸且: 'дюймов и',
    超标费: 'Превышение ставок',
    '产生超标费后，基础运价按实际重量，体积重和':
      'После возникновения платы за превышение, базовая тарифная ставка рассчитывается по фактическому весу, объёмному весу и',
    磅三者中最大者计费: 'максимальному значению из трех показателей в фунтах',
    用Fedex: 'Использование Fedex',
    Ground发货: 'Отправка Ground',
    '最短边）大于': 'Самая короткая сторона) больше',
    英寸且小于等于: 'дюймов и меньше или равно',
    最长边大于: 'Самая длинная сторона больше',
    Delivery发货: 'Отправка Delivery',
    未授权发货费: 'Неавторизованные расходы на доставку',
    计价重大于: 'Расчетный вес больше',
    签收费: 'Подписать плату',
    地址更正费: 'Стоимость исправления адреса',
    '由于地址不正确，Fedex会设法寻找正确的地址以完成送货':
      'Из-за неправильного адреса Fedex попытается найти правильный адрес для завершения доставки',
    '应发货方要求，更改送货地址':
      'По требованию отправителя изменить адрес доставки',
    地址更改服务费: 'Плата за изменение адреса',
    '应发货方要求，更改地址或者召回货物服务费':
      'Плата за изменение адреса или возврат товара по требованию отправителя',
    燃油附加费: 'Топливный сбор',
    '根据官方燃油附加费率，按百分比收取':
      'Согласно официальной тарифной ставке на топливо, взимается в процентах',
    适用于超大或超重件运输:
      'Подходит для транспортировки сверхбольших или сверхтяжелых грузов',
    '每次发货前，可免费询价':
      'Перед каждой отправкой можно бесплатно запросить цену',
    体积重: 'Объемный вес',
    '高/体积比': 'Высота/Объемное соотношение',
    计价重量为体积重和实际重量中数值较大者:
      'Расчетный вес - это большее значение между объемным весом и фактическим весом',
    '特殊处理费，超标费及未授权发货费三项，不重复收费，只收取最贵的一项':
      'Специальная обработка, плата за превышение нормы и плата за отправку без разрешения — эти три пункта не взимаются повторно, взимается только самый дорогой.',
    '所有尺寸，重量均按英制计算':
      'Все размеры и вес указаны в имперской системе измерений.',
    千克: 'Килограмм',
    '所有尺寸，重量均向上取整':
      'Все размеры и веса округляются в большую сторону',
    所有货币单位均为美元: 'Все валютные единицы в долларах',
    '如Fedex价格变动，报价将进行相应变动，我司将另行通知':
      'В случае изменения цен FedEx, предложение будет соответствующим образом скорректировано, и наша компания уведомит дополнительно.',
    '此报价不含旺季附加费，旺季附加费按官网价收取':
      'Данное предложение не включает дополнительную плату за высокий сезон, дополнительная плата за высокий сезон взимается по цене на официальном сайте.',
    旺季附加费收费时间段以Fedex官网收费时间段为准:
      'Дополнительная плата за пиковый сезон действует в период, указанный на официальном сайте FedEx.',
    收费重量尺寸以Fedex实际账单为准:
      'Оплачиваемый вес и размер указаны в фактическом счете FedEx.',
    计价重量计算方式: 'Способ расчета расчетного веса',
    见拣货费价格: 'Стоимость отбора товаров',
    今日计划详情: 'Детали плана на сегодня',
    快递详情: 'Детали экспресс-доставки',
    物流信息: 'Логистическая информация',
    查看运费: 'Посмотреть стоимость доставки',
    快递服务商: 'Сервис-провайдер экспресс-доставки',
    个工作日: 'рабочих дней',
    含: 'Включая',
    免费追踪: 'Бесплатное отслеживание',
    选择快递: 'Выбрать экспресс-доставку',
    请完善包裹信息: 'Пожалуйста, уточните информацию о посылке.',
    '您确定选择当前快递服务商并支付费用?':
      'Вы уверены, что выбираете текущего курьерского перевозчика и оплачиваете стоимость?',
    运费预估: 'Смета расходов на перевозку',
    关联发货计划: 'Связанный план отправки',
    物品体积: 'Объем предметов',
    物品总重量: 'Общий вес предметов',
    您确定要对当前数据进行寄件:
      'Вы уверены, что хотите отправить текущие данные',
    您确定要对当前数据进行取消寄件:
      'Вы уверены, что хотите отменить отправку текущих данных',
    选择面单: 'Выбрать накладную',
    选择打印机: 'Выбрать принтер',
    费用预估为: 'Ориентировочная стоимость составляет',
    费用预估: 'Смета расходов',
    '您确定要对当前产品发往香港仓？':
      'Вы уверены, что хотите отправить текущий продукт на склад в Гонконге?',
    发货单详情: 'Детали накладной на отправку',
    文本记录: 'Текстовые записи',
    '规格/尺寸': 'Спецификация/Размеры',
    发货仓: 'Склад отправки',
    包件备注: 'Примечания к посылке',
    行程安排: 'Программа работы',
    送货员: 'Курьер',
    '确认取消包裹派送？': 'Подтвердить отмену доставки посылки?',
    '确认包裹客户已接收？': 'Подтвердить, что клиент получил посылку?',
    '确认包裹要回仓？': 'Подтвердить возврат посылки на склад?',
    未安排: 'Не запланировано',
    库存状况: 'Состояние запасов',
    采购情况: 'Положение в области закупок',
    确认收货: 'Подтвердить получение',
    发往香港仓: 'Отправить на склад в Гонконге',
    确认上车: 'Подтвердить погрузку',
    您确定对所选数据进行全部: 'Вы уверены, что хотите выполнить все',
    '操作吗？': 'операции с выбранными данными?',
    采购中: 'В процессе закупок',
    已售待送: 'Продано, ожидает отправки',
    收货单详情: 'Детали накладной на получение',
    '您确定要签收入库？':
      'Вы уверены, что хотите подписать и поступить на склад?',
    供货商: 'Поставщик',
    到达时间: 'Время прибытия',
    出入库单号: 'Номер накладной прихода/расхода',
    仓位: 'Позиция на складе',
    '总体积(m³)': 'Общий объем (м³)',
    添加行: 'Добавить строку',
    添加列: 'Добавить столбец',
    拆分为表格: 'Разделить на таблицу',
    当前共有: 'В настоящее время всего',
    '条数据，请输入要拆分的行数':
      'записей данных, пожалуйста, введите количество строк для разделения',
    拆分的行数: 'Количество строк для разделения',
    请输入要拆分的行数: 'Пожалуйста, введите количество строк для разделения',
    商品快递索赔详情: 'Детали претензии по экспресс-доставке товара',
    请选择商品代发单:
      'Пожалуйста, выберите заказ на продажу товаров через поставщика.',
    商品退货详情: 'Детали возврата товара',
    商品代发详情: 'Детали продажи товаров через дистрибьютора',
    '您确定要通知仓库发货？':
      'Вы уверены, что хотите уведомить склад об отправке?',
    请完善产品仓库信息: 'Пожалуйста, уточните информацию о товарном складе.',
    入库预报详情: 'Подробности прогноза',
    '您确定要发货？': 'Вы уверены, что хотите отправить?',
    索赔原因: 'Причина претензии',
    '您确定要对当前数据进行退货处理?':
      'Вы уверены, что хотите обработать возврат для текущих данных?',
    发货模版: 'Шаблон отправки',
    智能识别: 'Интеллектуальное распознавание',
    您确定要对当前订单进行作废:
      'Вы уверены, что хотите аннулировать текущий заказ',
    '部分产品报价低于最低售价确定要审核通过？':
      'Некоторые цены на продукцию ниже минимальной цены, чтобы определить, что они должны быть рассмотрены и одобрены?',
    预设报价: 'Предустановленная цена',
    是否发货: 'Отправить ли',
    '您确定要取消当前订单寄件？':
      'Вы уверены, что хотите отменить отправку текущего заказа?',
    '您确定要清除当前订单的关联信息？清除后可以重新添加产品':
      'Вы уверены, что хотите очистить связанную информацию текущего заказа? После очистки можно повторно добавить продукт',
    VIP类型: 'Тип VIP',
    商店域名: 'Домен магазина',
    请输入商店域名: 'Пожалуйста, введите домен магазина',
    请选择VIP类型: 'Пожалуйста, выберите тип VIP',
    选项值: 'Значение опции',
    面单标题: 'Заголовок накладной',
    网点: 'Точка обслуживания',
    快递员: 'Курьер',
    面单编码: 'Код накладной',
    面单模版: 'Шаблон накладной',
    绑定打印机: 'Привязать принтер',
    秘钥: 'Секретный ключ',
    校验码: 'Код проверки',
    打印机类型: 'Тип принтера',
    在线状态: 'Онлайн статус',
    模版图: 'Изображение шаблона',
    模版标题: 'Заголовок шаблона',
    '打印纸尺寸(mm)': 'Размер бумаги для печати (мм)',
    快递面单模版: 'Шаблон накладной экспресс-доставки',
    排序字段: 'Поле сортировки',
    '您确定要对当前数据进行同步翻译？':
      'Вы уверены, что хотите синхронизировать перевод текущих данных?',
    请输入code编码: 'Пожалуйста, введите код code',
    请输入汇率: 'Пожалуйста, введите обменный курс.',
    销售单号规则: 'Правила купли - продажи',
    采购单号规则: 'Правила, касающиеся номеров закупочных документов',
    使用币种: 'Используемая валюта',
    默认汇率: 'Обменный курс по умолчанию',
    开启供应商仓储报表: 'Включить отчеты по хранению поставщиков',
    默认币种: 'Стандартная валюта',
    费用征收比例: 'Доля взимаемых сборов',
    请输入merchant: 'Пожалуйста, введите merchant',
    秘钥Key: 'Секретный ключ Key',
    请输入秘钥Key: 'Пожалуйста, введите секретный ключ Key',
    不允许使用特殊符号: 'Не допускается использование специальных символов',
    公钥Key: 'Открытый ключ Key',
    请输入公钥Key: 'Пожалуйста, введите открытый ключ Key',
    字段控制: 'Контроль полей',
    stripe支付配置: 'Конфигурация платежей stripe',
    乐刷支付配置: 'Конфигурация платежей Leshua',
    使用次数: 'Количество использований',
    已授权: 'Авторизовано',
    未授权: 'Не авторизовано',
    扫码授权: 'Авторизация по QR-коду',
    授权状态: 'Статус авторизации',
    token过期时间: 'Время истечения tokenа',
    昨日销量: 'Объем продаж вчера',
    店铺扫码授权: 'Авторизация магазина по QR-коду',
    三方渠道: 'Третьесторонние каналы',
    '您确定生成全部任务？': 'Вы уверены, что хотите сгенерировать все задачи?',
    // TODO: 2025-08-18
    选择日期时间: 'Выбрать дату и время',
    分阶段付款: 'Оплата по этапам',
    请输入或选择颜色: 'Введите или выберите цвет',
    已选: 'Выбрано',
    '现货发货获取流量扶持，一档时效越短数量越多，流量扶持越多；买家下单数量超出一档或商品仅勾选定制视为定制交易':
      'При отправке товара со склада для получения поддержки трафика: чем короче срок доставки первого уровня и чем больше количество, тем больше поддержка трафика; если количество заказа покупателя превышает первый уровень или товар отмечен только как на заказ, это считается индивидуальным заказом',
    库存上限: 'Максимальный уровень запасов',
    '预览（可根据买家购买的不同数量设置不同的发货时间）':
      'Предварительный просмотр (можно установить разное время доставки в зависимости от разного количества покупок покупателя)',
    以上: 'Выше',
    承诺: 'Обещание',
    属性已存在: 'Атрибут уже существует',
    图片选择: 'Выбор изображения',
    管理相册: 'Управление альбомом',
    要插入的图片: 'Изображение для вставки',
    使用选中图片: 'Использовать выбранное изображение',
    请选择相册: 'Пожалуйста, выберите альбом',
    图片选择超出最大数量:
      'Выбрано больше изображений, чем максимально допустимое количество',
    规格图片: 'Изображение спецификации',
    '体积(cm³)': 'Объем (см³)',
    '重量(g)': 'Вес (г)',
    按规格设置: 'Настройка по спецификациям',
    按商品设置: 'Настройка по товарам',
    白色系: 'Белая цветовая гамма',
    乳白色: 'Молочный белый',
    米白色: 'Бежевый',
    象牙白: 'Белый слоновой кости',
    灰色系: 'Серая цветовая гамма',
    灰色: 'Серый',
    浅灰色: 'Светло-серый',
    深灰色: 'Темно-серый',
    银色: 'Серебристый',
    铅色: 'Свинцовый',
    奶奶灰: 'Серый бабушки',
    石板灰: 'Шиферно-серый',
    深空灰: 'Космический серый',
    石墨色: 'Графитовый',
    银灰色: 'Серебристо-серый',
    黑色系: 'Черная цветовая гамма',
    红色系: 'Красная цветовая гамма',
    桔红色: 'Оранжево-красный',
    粉红色: 'Розовый',
    玫红色: 'Пурпурный',
    藕色: 'Цвет лотоса',
    西瓜红: 'Арбузно-красный',
    酒红色: 'Бордовый',
    桃色: 'Персиковый',
    深红色: 'Темно-красный',
    砖红色: 'Кирпично-красный',
    橙红色: 'Оранжево-красный',
    珊瑚色: 'Коралловый',
    洋红色: 'Маджента',
    亮粉: 'Ярко-розовый',
    胭脂色: 'Румяна',
    深粉红: 'Темно-розовый',
    蔷薇色: 'Роза',
    猩红色: 'Алый',
    黄色系: 'Желтая цветовая гамма',
    黄色: 'Желтый',
    浅黄色: 'Светло-желтый',
    柠檬黄: 'Лимонно-желтый',
    桔色: 'Оранжевый',
    明黄色: 'Ярко-желтый',
    金色: 'Золотой',
    荧光黄: 'Флуоресцентный желтый',
    姜黄色: 'Имбирно-желтый',
    香槟色: 'Шампанский',
    杏色: 'Абрикосовый',
    卡其色: 'Хаки',
    土黄色: 'Земляной желтый',
    橙色: 'Оранжевый',
    肤色: 'Цвет кожи',
    小麦色: 'Пшеничный',
    向日葵色: 'Подсолнечный',
    绿色系: 'Зеленая цветовая гамма',
    绿色: 'Зеленый',
    浅绿色: 'Светло-зеленый',
    墨绿色: 'Темно-зеленый',
    军绿色: 'Армейский зеленый',
    翠绿色: 'Изумрудный',
    荧光绿: 'Флуоресцентный зеленый',
    青色: 'Голубой',
    草绿色: 'Травяной зеленый',
    黄绿色: 'Желто-зеленый',
    碧绿: 'Бирюзовый',
    绿宝石: 'Изумруд',
    海洋绿: 'Морской зеленый',
    橄榄色: 'Оливковый',
    橄榄绿: 'Оливково-зеленый',
    抹茶色: 'Матча',
    孔雀绿: 'Павлиний зеленый',
    蓝色系: 'Синяя цветовая гамма',
    蓝色: 'Синий',
    天蓝色: 'Голубой',
    孔雀蓝: 'Павлиний синий',
    宝蓝色: 'Сапфировый',
    深蓝色: 'Темно-синий',
    湖蓝色: 'Озерный синий',
    浅蓝色: 'Светло-синий',
    藏青色: 'Темно-синий',
    海蓝色: 'Морской синий',
    蔚蓝色: 'Лазурный',
    紫色系: 'Фиолетовая цветовая гамма',
    紫色: 'Фиолетовый',
    浅紫色: 'Светло-фиолетовый',
    深紫色: 'Темно-фиолетовый',
    紫红色: 'Пурпурный',
    紫罗兰: 'Фиалка',
    暗紫罗兰: 'Темная фиалка',
    深洋红色: 'Темно-малиновый',
    紫兰色: 'Фиолетово-синий',
    薰衣草紫: 'Лавандовый',
    棕色系: 'Коричневая цветовая гамма',
    咖啡色: 'Кофейный',
    深棕色: 'Темно-коричневый',
    浅棕色: 'Светло-коричневый',
    栗色: 'Каштановый',
    深卡其布色: 'Темный хаки',
    巧克力色: 'Шоколадный',
    褐色: 'Коричневый',
    驼色: 'Верблюжий',
    焦糖色: 'Карамельный',
    古铜色: 'Бронзовый',
    红褐色: 'Красно-коричневый',
    琥珀色: 'Янтарный',
    玫瑰金: 'Розовое золото',
    透明系: 'Прозрачная цветовая гамма',
    透明: 'Прозрачный',
    '7天包换Tips':
      'Продавец, основываясь на обязательствах по защите покупателя, добровольно предоставляет покупателю услугу "замена в течение 7 дней". После того, как покупатель закажет товар, поддерживающий услугу "замена в течение 7 дней", онлайн, продавец обязуется заменить товар без механических повреждений в течение 7 дней после получения покупателем. Если продавец не выполнит вышеуказанные обязательства, покупатель может подать заявку на компенсацию в установленный срок.',
    '7天无理由退Tips':
      'Продавец обязуется предоставить услугу возврата покупателю в течение 7 дней после получения товара при условии "товар в хорошем состоянии".',
    材质保障Tips:
      'Продавец, основываясь на обязательствах по защите покупателя, добровольно предоставляет услугу гарантии качества. Продавец гарантирует, что данный продукт соответствует требованиям к материалам, заранее согласованным с покупателем, в противном случае продавец компенсирует покупателю 20% от суммы платежа (но не более 10 000 юаней).',
    破损包赔Tips:
      'Продавец, основываясь на обязательствах по защите покупателя, добровольно предоставляет услугу "компенсация за повреждения". После того, как покупатель закажет продукт продавца онлайн, если продукт поврежден, продавец обязуется бесплатно отправить замену в течение срока гарантии. Если после повторной отправки покупатель все равно не получит целый продукт, продавец должен предоставить услугу возврата денег за поврежденный продукт.',
    少货必赔Tips:
      'Если продавец не сможет предоставить соответствующие доказательства в установленный срок или предоставленные доказательства явно недействительны, Alibaba определит, что заявка на компенсацию покупателя обоснована, и продавец согласен компенсировать покупателю понесенные убытки в соответствии с настоящим соглашением. Сумма компенсации составляет фактически оплаченную покупателем стоимость недостающего продукта (даже при недостатке только компонентов необходимо компенсировать стоимость всего комплекта). В этом случае Alibaba имеет право использовать保证金 продавца или уведомить компанию Alipay напрямую списать соответствующую сумму со счета продавца в Alipay для предварительной компенсации покупателю.',
    坏单包赔Tips:
      'Alibaba определила, что заявка на компенсацию покупателя обоснована, и продавец согласен компенсировать покупателю понесенные убытки в соответствии с настоящим соглашением. Сумма компенсации составляет стоимость продукта в количестве, указанном покупателем как испорченный заказ. В этом случае Alibaba имеет право использовать保证金 продавца или уведомить компанию Alipay напрямую списать соответствующую сумму со счета продавца в Alipay для предварительной компенсации покупателю.',
    官方直送Tips: `"После активации продавцом услуги гарантии "официальная доставка" продавец обязуется одновременно предоставлять покупателю услугу гарантии "официальная доставка". Товар должен соответствовать следующим условиям, и на нем будет отображаться ярлык услуги гарантии "официальная доставка":
                (1) Вы отметили услугу гарантии "официальная доставка" на товаре;
                (2) Данный товар использует "шаблон руководства по доставке";
                (3) За последние 30 дней доля заказов на данный товар продавца, отправленных с использованием услуги "официальная доставка", составляет 90% и более (при объеме заказов за последние 30 дней 10 и более заказов).
                Если продавец не выполнит обязательство по использованию "шаблона руководства по доставке" для данного товара или доля заказов за последние 30 дней, отправленных с использованием услуги "официальная доставка", составляет 90% и более (при объеме заказов за последние 30 дней 10 и более заказов), данный товар будет удален."`,
    天包换: 'Дней на замену',
    天包换Tips: 'Подсказки по замене в течение нескольких дней',
    天无理由退: 'Дней на возврат без причины',
    天无理由退Tips:
      'Подсказки по возврату без причины в течение нескольких дней',
    材质保障: 'Гарантия качества материалов',
    破损包赔: 'Компенсация за повреждения',
    少货必赔: 'Компенсация за недостачу',
    坏单包赔: 'Компенсация за испорченные заказы',
    官方直送: 'Официальная доставка',
    常用类目: 'Часто используемые категории',
    您选择的类目: 'Выбранные вами категории',
    主要下游平台: 'Основные платформы downstream',
    速卖通: 'AliExpress',
    亚马逊: 'Amazon',
    独立站: 'Независимый сайт',
    主要销售地区: 'Основные регионы продаж',
    欧洲: 'Европа',
    北美: 'Северная Америка',
    南美: 'Южная Америка',
    东南亚: 'Юго-Восточная Азия',
    东北亚: 'Северо-Восточная Азия',
    中东: 'Ближний Восток',
    非洲: 'Африка',
    请至少选择一项: 'Пожалуйста, выберите хотя бы один вариант',
    '您已开通买保服务，当前保证金金额为':
      'Вы активировали услугу защиты покупателя, текущая сумма保证金 составляет',
    保障服务首页: 'Главная страница услуг защиты',
    申请开通: 'Подать заявку на активацию',
    不支持: 'Не поддерживается',
    值: 'Значение',
    自产产品: 'Собственное производство',
    KP产品: 'Продукты KP',
    有产品凭证: 'Есть сертификат продукта',
    首次采购: 'Первая закупка',
    '次采购,之前共采购': 'закупок, всего закуплено',
    '产品数量低于最低起售数量不可提交,请调整!':
      'Количество продукта ниже минимального количества продажи, нельзя отправить, пожалуйста, скорректируйте!',
    产品数量低于最低起售数量:
      'Количество продукта ниже минимального количества продажи',
    产品报价低于最低售价: 'Цена продукта ниже минимальной цены продажи',
    产品报价高于最低采购价: 'Цена продукта выше минимальной закупочной цены',
    三方仓库名: 'Название стороннего склада',
    冻结数量: 'Замороженное количество',
    订单日期: 'Дата заказа',
    流程名称: 'Название процесса',
    货架: 'Стеллаж',
    更新: 'Обновить',
    暂无: 'Временно нет',
    deliveryPlanNumTips:
      'Общее количество - Отправленное количество = Ожидаемое количество (единица)',
    stockNumTips: 'Запасы - Замороженные запасы = Доступные запасы (единица)',
    totalStockNumTips:
      'Запасы (Общие запасы - Замороженные запасы = Доступные запасы) (единица)',
    冻结库存: 'Замороженные запасы',
    '添加中...': 'Добавление...',
    调价: 'Корректировка цен',
    不调价: 'Не корректировать цены',
    上次采购价: 'Последняя закупочная цена',
    产品价格和数量一样: 'Цена и количество продукта одинаковы',
    请选择船号: 'Пожалуйста, выберите номер судна',
    请选择集装箱号: 'Пожалуйста, выберите номер контейнера',
    '调出仓库(库存)': 'Склад отправки (запасы)',
    '调入仓库(库存)': 'Склад получения (запасы)',
    自项目实际完结日起: 'С даты фактического завершения проекта',
    当前产品的个仓位数量信息:
      'Информация о количестве позиций текущего продукта',
    当前产品的冻结库存信息:
      'Информация о замороженных запасах текущего продукта',
    在途库存: 'Запасы в пути',
    默认仓位: 'Позиция по умолчанию',
    已生成: 'Сгенерировано',
    未生成: 'Не сгенерировано',
    备货图: 'Схема подготовки товаров',
    船号: 'Номер судна',
    集装箱号: 'Номер контейнера',
    '您当前数量低于最小起订量，请修改！':
      'Ваше текущее количество ниже минимального заказа, пожалуйста, измените!',
    导入数据: 'Импорт данных',
    下载模板: 'Скачать шаблон',
    请配置模块名称: 'Пожалуйста, настройте название модуля',
    聚合搜索: 'Агрегированный поиск',
    产品标题: 'Название продукта',
    全部产品: 'Все продукты',
    按产品数量: 'По количеству продуктов',
    按产品种类: 'По видам продуктов',
    项目: 'Проект',
    出入库单: 'Документы прихода и расхода',
    项目服务商: 'Сервис-провайдер проекта',
    模具: 'Форма',
    我创建的: 'Созданные мной',
    我负责的: 'Ответственный я',
    我参与的: 'Участник я',
    元旦节: 'Новый год',
    情人节: 'День святого Валентина',
    劳动节: 'День труда',
    青年节: 'День молодежи',
    儿童节: 'День детей',
    教师节: 'День учителя',
    国庆节: 'Национальный день',
    圣诞节: 'Рождество',
    妇女节: 'Международный женский день',
    植树节: 'День посадки деревьев',
    愚人节: 'День дурака',
    护士节: 'День медсестры',
    建党节: 'День основания партии',
    建军节: 'День основания армии',
    平安夜: 'Святой вечер',
    除夕: 'Канун Нового года по лунному календарю',
    春节: 'Китайский Новый год',
    元宵节: 'Праздник фонарей',
    龙抬头: 'День возрождения дракона',
    端午节: 'Праздник лодок-драконов',
    七夕节: 'День влюбленных по лунному календарю',
    中元节: 'Фестиваль духов',
    中秋节: 'Праздник середины осени',
    重阳节: 'Праздник двойной девятки',
    寒衣节: 'День теплой одежды',
    下元节: 'Нижний юань',
    腊八节: 'Фестиваль Лаба',
    北方小年: 'Северный малый Новый год',
    南方小年: 'Южный малый Новый год',
    打印失败: 'Ошибка печати',
    今日: 'Сегодня',
    昨日: 'Вчера',
    本周: 'Эта неделя',
    上周: 'Прошлая неделя',
    本月: 'Этот месяц',
    上月: 'Прошлый месяц',
    最近三个月: 'Последние 3 месяца',
    最近半年: 'Последние полгода',
    用时: 'Время использования',
    天: 'дней',
    逾期: 'Просрочено',
    剩余: 'Остаток',
    已完结: 'Завершено',
    公式必须是字符串类型: 'Формула должна быть строкового типа',
    变量必须是对象类型: 'Переменная должна быть объектного типа',
    无效的变量名: 'Недопустимое имя переменной',
    公式包含不允许的字符: 'Формула содержит недопустимые символы',
    计算结果不是有效数字: 'Результат вычисления не является допустимым числом',
    计算失败: 'Ошибка вычисления',
    零售适配: 'Розничная адаптация',
    相册: 'Альбом',
    生日: 'День рождения',
    宗教: 'Религия',
    账单地址: 'Адрес для выставления счета',
    订单来源: 'Источник заказа',
    审核备注: 'Примечание к проверке',
    复核状态: 'Статус повторной проверки',
    复核人: 'Проверяющий',
    复核备注: 'Примечание к повторной проверке',
    备货进度: 'Прогресс подготовки товаров',
    发货单据: 'Документы отгрузки',
    请选择州: 'Пожалуйста, выберите штат',
    计划金额: 'Планируемая сумма',
    回款状态: 'Статус возврата средств',
    次品数: 'Количество брака',
    不合格数量: 'Количество несоответствий',
    次品数量: 'Количество брака',
    模具名称: 'Название формы',
    模具编码: 'Код формы',
    模具类型: 'Тип формы',
    开发方: 'Разработчик',
    维护方: 'Обслуживающая сторона',
    加工方: 'Обрабатывающая сторона',
    耗材: 'Расходные материалы',
    当前位置: 'Текущее местоположение',
    模具成本: 'Стоимость формы',
    成本描述: 'Описание стоимости',
    产权描述: 'Описание прав собственности',
    模具图集: 'Альбом изображений формы',
    模具描述: 'Описание формы',
    研发成本: 'Стоимость НИОКР',
    生产成本: 'Производственная стоимость',
    预计售价: 'Ожидаемая цена продажи',
    回本数量: 'Количество для окупаемости',
    样品状态: 'Статус образца',
    启动时间: 'Время запуска',
    预计完结: 'Ожидаемое завершение',
    实际完结: 'Фактическое завершение',
    项目描述: 'Описание проекта',
    项目成本: 'Стоимость проекта',
    产品成本: 'Стоимость продукта',
    项目复盘: 'Анализ проекта',
    关联模块: 'Связанный модуль',
    关联数据: 'Связанные данные',
    任务描述: 'Описание задачи',
    完成图集: 'Альбом завершенных изображений',
    完成视频: 'Завершенное видео',
    完成反馈: 'Обратная связь по завершению',
    配送员: 'Курьер',
    配送仓库: 'Склад доставки',
    配送状态: 'Статус доставки',
    批量审核: 'Массовая проверка',
    零售价格: 'Розничная цена',
    批发价: 'Оптовая цена',
    基础信息: 'Базовая информация',
    请选择标签: 'Пожалуйста, выберите тег',
    销售信息: 'Информация о продажах',
    仓储信息: 'Информация о складе',
    分类信息: 'Информация о классификации',
    图片与视频: 'Изображения и видео',
    包装与箱规: 'Упаковка и спецификации коробки',
    描述与详情: 'Описание и детали',
    拓展信息: 'Дополнительная информация',
    '数据未保存是否保存数据？': 'Данные не сохранены, сохранить данные?',
    不保存: 'Не сохранять',
    按SKU: 'По SKU',
    按产品分类: 'По классификации продукта',
    所有: 'Все',
    同步得物价格: 'Синхронизировать цены Poizon',
    请输入具体的SKU: 'Пожалуйста, введите конкретный SKU',
    同步: 'Синхронизировать',
    同步得物商品: 'Синхронизировать товары Poizon',
    尺寸单位: 'Единица измерения размера',
    请选择尺寸单位: 'Пожалуйста, выберите единицу измерения размера',
    重量单位: 'Единица измерения веса',
    请选择重量单位: 'Пожалуйста, выберите единицу измерения веса',
    商品ID: 'ID товара',
    请输入Shopify商品页面链接中products后面跟的纯数字ID:
      'Пожалуйста, введите чистый цифровой ID, следующий за products в ссылке на страницу товара Shopify',
    请选择订单来源: 'Пожалуйста, выберите источник заказа',
    '您的报价产品中有低于最低售价或最小起订量的产品，请检查！':
      'В ваших ценах на продукты есть продукты ниже минимальной цены продажи или минимального заказа, пожалуйста, проверьте!',
    请选择来源: 'Пожалуйста, выберите источник',
    请选择日期: 'Пожалуйста, выберите дату',
    请输入宗教: 'Пожалуйста, введите религию',
    客户标签: 'Тег клиента',
    供应商标签: 'Тег поставщика',
    运费测算: 'Расчет стоимости доставки',
    请输入处理方式: 'Пожалуйста, введите способ обработки',
    添加回款明细: 'Добавить детали возврата средств',
    其他费用: 'Прочие расходы',
    费用减免: 'Снижение расходов',
    额外费用: 'Дополнительные расходы',
    费用说明: 'Описание расходов',
    职责: 'Обязанности',
    直接输入并选择: 'Прямой ввод и выбор',
    批量生成入库预报: 'Массовое создание прогноза прихода',
    各产品数量: 'Количество каждого продукта',
    请填写数量: 'Пожалуйста, заполните количество',
    平台单号: 'Номер заказа на платформе',
    请输入平台单号: 'Пожалуйста, введите номер заказа на платформе',
    '仓库代退-商品退货单': 'Возврат через склад - документ возврата товара',
    添加快递单号: 'Добавить номер экспресс-доставки',
    码头: 'Пристань',
    请选择码头: 'Пожалуйста, выберите пристань',
    三方仓产品调拨: 'Перемещение продуктов на стороннем складе',
    关联网页: 'Связанная веб-страница',
    字段取值: 'Значение поля',
    请输入取值字段: 'Пожалуйста, введите поле для получения значения',
    部件属性: 'Атрибуты компонента',
    '部件属性在设置》扩展字段》产品中添加':
      'Атрибуты компонента добавляются в Настройки》Расширенные поля》Продукт',
    请选择部件包含的属性:
      'Пожалуйста, выберите атрибуты, содержащиеся в компоненте',
    密钥: 'Секретный ключ',
    请输入密钥: 'Пожалуйста, введите секретный ключ',
    父级仓库: 'Родительский склад',
    打印图片: 'Печать изображения',
    模块名称: 'Название модуля',
    请输入模块名称: 'Пожалуйста, введите название модуля',
    显示移动端: 'Отображать на мобильном устройстве',
    凭证文件: 'Файл сертификата',
    生产: 'Производство',
    '良品数量(实际入库数量)':
      'Количество качественных товаров (фактическое количество прихода)',
    请输入Key: 'Пожалуйста, введите Key',
    请输入Secret: 'Пожалуйста, введите Secret',
    资产: 'Активы',
    资产类型: 'Тип актива',
    请选择资产类型: 'Пожалуйста, выберите тип актива',
    资产状态: 'Статус актива',
    请选择资产状态: 'Пожалуйста, выберите статус актива',
    资产编码: 'Код актива',
    请输入资产编码: 'Пожалуйста, введите код актива',
    资产名称: 'Название актива',
    请输入资产名称: 'Пожалуйста, введите название актива',
    购入日期: 'Дата покупки',
    请选择购入日期: 'Пожалуйста, выберите дату покупки',
    请输入规格型号: 'Пожалуйста, введите спецификации и модель',
    设备序列号: 'Серийный номер оборудования',
    请输入设备序列号: 'Пожалуйста, введите серийный номер оборудования',
    价值币种: 'Валюта стоимости',
    期初价值: 'Начальная стоимость',
    请输入期初价值: 'Пожалуйста, введите начальную стоимость',
    当前价值: 'Текущая стоимость',
    请输入当前价值: 'Пожалуйста, введите текущую стоимость',
    使用人: 'Пользователь',
    请选择使用人: 'Пожалуйста, выберите пользователя',
    使用部门: 'Отдел использования',
    请选择使用部门: 'Пожалуйста, выберите отдел использования',
    存放位置: 'Место хранения',
    请输入存放位置: 'Пожалуйста, введите место хранения',
    资产图集: 'Альбом активов',
    资产描述: 'Описание актива',
    请输入资产描述: 'Пожалуйста, введите описание актива',
    生产模具: 'Производственная форма',
    请输入模具名称: 'Пожалуйста, введите название формы',
    请选择模具类型: 'Пожалуйста, выберите тип формы',
    请输入模具编码SN: 'Пожалуйста, введите код формы SN',
    模具状态: 'Статус формы',
    请输入模具成本: 'Пожалуйста, введите стоимость формы',
    成本币种: 'Валюта стоимости',
    模具位置: 'Местоположение формы',
    请输入模具位置: 'Пожалуйста, введите местоположение формы',
    请输入成本描述: 'Пожалуйста, введите описание стоимости',
    请输入耗材描述: 'Пожалуйста, введите описание расходных материалов',
    请选择模具开发商: 'Пожалуйста, выберите разработчика формы',
    请选择模具维护方: 'Пожалуйста, выберите сторону обслуживания формы',
    请选择模具加工方: 'Пожалуйста, выберите сторону обработки формы',
    请输入模具描述: 'Пожалуйста, введите описание формы',
    请输入产权描述: 'Пожалуйста, введите описание прав собственности',
    请输入项目名称: 'Пожалуйста, введите название проекта',
    项目标签: 'Тег проекта',
    项目阶段: 'Этап проекта',
    请输入启动时间: 'Пожалуйста, введите время запуска',
    请输入预计完结时间: 'Пожалуйста, введите ожидаемое время завершения',
    请输入实际完结时间: 'Пожалуйста, введите фактическое время завершения',
    项目预算: 'Бюджет проекта',
    请输入项目预计研发成本:
      'Пожалуйста, введите ожидаемую стоимость НИОКР проекта',
    请输入项目预计生产成本:
      'Пожалуйста, введите ожидаемую производственную стоимость проекта',
    请输入预计售价: 'Пожалуйста, введите ожидаемую цену продажи',
    请输入项目预计回本数量:
      'Пожалуйста, введите ожидаемое количество для окупаемости проекта',
    请输入项目描述: 'Пожалуйста, введите описание проекта',
    请输入项目成本描述: 'Пожалуйста, введите описание стоимости проекта',
    请输入项目产品成本描述:
      'Пожалуйста, введите описание стоимости продукта проекта',
    请输入项目复盘内容: 'Пожалуйста, введите содержание анализа проекта',
    详情描述: 'Подробное описание',
    请输入详情描述: 'Пожалуйста, введите подробное описание',
    请选择发货地址: 'Пожалуйста, выберите адрес отправки',
    货架数量: 'Количество стеллажей',
    请输入货架数量: 'Пожалуйста, введите количество стеллажей',
    '前缀标题如：仓库1-': 'Префикс заголовка, например: Склад1-',
    '后缀标题如：-01行': 'Суффикс заголовка, например: -01 строка',
    第三方仓库: 'Сторонний склад',
    三方仓库: 'Сторонний склад',
    请选择三方仓库公司: 'Пожалуйста, выберите компанию стороннего склада',
    产品授权大市场: 'Авторизация продукта на большом рынке',
    授权公司: 'Авторизованная компания',
    请选择授权公司: 'Пожалуйста, выберите авторизованную компанию',
    授权产品: 'Авторизованный продукт',
    产品评论: 'Комментарии к продукту',
    显示状态: 'Статус отображения',
    评论图片: 'Изображения комментариев',
    评论内容: 'Содержание комментариев',
    请输入评论内容: 'Пожалуйста, введите содержание комментариев',
    请输入标签名称: 'Пожалуйста, введите название тега',
    标签类型: 'Тип тега',
    请选择标签类型: 'Пожалуйста, выберите тип тега',
    请选择关联模块: 'Пожалуйста, выберите связанный модуль',
    请选择关联数据: 'Пожалуйста, выберите связанные данные',
    关联模板: 'Связанный шаблон',
    请选择关联模板: 'Пожалуйста, выберите связанный шаблон',
    请输入开始日期: 'Пожалуйста, введите дату начала',
    截止日期: 'Дата окончания',
    请选择截止日期: 'Пожалуйста, выберите дату окончания',
    请输入任务描述内容: 'Пожалуйста, введите содержание описания задачи',
    完成任务: 'Завершить задачу',
    请输入任务答辩内容: 'Пожалуйста, введите содержание защиты задачи',
    合格情况: 'Результат проверки',
    请选择合格情况: 'Пожалуйста, выберите результат проверки',
    请选择入库日期: 'Пожалуйста, выберите дату прихода',
    是否有清单: 'Есть ли список',
    销售日期: 'Дата продажи',
    请选择销售日期: 'Пожалуйста, выберите дату продажи',
    产品标签: 'Тег продукта',
    数据范围: 'Диапазон данных',
    请选择复核状态: 'Пожалуйста, выберите статус повторной проверки',
    单品数量: 'Количество единиц',
    请选择单品数量: 'Пожалуйста, выберите количество единиц',
    前缀标题: 'Префикс заголовка',
    '前缀标题如：仓库': 'Префикс заголовка, например: Склад',
    后缀标题: 'Суффикс заголовка',
    后缀标题如: 'Суффикс заголовка как',
    大于: 'Больше чем',
    入库状态: 'Статус прихода',
    发货地: 'Место отправки',
    请选择业务类型: 'Пожалуйста, выберите тип бизнеса',
    采购单: 'Заказ на закупку',
    '请搜索/选择采购单': 'Пожалуйста, найдите/выберите заказ на закупку',
    请选择参与人: 'Пожалуйста, выберите участников',
    请选择开始时间: 'Пожалуйста, выберите время начала',
    请选择跟进人: 'Пожалуйста, выберите ответственного за сопровождение',
    请选择跟进时间: 'Пожалуйста, выберите время сопровождения',
    后: 'После',
    分钟: 'Минуты',
    昨天: 'Вчера',
    下载查看: 'Скачать для просмотра',
    '导入数据过多，已添加至异步导入队列生成':
      'Слишком много данных для импорта, добавлено в очередь асинхронного импорта для генерации',
    '您确定要将当前任务进行作废操作？':
      'Вы уверены, что хотите аннулировать текущую задачу?',
    子任务: 'Подзадача',
    创建: 'Создать',
    负责: 'Ответственный',
    模块: 'Модуль',
    跟进模块: 'Модуль сопровождения',
    查看富文本内容: 'Просмотр содержимого форматированного текста',
    跟进附件: 'Вложения сопровождения',
    跟进位置: 'Местоположение сопровождения',
    富文本内容: 'Содержимое форматированного текста',
    暂无关联数据: 'Нет связанных данных',
    列表显示: 'Отображение списком',
    日历显示: 'Отображение календарем',
    初一: 'Первый день',
    多任务: 'Множественные задачи',
    项: 'Элементов',
    请先添加数据: 'Пожалуйста, сначала добавьте данные',
    组合产品: 'Комбинированный продукт',
    "90天销售笔数'": 'Количество продаж за 90 дней',
    '90天销售客户数': 'Количество клиентов за 90 дней',
    最近销售: 'Последняя продажа',
    资产图片: 'Изображения активов',
    资产详情: 'Детали актива',
    上次采购: 'Последняя закупка',
    客户订单: 'Заказ клиента',
    KA一个月未下单: 'KA не делал заказ в течение месяца',
    KA三个月未下单: 'KA не делал заказ в течение трех месяцев',
    KA一个月未跟进: 'KA не сопровождался в течение месяца',
    合并客户数据: 'Объединить данные клиентов',
    被合并客户: 'Клиент для объединения',
    请选择被合并客户: 'Пожалуйста, выберите клиента для объединения',
    合并到客户: 'Объединить с клиентом',
    请选择合并到客户: 'Пожалуйста, выберите клиента для объединения',
    模具详情: 'Детали формы',
    位置状态变化: 'Изменение статуса местоположения',
    项目详情: 'Детали проекта',
    模具明细: 'Детали формы',
    关联服务商: 'Связанный сервис-провайдер',
    模具供应商详情: 'Детали поставщика формы',
    关联项目: 'Связанный проект',
    关联模具: 'Связанная форма',
    客户头像: 'Аватар клиента',
    请选择服务商: 'Пожалуйста, выберите сервис-провайдера',
    成本价格: 'Себестоимость',
    包含模具: 'Включая формы',
    开发状态: 'Статус разработки',
    距离完结: 'Расстояние до завершения',
    距完结: 'До завершения',
    '您确定要同步产品到BOM吗？':
      'Вы уверены, что хотите синхронизировать продукт с BOM?',
    计划信息: 'Плановая информация',
    明细信息: 'Детальная информация',
    关联采购订单: 'Связанный заказ на закупку',
    说明: 'Описание',
    凭证图: 'Изображение сертификата',
    计划付款: 'Плановый платеж',
    计划占比: 'Доля плана',
    已付占比: 'Доля оплаченного',
    计划回款: 'Плановый возврат средств',
    回款信息: 'Информация о возврате средств',
    已回占比: 'Доля возвращенного',
    图表统计: 'Статистика диаграмм',
    渠道销量: 'Объем продаж по каналам',
    新增刊登产品: 'Новые размещенные продукты',
    新增刊登排名: 'Рейтинг новых размещений',
    渠道新增刊登: 'Новые размещения по каналам',
    销售产品: 'Продукты продаж',
    提成排行: 'Рейтинг комиссий',
    计提金额: 'Сумма начисления',
    上一时间段: 'Предыдущий период времени',
    当前时间段: 'Текущий период времени',
    请选择统计币种: 'Пожалуйста, выберите валюту статистики',
    库存预警: 'Предупреждение о запасах',
    剩余库存: 'Остаточные запасы',
    请选择操作人: 'Пожалуйста, выберите оператора',
    操作内容: 'Содержание операции',
    渠道大类: 'Категория каналов',
    渠道店铺: 'Магазины каналов',
    自产货源: 'Источник собственного производства',
    零售适配评分: 'Оценка розничной адаптации',
    未上架产品: 'Невыставленные продукты',
    AI分析: 'AI анализ',
    请选择尺寸: 'Пожалуйста, выберите размер',
    请输入重量: 'Пожалуйста, введите вес',
    评论: 'Комментарии',
    '您确定要对当前所有数据进行刷新操作？':
      'Вы уверены, что хотите обновить все текущие данные?',
    组合商品: 'Комбинированный товар',
    商品编码: 'Код товара',
    商品分类: 'Классификация товара',
    价格公式: 'Формула цены',
    尺码表: 'Таблица размеров',
    是否关键商品: 'Ключевой товар или нет',
    批量修改尺码表: 'Массовое изменение таблицы размеров',
    请选择尺码表: 'Пожалуйста, выберите таблицу размеров',
    推送到第三方店铺: 'Отправить в сторонний магазин',
    请选择第三方店铺: 'Пожалуйста, выберите сторонний магазин',
    请选择规类型: 'Пожалуйста, выберите тип спецификации',
    添加规格: 'Добавить спецификацию',
    '规格类型在：设置》产品设置》规格类型中添加':
      'Тип спецификации добавляется в: Настройки》Настройки продукта》Тип спецификации',
    '不能选择重复属性！！': 'Нельзя выбирать повторяющиеся атрибуты!!',
    商品详情: 'Детали товара',
    产品SKU: 'SKU продукта',
    产品售价: 'Цена продажи продукта',
    规格属性: 'Атрибуты спецификации',
    选择规格: 'Выбрать спецификацию',
    商品属性: 'Атрибуты товара',
    获取得物价格: 'Получить цену Poizon',
    添加规格模板: 'Добавить шаблон спецификации',
    规格模板名称: 'Название шаблона спецификации',
    请输入模板名称: 'Пожалуйста, введите название шаблона',
    '请添加规格及属性值！！':
      'Пожалуйста, добавьте спецификацию и значения атрибутов!!',
    '商品规格数量过多，请重新选择！':
      'Слишком много спецификаций товара, пожалуйста, выберите снова!',
    '产品编码有重复请检查！！':
      'Коды продуктов повторяются, пожалуйста, проверьте!!',
    规格设置: 'Настройка спецификаций',
    采购总量: 'Общий объем закупок',
    最高售价: 'Максимальная цена продажи',
    最近一次售价: 'Последняя цена продажи',
    最近一次采购时间: 'Время последней закупки',
    更改: 'Изменить',
    查看历史采购: 'Просмотреть историю закупок',
    智能AI: 'Интеллектуальный AI',
    销售预测: 'Прогноз продаж',
    '实线为真实销量；虚线为预测销量':
      'Сплошная линия - реальные продажи; пунктирная линия - прогноз продаж',
    PROPHET方法预测: 'Прогноз методом PROPHET',
    PROPHET方法预测Tips:
      'PROPHET - это библиотека прогнозирования временных рядов с открытым исходным кодом от Facebook (ныне Meta), названная Prophet. Она主要用于对时间序列数据进行建模和预测，适用于具有明显季节性和节假日效应的数据',
    SARIMA方法预测: 'Прогноз методом SARIMA',
    SARIMA方法预测Tips:
      'SARIMA - это аббревиатура от Seasonal Autoregressive Integrated Moving Average, классическая статистическая модель для прогнозирования временных рядов. Это расширенная версия модели ARIMA, специально предназначенная для обработки данных с явными сезонными паттернами',
    客户采购: 'Закупки клиентов',
    预计出库: 'Ожидаемая отгрузка',
    真实销量: 'Реальные продажи',
    方法预测: 'Прогноз методом',
    '零售价格/建议售价-最低售价/成本':
      'Розничная цена/Рекомендуемая цена - Минимальная цена продажи/Себестоимость',
    '90天销量/笔数': 'Объем продаж/Количество за 90 дней',
    授权市场: 'Авторизованный рынок',
    '您确定下架当前产品？':
      'Вы уверены, что хотите снять с продажи текущий продукт?',
    '您确定要对当前所有数据进行比价并上架？':
      'Вы уверены, что хотите сравнить цены всех текущих данных и выставить на продажу?',
    '您确定要对当前所选数据进行比价并上架？':
      'Вы уверены, что хотите сравнить цены выбранных данных и выставить на продажу?',
    批量下架: 'Массовое снятие с продажи',
    自产滞销: 'Собственное производство не пользуется спросом',
    自产滞销Tips:
      'Собственное производство не пользуется спросом (собственное производство, продажи менее 50 штук за 90 дней), сортировка по убыванию количества запасов и возрастанию времени последней продажи',
    外购滞销: 'Закупка не пользуется спросом',
    外购滞销Tips:
      'Закупка не пользуется спросом (закупка, есть запасы, продажи менее 10 штук за 90 дней), сортировка по убыванию количества запасов и возрастанию времени последней продажи',
    省市区: 'Провинция, город, район',
    位置: 'Местоположение',
    操作记录: 'Записи операций',
    主域名: 'Основной домен',
    网页快照: 'Снимок веб-страницы',
    条形码: 'Штрих-код',
    '起订量(moq)': 'Минимальный заказ (moq)',
    '您确定要对当客户订单中的产品进行同步吗？':
      'Вы уверены, что хотите синхронизировать продукты в заказе клиента?',
    同步订单中的产品: 'Синхронизировать продукты в заказе',
    采购单的其他费用金额: 'Сумма прочих расходов по заказу на закупку',
    '您确定要对当前数据直接生成入库单并审核通过？':
      'Вы уверены, что хотите напрямую сгенерировать документ прихода для текущих данных и пройти проверку?',
    '您确认将产品货物状态变为采购？':
      'Вы подтверждаете изменение статуса товара на закупку?',
    '您确定要批量提审选中的信息？':
      'Вы уверены, что хотите массово отправить на проверку выбранную информацию?',
    派货行程单详情: 'Детали маршрута доставки',
    配送地址: 'Адрес доставки',
    '您确定要对当前数据完成配送？':
      'Вы уверены, что хотите завершить доставку текущих данных?',
    包含单数: 'Количество включенных заказов',
    '您确定要对当前数据开始派货？':
      'Вы уверены, что хотите начать доставку текущих данных?',
    '您确定要对当前数据结束派货？':
      'Вы уверены, что хотите завершить доставку текущих данных?',
    '您确定要生成出库单？':
      'Вы уверены, что хотите сгенерировать документ отгрузки?',
    各仓库库存: 'Запасы по складам',
    '您确定要对当前数据进行自动派货？':
      'Вы уверены, что хотите автоматически распределить доставку текущих данных?',
    是否打印: 'Печатать или нет',
    您确定要对选中的数据进行批量打印:
      'Вы уверены, что хотите массово распечатать выбранные данные',
    工厂库存: 'Запасы фабрики',
    入库记录: 'Записи прихода',
    库存低于: 'Запасы ниже',
    天销售: 'дней продаж',
    '天销售,滞销！': 'дней продаж, не пользуется спросом!',
    可用天数: 'Доступные дни',
    根据当前库存和日均销售量计算预估可用天数:
      'Рассчитать предполагаемое количество доступных дней на основе текущих запасов и среднесуточных продаж',
    '你确定要复制和当前数据子节点结构一样？':
      'Вы уверены, что хотите скопировать структуру дочерних узлов текущих данных?',
    splitTableTips:
      'Если есть количество стеллажей, пожалуйста, разделите вертикальной чертой (|)',
    加载中: 'Загрузка...',
    productCategoryNumStock: 'Виды продуктов|Общее количество (позиция)',
    productCategoryNum: 'Виды продуктов | Количество',
    等待处理数量: 'Количество в ожидании обработки',
    '已处理/订单数': 'Обработано/Количество заказов',
    '处理完成！！': 'Обработка завершена!!',
    '您确定要批量打印面单吗？':
      'Вы уверены, что хотите массово распечатать накладные?',
    '您确定要批量删除所选数据吗？':
      'Вы уверены, что хотите массово удалить выбранные данные?',
    '您确定要批量确认运单费用吗？':
      'Вы уверены, что хотите массово подтвердить стоимость накладных?',
    天销售笔数: 'Количество продаж в день',
    天销售客户数: 'Количество клиентов продаж в день',
    '天销量/笔数': 'Объем продаж/Количество в день',
    '尺寸/重量': 'Размер/Вес',
    预估费用: 'Предполагаемая стоимость',
    收货地: 'Место получения',
    '您确定要使用当前预估费用进行费用确认吗？':
      'Вы уверены, что хотите использовать текущую предполагаемую стоимость для подтверждения расходов?',
    第三方仓库详情: 'Детали стороннего склада',
    所在仓: 'Находится на складе',
    待发货数量: 'Количество в ожидании отправки',
    毛利: 'Валовая прибыль',
    订单毛利金额: 'Сумма валовой прибыли заказа',
    '订单金额-已收金额-优惠金额':
      'Сумма заказа - Полученная сумма - Сумма скидки',
    订单的其他费用金额: 'Сумма прочих расходов по заказу',
    '您确定要对当前数据撤销提审？':
      'Вы уверены, что хотите отозвать текущие данные с проверки?',
    仅撤销: 'Только отозвать',
    撤销并删除关联单据: 'Отозвать и удалить связанные документы',
    '您确定要对当前订单利润进行重新计算？':
      'Вы уверены, что хотите пересчитать прибыль текущего заказа?',
    订单复核: 'Повторная проверка заказа',
    订单金额调整: 'Корректировка суммы заказа',
    未提交: 'Не отправлено',
    未审核: 'Не проверено',
    已审核: 'Проверено',
    未复核: 'Не повторно проверено',
    已复核: 'Повторно проверено',
    大单品订单: 'Заказ крупного единичного продукта',
    '您确定要批量出库选中的信息？':
      'Вы уверены, что хотите массово отгрузить выбранную информацию?',
    删除时间: 'Время удаления',
    '您确定要恢复当前订单的信息？':
      'Вы уверены, что хотите восстановить информацию текущего заказа?',
    订单模版: 'Шаблон заказа',
    反馈处理: 'Обработка обратной связи',
    岗位描述: 'Описание должности',
    最新编辑: 'Последнее редактирование',
    使用公司: 'Использующая компания',
    标签名称: 'Название тега',
    关联信息编码: 'Код связанной информации',
    标签查询: 'Поиск по тегам',
    标签列表: 'Список тегов',
    操作说明: 'Инструкция по операции',
    请输入操作说明: 'Пожалуйста, введите инструкцию по операции',
    显示选项卡: 'Отображать вкладки',
    规格值: 'Значение спецификации',
    产品规格类型: 'Тип спецификации продукта',
    规格名称: 'Название спецификации',
    请输入规格名称: 'Пожалуйста, введите название спецификации',
    '颜色、尺寸、重量等': 'Цвет, размер, вес и т.д.',
    请输入规格属性: 'Пожалуйста, введите атрибуты спецификации',
    '请输入规格属性值如红色、黑色、白色等':
      'Пожалуйста, введите значения атрибутов спецификации, например красный, черный, белый и т.д.',
    服务商类型: 'Тип сервис-провайдера',
    规格类型: 'Тип спецификации',
    常见问题: 'Часто задаваемые вопросы',
    问题类型: 'Тип вопроса',
    币种汇率: 'Курс валют',
    kickcrew页面价格: 'Цена на странице kickcrew',
    '美元换算人民币汇率）': 'Курс доллара к юаню)',
    汽配行业不适用: 'Не применимо для автомобильной промышленности',
    请输入价格公式: 'Пожалуйста, введите формулу цены',
    '如（price': 'Например (price',
    严格宽松模式: 'Строгий или свободный режим',
    单号规则: 'Правила номеров документов',
    页面设置: 'Настройки страницы',
    搜索条件缓存: 'Кэширование условий поиска',
    '页面搜索条件缓存开启后，页面搜索条件会缓存，下次访问时会自动加载上次搜索条件，请谨慎使用':
      'После включения кэширования условий поиска на странице, условия поиска будут кэшироваться, и при следующем посещении автоматически загрузятся последние условия поиска, пожалуйста, используйте с осторожностью',
    展示产品编辑时间: 'Отображать время редактирования продукта',
    '产品编辑时间开启后，产品编辑时间和编辑人信息会显示在产品列表图片下方':
      'После включения времени редактирования продукта, время редактирования и информация о редакторе будут отображаться под изображением в списке продуктов',
    展示产品最近销售时间: 'Отображать время последней продажи продукта',
    '产品最近销售时间开启后，产品最近销售时间信息会显示在产品明细列表图片下方':
      'После включения времени последней продажи продукта, информация о времени последней продажи будет отображаться под изображением в списке деталей продукта',
    自动保存form表单: 'Автосохранение формы',
    '自动保存form表单开启后，打开编辑弹窗将会自动保存form表单内容':
      'После включения автосохранения формы, при открытии редактирования всплывающее окно будет автоматически сохранять содержимое формы',
    电商小程序审核: 'Проверка мини-программы электронной коммерции',
    开启后文章分类将不显示:
      'После включения категории статей не будут отображаться',
    双击复制单元格: 'Двойной клик для копирования ячейки',
    '开启后本系统中列表支持双击复制单元格内容，方便快捷复制文案':
      'После включения система будет поддерживать двойной клик для копирования содержимого ячейки в списках, что удобно и быстро для копирования текста',
    tab页新开页面: 'Открывать вкладки на новых страницах',
    '开启后本系统中所有的tab页都会在新页面打开，方便数据对比':
      'После включения все вкладки в системе будут открываться на новых страницах, что удобно для сравнения данных',
    虚拟列表: 'Виртуальный список',
    '开启后本系统详情页明细列表将使用虚拟列表，请谨慎使用':
      'После включения список деталей на странице деталей в системе будет использовать виртуальный список, пожалуйста, используйте с осторожностью',
    此操作会带来不必要的性能开销:
      'Эта операция приведет к ненужным затратам производительности',
    详情列表拖拽排序: 'Сортировка списка деталей перетаскиванием',
    开启后本系统详情页明细列表可以自由拖拽排序:
      'После включения список деталей на странице деталей в системе можно свободно сортировать перетаскиванием',
    其他设置: 'Прочие настройки',
    订单默认渠道: 'Канал заказа по умолчанию',
    设置后订单下单时会自动默认选择当前渠道值:
      'После настройки при размещении заказа автоматически будет выбираться текущее значение канала по умолчанию',
    请搜索默认渠道: 'Пожалуйста, найдите канал по умолчанию',
    '确定要测试吗？': 'Уверены, что хотите протестировать?',
    执行周期: 'Цикл выполнения',
    请选择执行类型: 'Пожалуйста, выберите тип выполнения',
    选择执行时间: 'Выбрать время выполнения',
    电商小程序APPID: 'APPID мини-программы электронной коммерции',
    请输入电商小程序APPID:
      'Пожалуйста, введите APPID мини-программы электронной коммерции',
    电商小程序Secret: 'Secret мини-программы электронной коммерции',
    请输入电商小程序AppSecret:
      'Пожалуйста, введите AppSecret мини-программы электронной коммерции',
    微信配置: 'Настройки WeChat',
    定时任务配置: 'Настройки запланированных задач',
    任务模板详情: 'Детали шаблона задачи',
    任务模板: 'Шаблон задачи',
    纸张大小: 'Размер бумаги',
    请选择纸张大小: 'Пожалуйста, выберите размер бумаги',
    纸张方向: 'Ориентация бумаги',
    请选择纸张方向: 'Пожалуйста, выберите ориентацию бумаги',
    预览: 'Предварительный просмотр',
    普通导出: 'Обычный экспорт',
    普通打印: 'Обычная печать',
    输出PDF: 'Вывод в PDF',
    打印机打印: 'Печать на принтере',
    预览模板: 'Предварительный просмотр шаблона',
    '此内容依赖于：产品》产品分类，您可以勾选你需要展示的分类，勾选后分类将出现在分类中。':
      'Это содержимое зависит от: Продукт》Классификация продуктов, вы можете выбрать нужные вам категории для отображения, после выбора категории появятся в классификации.',
    '此内容依赖于：产品》产品分类，您可以勾选你需要展示的分类，勾选后分类将出现在首页(PC端)导航栏中。':
      'Это содержимое зависит от: Продукт》Классификация продуктов, вы можете выбрать нужные вам категории для отображения, после выбора категории появятся в навигационной панели главной страницы (ПК).',
    授权时间: 'Время авторизации',
    授权企业: 'Авторизованное предприятие',
    '您确定要对当前数据取消授权？':
      'Вы уверены, что хотите отменить авторизацию текущих данных?',
    // TODO: 2025-12-01
    "OEM信息": "Информация об OEM",
    "谷歌搜图": "Поиск изображений Google",
    "待完善、不售卖产品": "Незавершенный продукт, не продается",
    "新产品": "Новый продукт",
    "图片地址": "Адрес изображения",
    "应用": "Приложение",
    "图纸信息": "Информация о чертежах",
    "适配车型": "Совместимые модели автомобилей",
    "版本": "Версия",
    "指导价": "Рекомендованная цена",
    "位置编号": "Номер позиции",
    "使用年份": "Год использования",
    "图纸": "Чертежи",
    "型号": "Модель",
    "发动机": "Двигатель",
    "市场/地区": "Рынок/регион",
    "部件图": "Диаграмма компонентов",
    "部件信息": "Информация о компонентах",
    "适用品牌": "Применимые бренды",
    "部件编码": "Код компонента",
    "回本周期": "Период окупаемости",
    "无法估算": "Невозможно оценить",
    "回本日": "День окупаемости",
    "税费": "Налоги и сборы",
    "评价": "Отзыв",
    "海关编码": "Таможенный код",
    "新旧类型": "Тип нового/старого",
    "订单评价": "Отзыв о заказе",
    "订单预审": "Предварительный просмотр заказа",
    "是否施工": "Строительство или нет",
    "原厂零售价": "Розничная цена от завода-изготовителя",
    "请选择新旧类型": "Выберите тип нового/старого",
    "请输入海关编码": "Введите таможенный код",
    "google搜索OEM码": "Поиск кода OEM в Google",
    "预计完工": "Ожидаемое завершение",
    "请选择预计完成时间": "Выберите предполагаемое время завершения",
    "请输入箱规毛重": "Введите брутто вес упаковки",
    "产品报价": "Цена продукта",
    "请输入产品报价": "Введите цену продукта",
    "产品推介渠道": "Канал продвижения продукта",
    "其他信息": "Другая информация",
    "账期备注": "Примечание к сроку оплаты",
    "图片视频": "Изображения и видео",
    "线索类型": "Тип лида",
    "图像": "Изображение",
    "支持排序": "Поддержка сортировки",
    "按照产品已有价格": "По уже имеющейся цене продукта",
    "优先使用": "Приоритетное использование",
    "零售价": "Розничная цена",
    "项目分类": "Классификация проекта",
    "请搜索/选择项目分类": "Поиск/выбор классификации проекта",
    "请输入服务商名称": "Введите название сервис-провайдера",
    "跟踪产品": "Отслеживаемый продукт",
    "我方产品": "Наш продукт",
    "请输入我方产品地址": "Введите адрес нашего продукта",
    "竞品产品": "Конкурентный продукт",
    "请输入竞品产品地址": "Введите адрес конкурентного продукта",
    "添加竞品产品地址": "Добавить адрес конкурентного продукта",
    "最低价格": "Минимальная цена",
    "最低跟踪价格": "Минимальная отслеживаемая цена",
    "打标签": "Добавить тег",
    "请搜索/选择新旧类型": "Поиск/выбор типа нового/старого",
    "未销售天数": "Дни без продаж",
    "请输入未销售天数": "Введите дни без продаж",
    "请选择项目分类": "Выберите классификацию проекта",
    "超时": "Тайм-аут",
    "到期": "Срок истек",
    "个月": "месяцев",
    "标签明细": "Подробности тега",
    "关联信息ID": "ID связанной информации",
    "暂为匹配到当前关联信息": "Временно не соответствует текущей связанной информации",
    "查看明细": "Просмотр деталей",
    "占用数量": "Занятое количество",
    "已购产品": "Купленные продукты",
    "未购产品": "Некупленные продукты",
    "购买产品车型明细": "Детали моделей автомобилей купленных продуктов",
    "上次采购价格": "Цена последней закупки",
    "上次采购数量": "Количество последней закупки",
    "上次采购订单": "Заказ последней закупки",
    "客户成长性": "Рост клиента",
    "采购频率": "Частота закупок",
    "每笔订单平均间隔": "Средний интервал между заказами",
    "以产品品牌分类的产品分布情况": "Распределение продуктов по брендам",
    "以产品一级分类的产品分布情况": "Распределение продуктов по первичной классификации",
    "二级分类": "Вторичная классификация",
    "以产品二级分类的产品分布情况": "Распределение продуктов по вторичной классификации",
    "以产品车型分类的产品分布情况": "Распределение продуктов по моделям автомобилей",
    "以产品部件分类的产品分布情况": "Распределение продуктов по компонентам",
    "季": "квартал",
    "至": "до",
    "暂无关联数据！": "Нет связанных данных!",
    "项目类型": "Тип проекта",
    "利润金额": "Сумма прибыли",
    "订单利润": "Прибыль от заказа",
    "客户推荐": "Рекомендация клиента",
    "图文标题": "Заголовок графики и текста",
    "请输入图文标题": "Введите заголовок графики и текста",
    "最低售价/成本/原厂零售价": "Минимальная цена продажи/себестоимость/розничная цена от завода",
    "预计完成时间": "Ожидаемое время завершения",
    "请先填写OEM编码": "Сначала заполните код OEM",
    "我方售价": "Наша цена продажи",
    "竞品售价": "Цена продажи конкурента",
    "天销售少于": "Дней продаж менее",
    "创建时间大于": "Время создания больше чем",
    "天，按去库存周期由大到小排列": "дней, упорядоченных по периоду списания запасов от большего к меньшему",
    "天订单": "Заказ за дней",
    "天客户": "Клиент за дней",
    "去库存": "Списание запасов",
    "您确定要批量出库？": "Вы уверены, что хотите массовое списание?",
    "已审现金": "Проверенные наличные",
    "已审挂账": "Проверенные долги",
    "作废订单": "Аннулированные заказы",
    "拥有成员": "Участники",
    "关联父级信息": "Связанная родительская информация",
    "产品信息中的箱规尺寸": "Размеры упаковки в информации о продукте",
    "产品信息中的箱规中的重量": "Вес в упаковке в информации о продукте",
    "上次跟进内容": "Содержание последнего отслеживания",
    "上次跟进附件": "Вложения последнего отслеживания",
    "上次跟进位置": "Местоположение последнего отслеживания",
    "上次跟进时间": "Время последнего отслеживания"
  },
}
